import { Link, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Accordion, Tab, Nav } from "react-bootstrap";
import ContactForm from "./ContactForm";
import FaqData from "./FaqData";
import { isDesktop } from "react-device-detect";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { s3_img_url } from "../../Helper/request";
const CustomerService = () => {
  const metaData = useSelector((state) => state?.persistedReducer?.meta?.meta);
    const faqData = useSelector((state) => state?.persistedReducer?.meta?.faqMeta?.data);
  let { pageType } = useParams();
  const [key, setKey] = useState("our-warranty");
  const [iskey, setIsKey] = useState(false);
  useEffect(() => {
    if (pageType != undefined) {
      setIsKey(true);
    }
  }, [pageType]);

  function handlSelecte(selectedkey) {
    setKey(selectedkey);
    setIsKey(false);
  }
  return (
    <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{metaData?.title ? metaData?.title : "Wedding Day Diamonds"}</title>
                <meta
                    name="description"
                    content={metaData?.description}
                ></meta>
                <meta name="keywords" content={metaData?.keywords}></meta>

                        <script type="application/ld+json" id="faqs">
          {`
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        ${faqData
              .map(
                (item) => `{
              "@type": "Question",
              "name": "${item?.title}",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "${item?.value}"
              }
            }`
              )
              .join(",")}
      ]
    }
  `}
        </script>
            </Helmet>
      <div className="contact-banner customer-services-page">
        <img src={s3_img_url + 'Header_Footer-01.jpg'} alt="Wedding day diamonds" />
        <img
          src={s3_img_url + 'Header_Footer-02.jpg'}
          alt="Wedding day diamonds"
          className="mx-3"
        />
        <img
          src={s3_img_url + 'Header_Footer-03.jpg'}
          alt="Wedding day diamonds"
          className="me-3"
        />
        <img src={s3_img_url + 'Header_Footer-04.jpg'} alt="Wedding day diamonds" />
      </div>
      <div className="page-header">
        <h1 className="page-title text-center">
          WE'RE HERE FOR YOU, EVERY STEP OF THE WAY.
        </h1>
        {/* <p className='page-subtitle text-start'>Schedule a visit and see for yourself why Wedding Day Diamonds <br /> is Minnesota's favorite engagement ring store.</p> */}
      </div>

      <Container fluid className="p-0">
        <div className="customer-service-page">
          <div className="customer-service__wrapper">
            {isDesktop ? (
              <Tab.Container
                defaultActiveKey={key}
                activeKey={
                  iskey == true ? pageType : iskey == false ? key : key
                }
                onSelect={handlSelecte}
              >
                <Row className="m-0">
                  <Col lg={4} className="services-sidebar-block">
                    <div className="services-sidebar-inner">
                      <h2>Customer Service</h2>
                      <Nav variant="" className="flex-column services-sidebar">
                        <Nav.Item>
                          <Nav.Link eventKey="our-warranty">
                            Our Warranty
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="financing">Financing</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="layaways">Layaways</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="appraisals">Appraisals</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="insurance">Insurance</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="trade-ins">Trade Ins</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="returns-exchanges">
                            Returns Exchanges
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="custom-design-faq">
                            Custom Design FAQs
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="repairs">Repairs</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="ring-cleaning">
                            Ring Cleaning
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="engraving">Engraving</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="payment-options">
                            Payment Options
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="referral-program">
                            Referral Program
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="military-discount">
                            Military Discount
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="help">Help</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="shipping">Shipping</Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </div>
                  </Col>
                  <Col lg={8} className="p-0 services-main-block-box">
                    <div className="customer-service-wrappers">
                      <Tab.Content>
                        <Tab.Pane eventKey="our-warranty">
                          <div className="cswrapper">
                            <div
                              className="customerservicecontainer"
                              id="our-warranty"
                            >
                              <a name="our-warranty"></a>
                              <article className="customerservicecontent">
                                <div>
                                  <div className="basic customerService">
                                    <div className="customer-service-page-heading">
                                      <h2>Our Warranty</h2>
                                    </div>
                                    <div className="csContent">
                                    <p><a
                                    className="fancybox"
                                    href="https://d1ixrqw6vq49jv.cloudfront.net/wysiwyg/wdd/customer-service/image-5e4c09d9afcae9.78677400.jpeg"
                                  >
                                    EXCELLENT COVERAGE AND NO FINE PRINT
                                  </a></p>
                                      <p>
                                        If you bought it at Wedding Day
                                        Diamonds, it's guaranteed. It's just
                                        that simple. Even if you lose a diamond
                                        from a ring you purchased from Wedding
                                        Day Diamonds, we will replace it.
                                      </p>
                                      <p>
                                        If you choose to trade in your diamond,
                                        simply find a diamond that retails for
                                        at least $1 more than the current market
                                        value. All{" "}
                                        <a href="#repairs">maintenance</a> is
                                        free forever.
                                      </p>
                                      <p>
                                        The only thing we are unable to
                                        guarantee is that you won't lose your
                                        jewelry. For that you need{" "}
                                        <a href="#insurance">insurance</a>.
                                      </p>
                                    </div>
                                    <div className="csContentGrad">
                                      <p>
                                        <strong>ADDITIONAL INFORMATION</strong>
                                      </p>
                                      <ul>
                                        <li>
                                          No clean and checks, ever. No
                                          inspections required. Most jewelers
                                          will require regular inspections to
                                          keep your warranty valid, but not
                                          Wedding Day Diamonds.
                                        </li>
                                        <li>
                                          You do not pay for our warranty. It
                                          automatically comes with your
                                          purchase.
                                        </li>
                                        <li>
                                          No need to keep a copy of our warranty
                                          for your records; we will never
                                          question it when your ring needs
                                          repairs.
                                        </li>
                                        <li>Warranties are not transferable.</li>
                                        <li>
                                          If you purchased your jewelry at
                                          Wedding Day Jewelers before 2007, or
                                          if you made purchases under our
                                          corporate warranty, please call us at
                                          1-866-740-RING for more information.
                                        </li>
                                      </ul>
                                    </div>
                                    <div
                                      className="csContentGrad mt-5"
                                      id="parfect-ring-promise"
                                    >
                                      <p className="mb-2">
                                        <strong>PERFECT RING PROMISE</strong>
                                      </p>
                                      <p>
                                        If at any time during the first year of
                                        ownership you decide that your engagement ring
                                        isn’t perfect, we will do whatever it
                                        takes to make it perfect, up to and
                                        including a total remake. We’re able to
                                        make this promise because we have an
                                        exclusive Perfect Ring Promise,
                                        unequaled quality control, and most
                                        important, an absolute commitment to our
                                        clients. We are happy to exchange your
                                        engagement ring up to a year from your purchase
                                        date. You are allowed one exchange
                                        within one year. Custom orders ARE
                                        included.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </article>
                            </div>
                          </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="financing">
                          <div className="bluewrapper" id="financing">
                            <a name="financing"></a>
                            <div className="customerservicecontainer">
                              <article className="genericContentBluecs">
                                <div className="basic customerService">
                                  <div className="customer-service-page-heading">
                                    <h2 className="text-start">Financing</h2>
                                  </div>
                                  <div className="csContent text-start">
                                    <div data-banner-el-id="beforeForm">
                                      <h4 className="text-uppercase mb-3">
                                        We Make it Easy to Pay for Your Ring
                                      </h4>
                                      <p className="nopad">
                                        Wedding Day Diamonds offers Special
                                        Financing options with approved credit.
                                      </p>
                                      <a
                                        className="button wdd-button-primary"
                                        href="/financing"
                                      >
                                        Learn more
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </article>
                            </div>
                          </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="layaways">
                          <div className="cswrapper" id="">
                            <a name="layaways"></a>
                            <div className="customerservicecontainer">
                              <article className="customerservicecontent">
                                <div className="basic customerService">
                                  <div className="customer-service-page-heading">
                                    <h2>Layaways</h2>
                                  </div>
                                  <div className="csContent">
                                    <p>
                                      If you need additional time to pay for
                                      your ring before you get down on one knee,
                                      we’re here to help. With the Wedding Day
                                      Diamonds layaway policy, we’ll put your
                                      ring aside, with your name on it, and the
                                      price locked in. Just plan ahead, give
                                      yourself 6 months, and we will accept
                                      payments along the way.
                                    </p>
                                    <ul className="layawaysul">
                                      <li>
                                        We require a minimum deposit of 10% of
                                        the purchase price for layaway.
                                      </li>
                                      <li>
                                        Layaways must be paid in full within 180
                                        days.
                                      </li>
                                      <li>
                                        Each month, 10% of the purchase price is
                                        due.
                                      </li>
                                      <li>No refunds after 60 days.</li>
                                      <li>
                                        If any of these policies are
                                        non-compliant, the layaway will be
                                        cancelled and the money on the account
                                        will become store credit.
                                      </li>
                                    </ul>
                                    <p>
                                      <a
                                        className="button wdd-button-primary"
                                        href="#payment-options"
                                      >
                                        Payment options
                                      </a>
                                    </p>
                                  </div>
                                </div>
                              </article>
                            </div>
                          </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="appraisals">
                          <div className="bluewrapper" id="">
                            <a name="appraisals"></a>
                            <div className="customerservicecontainer">
                              <article className="genericContentBluecs">
                                <div className="basic customerService">
                                  <div className="customer-service-page-heading">
                                    <h2>Appraisals</h2>
                                  </div>
                                  <div className="csContent">
                                    <p>
                                      When you pick up your new engagement ring
                                      from Wedding Day Diamonds, you will
                                      receive “Insurance Replacement
                                      Documentation” free of charge. Please use
                                      this documentation to find an insurance
                                      policy that fits your needs.
                                    </p>
                                    <p>
                                      Although the Wedding Day Diamond warranty
                                      provides free maintenance forever,
                                      including the loss of diamonds, we cannot
                                      cover a completely lost or stolen piece of
                                      jewelry.
                                    </p>
                                    <p>
                                      We will provide FREE Insurance Replacement
                                      Documentation for a lifetime.
                                    </p>
                                    <p>
                                      It is recommended to update this
                                      documentation every 5 years.
                                    </p>
                                    <p>
                                      Call 1-866-740-RING to request an updated
                                      document now.
                                    </p>
                                  </div>
                                </div>
                              </article>
                            </div>
                          </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="insurance">
                          <div className="cswrapper" id="">
                            <div className="customerservicecontainer">
                              <article className="customerservicecontent">
                                <div className="basic customerService">
                                  <div className="customer-service-page-heading">
                                    <h2>Insurance</h2>
                                  </div>
                                  <div className="csContent">
                                    <div className="insuranceb text-start">
                                      <div className="img-box me-5">
                                        <img className="img-fluid mb-3" width={200}
                                          src={s3_img_url + 'insurance.jpg'}
                                          alt="Perfect Circle"
                                        />
                                      </div>
                                      <p>
                                        {/* Life is unpredictable. And in the event
                                        you lose your entire piece of jewelry,
                                        insurance is the way to have it
                                        replaced. Wedding Day Diamonds will
                                        guarantee that from the moment you put
                                        yourring on your finger, we will make
                                        sure it looks fabulous. But, make sure
                                        you are covered by insurance for those
                                        unpredictable moments in life.
                                        <br />
                                        <br />
                                        Take our word for it, Perfect Circle™
                                        jewelry insurance is the insurance you
                                        want for your beautiful new ring. With
                                        99 years of experience, Perfect Circle
                                        is renowned for their comprehensive
                                        coverage.
                                        <br />
                                        <br />
                                        We invite you to check them out for
                                        yourselves, and get a quote instantly. */}
                                        Life is unpredictable. And in the event you lose your entire piece of jewelry, insurance is the way to have it replaced. Wedding Day Diamonds will guarantee that from the moment you put your ring on your finger, we will make sure it looks fabulous. But, make sure you are covered by insurance for those unpredictable moments in life. <br /><br />

                                        Take our word for it, BriteCo. jewelry insurance is the insurance you want for your beautiful new ring. They make jewelry insurance faster, easier and more affordable wherever, whenever you choose. With exceptional coverage up to 125% of the appraised value, no deductibles and monthly pay options, they are our preferred jewelry insurance choice. <br /><br />

                                        We invite you to <a className="text-decoration-underline" href="https://brite.co/?ref=wdd&utm_source=wdd&utm_medium=lp&utm_campaign=cspage" rel="noreferrer" target="_blank">check them out</a> for yourselves, and get a quote instantly.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </article>
                            </div>
                          </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="trade-ins">
                          <div className="bluewrapper" id="">
                            <a name="trade-ins"></a>
                            <div className="customerservicecontainer">
                              <article className="genericContentBluecs">
                                <div className="basic customerService">
                                  <div className="customer-service-page-heading">
                                    <h2>Our Amazing Trade-in Policy</h2>
                                  </div>
                                  <div className="csContent">
                                    <p>
                                      Wedding Day Diamonds is here to help
                                      should you choose to trade your Wedding
                                      Day diamond for something new and
                                      different. Your spectacular new diamond
                                      will be just as special as that first
                                      stunning diamond you purchased.
                                    </p>
                                    <p>
                                      If you choose to trade in your diamond,
                                      simply find a diamond that retails for at
                                      least $1 more than the current market
                                      value.
                                    </p>
                                    <p>
                                      This trade-in policy applies to all loose
                                      diamonds.
                                    </p>
                                    <p>
                                      If you have any questions regarding your
                                      warranty or trade in, please contact us at{" "}
                                      <a href="mailto:info@wddco.com">
                                        info@wddco.com
                                      </a>
                                    </p>
                                  </div>
                                </div>
                              </article>
                            </div>
                          </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="returns-exchanges">
                          <div className="cswrapper" id="">
                            <a name="returns-exchanges"></a>
                            <div className="customerservicecontainer">
                              <article className="customerservicecontent">
                                <div className="basic customerService">
                                  <div className="customer-service-page-heading">
                                    <h2>Returns/Exchanges</h2>
                                  </div>
                                  <div className="csContent">
                                    <h3 className="text-uppercase mb-3">Return Policy</h3>
                                    <p className="special">
                                      All jewelry has a 60-day return policy
                                      from the date of purchase.
                                    </p>
                                    <h3 className="text-uppercase mb-3">Exchange Policy</h3>
                                    <h4>Semi Mounts</h4>
                                    <p>
                                      You may exchange all semi mounts once
                                      within 365 days from the date of purchase.
                                    </p>
                                    <h4 className="text-uppercase mb-3">Diamond Fashion Hoops</h4>
                                    <p>
                                      If you damage or lose a diamond fashion
                                      hoop within 365 days from the date of
                                      purchase, we will replace it once free of
                                      charge. You must still have the other
                                      earring within your possession. (For more
                                      information, please call 1-866-740-RING)
                                    </p>
                                    <h4 className="text-uppercase mb-3">Men's Wedding Bands</h4>
                                    <p>
                                      For a fee of $75, you may exchange your
                                      wedding band for the identical style due
                                      to damage or size. In most cases, your
                                      wedding band will be repaired in house
                                      without having to replace it. However,
                                      Wedding Day Diamonds will determine if the
                                      work cannot be done by our in house
                                      goldsmiths. All exchanges must be approved
                                      by the store manager. <br />
                                      *If you own a men’s wedding band made by
                                      Jeff Cooper, please call 1-866-740-RING
                                      for more information.
                                    </p>
                                    <h4 className="text-uppercase mb-3">Loose Diamonds</h4>
                                    <p>
                                      You may trade in your Wedding Day diamond
                                      for a more expensive one at any time. You
                                      will get the current market value for your
                                      diamond and you must exchange it for a
                                      diamond that is at least $1 over that
                                      amount. <br />
                                      See{" "}
                                      <a href="#trade-ins">
                                        Trade-In Policy
                                      </a>{" "}
                                      above.
                                    </p>
                                    <p className="special">
                                      If you purchased your diamond before 2004,
                                      please call 1-866-740-RING.
                                    </p>
                                    <h3 className="text-uppercase mb-3">Online Returns and Exchanges</h3>
                                    <p className="special">
                                      Our in-store return and exchange policies
                                      apply directly to online purchases as
                                      well. All purchases made online can be
                                      returned or exchanged via mail or in
                                      store. If you chose to stop into one of
                                      our stores, a sales associate will walk
                                      you through the entire process from start
                                      to finish.
                                    </p>
                                    <ul>
                                      <li>
                                        <a
                                          href="https://d1ixrqw6vq49jv.cloudfront.net/wysiwyg/custom-service-pdf/return-exchange-form-updated-10-16-20.pdf"
                                          target="_blank"
                                        >
                                          Download return form (pdf)
                                        </a>
                                      </li>
                                    </ul>
                                    <h4 className="text-uppercase mb-3">If you choose to mail your return:</h4>
                                    <ul>
                                      <li>
                                        Please make sure all original contents,
                                        packaging and paper work are included in
                                        your shipment. This includes but is not
                                        limited to:
                                        <ul>
                                          <li>Purchased Jewelry</li>
                                          <li>Receipts</li>
                                          <li>Ring Boxes</li>
                                          <li>Diamond Certifications</li>
                                          <li>
                                            Insurance Replacement Documentation
                                          </li>
                                        </ul>
                                      </li>
                                      <li>
                                        Any package that is missing original
                                        contents may be refused.
                                      </li>
                                      <li>
                                        Wedding Day Diamonds is not responsible
                                        for damage that occurs during shipping.
                                        We reserve the right to refuse a return
                                        if the items are damaged upon arrival.
                                      </li>
                                    </ul>
                                    <h4 className="text-uppercase mb-3">
                                      If you need to exchange an item via mail:
                                    </h4>
                                    <ul>
                                      <li>
                                        Wedding Day Diamonds will process your
                                        exchange within 2 business days from the
                                        date of receiving your package. A
                                        customer service representative will
                                        call you with further information
                                        regarding any exchanges that need to be
                                        made. This is to ensure the accuracy of
                                        your order and offer more information in
                                        regards to time frame and shipping
                                        details.
                                      </li>
                                    </ul>
                                    <h4 className="text-uppercase mb-3">
                                      Average timeframe for online orders:
                                    </h4>
                                    <p className="special text-uppercase">Engagement Rings</p>
                                    <ul>
                                      <li>
                                        Most engagement rings will ship within 3
                                        weeks of the purchase date. Some may
                                        take longer based on inventory, designer
                                        or custom work. Please call us for more
                                        information.
                                      </li>
                                    </ul>
                                    <p className="special text-uppercase">Wedding Bands</p>
                                    <ul>
                                      <li>
                                        Most wedding bands will ship within 3
                                        weeks of the purchase date. Some may
                                        take longer based on inventory, designer
                                        or custom work. Please call us for more
                                        information.
                                      </li>
                                    </ul>
                                    <p className="special text-uppercase">Fashion Jewelry</p>
                                    <ul>
                                      <li>
                                        Most fashion jewelry will ship within 48
                                        hours of the purchase date. Some may
                                        take longer based on inventory, designer
                                        or custom work. Please call us for more
                                        information.
                                      </li>
                                    </ul>
                                    <h4 className="text-uppercase mb-3">Domestic Shipping</h4>
                                    <p>
                                      All orders are shipped FREE Delivery.
                                    </p>
                                    <ul className="noPad">
                                      <li>
                                        All orders under $500: 2-day
                                      </li>
                                      <li>
                                        All orders over $500: Overnight
                                      </li>
                                    </ul>
                                    <h4 className="text-uppercase mb-3">International Shipping</h4>
                                    <p className="polink">
                                      Additional charges may apply. Please call
                                      1-866-740-RING for more information.
                                    </p>
                                  </div>
                                </div>
                              </article>
                            </div>
                          </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="custom-design-faq">
                          <div className="bluewrapper" id="">
                            <a name="custom-design-faq"></a>
                            <div className="customerservicecontainer">
                              <article className="genericContentBluecs">
                                <div className="basic customerService">
                                  <div className="customer-service-page-heading">
                                    <h2>Custom Design FAQs</h2>
                                  </div>
                                  <FaqData />
                                </div>
                              </article>
                            </div>
                          </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="repairs">
                          <div className="cswrapper" id="">
                            <a name="repairs"></a>
                            <div className="customerservicecontainer">
                              <article className="customerservicecontent">
                                <div className="basic customerService">
                                  <div className="customer-service-page-heading">
                                    <h2>Repairs</h2>
                                  </div>
                                  <div className="csContent">
                                    <div>
                                      <p>
                                        All cleaning and repair work is FREE
                                        under our NO FINE PRINT WARRANTY. If you
                                        purchased a piece of jewelry before
                                        2007, please call 1-866-740-RING.
                                      </p>
                                      <h3 className="text-uppercase mb-3">Repair Services</h3>
                                      <div className="d-lg-flex justify-content-lg-between">
                                        <ul className="repairs noPad">
                                          <li>Ring sizing</li>
                                          <li>Rhodium plating</li>
                                          <li>Soldering</li>
                                          <li>Diamond setting</li>
                                        </ul>
                                        <ul className="repairs noPad">
                                          <li>Engraving</li>
                                          <li>Ring removal</li>
                                          <li>Stone tightening</li>
                                          <li>Custom work</li>
                                        </ul>
                                        <ul className="repairs noPad">
                                          <li>Refurbishing and polishing</li>
                                          <li>Chain repair</li>
                                          <li>Plus more</li>
                                        </ul>
                                      </div>
                                      <h3 className="alt mt-5">FAQs</h3>
                                    </div>
                                    <div className="faq">
                                      <Accordion>
                                        <Accordion.Item eventKey="0">
                                          <Accordion.Header>
                                            How long do repairs take?
                                          </Accordion.Header>
                                          <Accordion.Body>
                                            Most repairs take one week to
                                            complete. Your repair will go into a
                                            queue based on the day you drop it
                                            off at one of our stores. If you
                                            need something done quickly, please
                                            give our stores a call or submit an
                                            appointment request above.{" "}
                                          </Accordion.Body>
                                        </Accordion.Item>

                                        <Accordion.Item eventKey="1">
                                          <Accordion.Header>
                                            Do I need to have my jewelry
                                            inspected?
                                          </Accordion.Header>
                                          <Accordion.Body>
                                            Our NO FINE PRINT WARRANTY does NOT
                                            require any inspections. However, it
                                            is recommended to get your jewelry
                                            cleaned and inspected about every 6
                                            months. If there is something that
                                            needs to be done, we will let you
                                            know and make arrangements to have
                                            it repaired.
                                          </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="2">
                                          <Accordion.Header>
                                            What is a clean and check?
                                          </Accordion.Header>
                                          <Accordion.Body>
                                            A clean and check is the process of
                                            inspecting your jewelry. Stop in
                                            anytime and ask for a clean and
                                            check! It’s FREE! A representative
                                            will take a look at your jewelry
                                            under a microscope, check for any
                                            loose stones or other damage that
                                            may need to be addressed. If
                                            everything looks great, we will
                                            professionally clean and steam it
                                            for you while you wait. If there are
                                            repairs needed, we will let you know
                                            and help you get it taken care of.
                                          </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="3">
                                          <Accordion.Header>
                                            My white gold ring is turning
                                            yellow; what do I do?
                                          </Accordion.Header>
                                          <Accordion.Body>
                                            All white gold has a plating called
                                            rhodium on it. It is rhodium that
                                            creates the white metal color on
                                            your ring. Over time, this plating
                                            can wear off. When this occurs,
                                            simply bring in your ring to get
                                            re-rhodium plated and polished. We
                                            recommend doing this no more than
                                            once a year in order to keep the
                                            integrity of your ring for as long
                                            as possible.
                                          </Accordion.Body>
                                        </Accordion.Item>

                                        <Accordion.Item eventKey="4">
                                          <Accordion.Header>
                                            {" "}
                                            Do you take appointments for repair
                                            work?
                                          </Accordion.Header>
                                          <Accordion.Body>
                                            We do our best to accommodate
                                            clients that need repair work done
                                            in a short amount of time. We know
                                            that some clients live out of town
                                            and need work done on the spot. If
                                            you need an appointment, please call
                                            one of our stores submit an
                                            appointment request above and we
                                            will do our best to make it as
                                            convenient as possible for you.
                                          </Accordion.Body>
                                        </Accordion.Item>

                                        <Accordion.Item eventKey="5">
                                          <Accordion.Header>
                                            {" "}
                                            My diamond fell out; what do I do?
                                          </Accordion.Header>
                                          <Accordion.Body>
                                            If your diamond fell out and you
                                            have possession of it, bring it in
                                            to one of our stores as soon as
                                            possible. We will take a look at
                                            your jewelry and help you get it
                                            reset and/or repaired. If your
                                            diamond fell out and you cannot find
                                            it, please call a store to make an
                                            appointment with the store manager.
                                            Most jewelry that is missing
                                            diamonds must be taken in by a
                                            manager and sent to our corporate
                                            office.
                                          </Accordion.Body>
                                        </Accordion.Item>

                                        <Accordion.Item eventKey="6">
                                          <Accordion.Header>
                                            {" "}
                                            I need my ring cut off; what do I
                                            do?
                                          </Accordion.Header>
                                          <Accordion.Body>
                                            We have goldsmiths at most of our
                                            locations, typically Monday-Friday
                                            from 11am-6pm. Please call
                                            1-866-740-RING for further
                                            assistance. (If it is an emergency,
                                            please contact your local hospital.
                                            We do not have goldsmiths available
                                            in the evenings or weekends.)
                                          </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="7">
                                          <Accordion.Header>
                                            {" "}
                                            My ring has scratches in it; can you
                                            polish it for me?
                                          </Accordion.Header>
                                          <Accordion.Body>
                                            All precious metals scratch over
                                            time and we will definitely help you
                                            polish your ring and remove as many
                                            scratches as we can. However, we
                                            recommend this service no more than
                                            once a year in order to keep the
                                            integrity of your ring for as long
                                            as possible.
                                          </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="8">
                                          <Accordion.Header>
                                            {" "}
                                            Is it true that alternative metal
                                            rings cannot be repaired?
                                          </Accordion.Header>
                                          <Accordion.Body>
                                            In most cases, repair work on
                                            alternative metal rings is not
                                            possible. Due to the nature of
                                            alternative metals, most cannot be
                                            polished, soldered or re-sized. If
                                            your alternative metal ring is
                                            damaged or you need a different
                                            size, please call our stores.{" "}
                                          </Accordion.Body>
                                        </Accordion.Item>

                                        {/* <Accordion.Item eventKey="9">
                                                                                <Accordion.Header>  I need my ring cut off; what do I do?</Accordion.Header>
                                                                                <Accordion.Body>We have goldsmiths at most of our locations, typically Monday-Friday from 11am-6pm. Please call 1-866-740-RING for further assistance or check our
                                                                                    <a href="/repairs">Jewelry Repairs</a> page for on site goldsmith locations. <br />
                                                                                    (If it is an emergency, please contact your local hospital. We do not have goldsmiths available in the evenings or weekends.)
                                                                                </Accordion.Body>
                                                                            </Accordion.Item>

                                                                            <Accordion.Item eventKey="10">
                                                                                <Accordion.Header>  My white gold ring is turning yellow; what do I do?</Accordion.Header>
                                                                                <Accordion.Body>All white gold has a plating called rhodium on it. It is rhodium that creates the white metal color on your ring. Over time, this plating can wear off. When this occurs, simply bring in
                                                                                    your ring to get re-rhodium plated and polished. We recommend doing this no more than once a year in order to keep the integrity of your ring for as long as possible.
                                                                                </Accordion.Body>
                                                                            </Accordion.Item>
                                                                            <Accordion.Item eventKey="11">
                                                                                <Accordion.Header> My ring has scratches in it; can you polish it for me?</Accordion.Header>
                                                                                <Accordion.Body> All precious metals scratch over time and we will definitely help you polish your ring and remove as many scratches as we can. However, we recommend this service no more than once a year
                                                                                    in order to keep the integrity of your ring for as long as possible.
                                                                                </Accordion.Body>
                                                                            </Accordion.Item>

                                                                            <Accordion.Item eventKey="12">
                                                                                <Accordion.Header>  Is it true that alternative metal rings cannot be repaired?</Accordion.Header>
                                                                                <Accordion.Body> In most cases, repair work on alternative metal rings is not possible. Due to the nature of alternative metals, most cannot be polished, soldered or re-sized. If your alternative metal
                                                                                    ring is damaged or you need a different size, please click <a href="#returns-exchanges">here</a>.
                                                                                </Accordion.Body>
                                                                            </Accordion.Item> */}
                                      </Accordion>
                                    </div>
                                  </div>
                                </div>
                              </article>
                            </div>
                          </div>
                        </Tab.Pane>

                        <Tab.Pane eventKey="ring-cleaning">
                          <div className="bluewrapper" id="">
                            <a name="payment-options"></a>
                            <div className="customerservicecontainer">
                              <article className="genericContentBluecs">
                                <div id="323" className="basic customerService">
                                  <div className="customer-service-page-heading">
                                    <h2>RING CLEANING</h2>
                                  </div>
                                  <div className="csContent">
                                    <p>
                                      We offer free inspections + ring cleaning
                                      for anyone who stops into our stores. Your
                                      jewelry is meant to be worn so its
                                      inevitable that over time, it will collect
                                      a little dust and dirt.
                                    </p>
                                    <p>
                                      Stop in anytime (no appointment necessary)
                                      and we will take a closer look at your
                                      jewelry, make sure everything is how it
                                      should be and then give it a quick bath in
                                      our ultrasonic cleaner. Finishing it off
                                      with a high pressure steam will make your
                                      jewelry sparkle and shine!
                                    </p>
                                  </div>
                                </div>
                              </article>
                            </div>
                          </div>
                        </Tab.Pane>

                        <Tab.Pane eventKey="engraving">
                          <div className="bluewrapper" id="">
                            <a name="payment-options"></a>
                            <div className="customerservicecontainer">
                              <article className="genericContentBluecs">
                                <div id="323" className="basic customerService">
                                  <div className="customer-service-page-heading">
                                    <h2 className="text-uppercase mb-3">Engraving</h2>
                                  </div>
                                  <div className="csContent">
                                    <p>
                                      For a minimal fee, we can engrave just
                                      about any piece of jewelry. Using
                                      state-of-the-art laser technology, our
                                      master jewelers will engrave your special
                                      message and create a lasting memory.
                                      Options for engraving depends on the space
                                      available and metal type of the jewelry.
                                    </p>
                                  </div>
                                </div>
                              </article>
                            </div>
                          </div>
                        </Tab.Pane>

                        <Tab.Pane eventKey="payment-options">
                          <div className="bluewrapper" id="">
                            <a name="payment-options"></a>
                            <div className="customerservicecontainer">
                              <article className="genericContentBluecs">
                                <div id="323" className="basic customerService">
                                  <div className="customer-service-page-heading">
                                    <h2 className="text-uppercase mb-3">Payment Options</h2>
                                  </div>
                                  <div className="csContent">
                                    <h3 className="text-uppercase mb-3">Layaway</h3>
                                    <p>
                                      No matter where you started your layaway
                                      purchase, feel free to stop into ANY
                                      Wedding Day Diamonds to make a payment. We
                                      accept all major credit cards, cash,
                                      cashier’s checks and personal checks.*
                                    </p>
                                    <br />
                                    *Jewelry paid for with a personal check will
                                    not be available for pick up until 10 days
                                    from the date of deposit.
                                    <p>
                                      For more information on our layaway
                                      program,<Link to="/financing">click here</Link>
                                    </p>
                                    <h3>Financing</h3>
                                    <p>
                                      For more information about our financing
                                      options, <Link to="/financing">click here</Link>
                                    </p>
                                    <h3>Phone Payments</h3>
                                    <p>
                                    We do not accept over the phone payments at this time. However, we are able to send a payment text link through Kenect.
                                    </p>
                                  </div>
                                </div>
                              </article>
                            </div>
                          </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="referral-program">
                          <div className="cswrapper" id="">
                            <a name="referral-program"></a>
                            <div className="customerservicecontainer">
                              <article className="customerservicecontent">
                                <div
                                  id="533"
                                  className="basic customerService referral-program"
                                  data-banner-id="533"
                                >
                                  <div className="customer-service-page-heading">
                                    <h2 className="text-uppercase mb-3">Referral Program</h2>
                                  </div>
                                  <div className="csContent">
                                    <div
                                      data-banner-el-id="additional"
                                      className="mb-3"
                                    >
                                      <p>
                                        Refer a friend to Wedding Day Diamonds
                                        to receive a{" "}
                                        <span className="blue">
                                          $100 gift card
                                        </span>{" "}
                                        towards your next
                                        <br />
                                        purchase{" "}
                                        <span className="plus">PLUS</span> your
                                        friend will receive{" "}
                                        <span className="blue">
                                          $100 off their purchase
                                        </span>{" "}
                                        of $1000 or more.
                                      </p>
                                    </div>
                                    <div className="faq">
                                      <Accordion>
                                        <Accordion.Item eventKey="0">
                                          <Accordion.Header>
                                            How Do I Refer a Friend?
                                          </Accordion.Header>
                                          <Accordion.Body>
                                            Request a referral card from your
                                            Client Advocate or a Store
                                            Representative. Within six months of
                                            your purchase, fill out your
                                            personalized referral card and give
                                            the completed card to your friend to
                                            present at the time of their
                                            purchase.
                                          </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="1">
                                          <Accordion.Header>
                                            How Do I Redeem a Referral Discount?
                                          </Accordion.Header>
                                          <Accordion.Body>
                                            Present your personalized referral
                                            card, given to you by an existing
                                            client of Wedding Day Diamonds, at
                                            the time of purchase. Purchase must
                                            equal $1000 or more before tax.
                                            Limit one discount per client
                                            referred to Wedding Day Diamonds.
                                            Eligible for new clients only.
                                            Cannot be redeemed for cash. Wedding
                                            Day Diamonds is not responsible for
                                            lost or stolen referral cards.
                                          </Accordion.Body>
                                        </Accordion.Item>
                                      </Accordion>
                                    </div>
                                  </div>
                                </div>
                              </article>
                            </div>
                          </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="military-discount">
                          <div className="bluewrapper" id="">
                            <a name="military-discount"></a>
                            <div className="customerservicecontainer">
                              <article className="genericContentBluecs text-start">
                                <div className="basic customerService">
                                  <div className="customer-service-page-heading">
                                    <h2 className="text-uppercase mb-3">
                                      Military and Health Care Appreciation
                                      Discount
                                    </h2>
                                  </div>
                                  <div className="csContent">
                                    <p>
                                      In appreciation of their service, we’re
                                      pleased to offer 10% off engagement rings
                                      and 5% off loose diamonds for active duty,
                                      reservists and veterans of the U.S. Armed
                                      Forces. We are also extending this
                                      discount to all health care workers.
                                      Please see store for details.
                                    </p>
                                  </div>
                                </div>
                              </article>
                            </div>
                          </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="help">
                          <div className="cswrapper" id="">
                            <a name="help"></a>
                            <div className="customerservicecontainer">
                              <article className="customerservicecontent text-start">
                                <div className="basic customerService">
                                  <h3 className="text-uppercase mb-3">
                                    How can we help you?
                                  </h3>
                                  <div className="csContent mt-5">
                                    <p className="polink">
                                      If there are any questions that we haven't
                                      answered, contact us{" "}
                                      <a href="/contact-us">here</a> or call
                                      1-866-740-RING.
                                    </p>
                                  </div>
                                </div>
                              </article>
                            </div>
                          </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="shipping">
                          <div className="cswrapper" id="">
                            <div className="customerservicecontainer">
                              <article className="customerservicecontent text-start">
                                <div className="basic customerService mb-5">
                                  <h3 className="text-uppercase mb-3">
                                  DOMESTIC SHIPPING
                                  </h3>
                                  <div className="csContent mt-3">
                                    <p className="polink">
                                    All orders under $500: FREE 2-day
                                    </p>
                                    <p className="polink">
                                    All orders over $500: FREE Overnight
                                    </p>
                                  </div>
                                </div>
                                <div className="basic customerService">
                                  <h3 className="text-uppercase mb-3">
                                  INTERNATIONAL SHIPPING
                                  </h3>
                                  <div className="csContent mt-3">
                                    <p className="polink">
                                    Additional charges may apply. Please call 1-866-740-RING for more information.
                                    </p>
                                  </div>
                                </div>
                              </article>
                            </div>
                          </div>
                        </Tab.Pane>
                      </Tab.Content>
                    </div>
                  </Col>
                </Row>
              </Tab.Container>
            ) : (
              <div className="customer-service-wrappers customer-service-mobile-accordian">
                <Accordion
                  defaultActiveKey={key}
                  activeKey={
                    iskey == true ? pageType : iskey == false ? key : key
                  }
                  onSelect={handlSelecte}
                  flush
                >
                  <Accordion.Item eventKey="our-warranty">
                    <Accordion.Header>Our Warranty</Accordion.Header>
                    <Accordion.Body>
                      <div className="cswrapper">
                        <div
                          className="customerservicecontainer"
                          id="our-warranty"
                        >
                          <a name="our-warranty"></a>
                          <article className="customerservicecontent">
                            <div>
                              <div className="basic customerService">
                                {/* <div className="customer-service-page-heading">
                                                                        <h2>Our Warranty</h2>
                                                                    </div> */}
                                <div className="csContent">
                                  <p><a
                                    className="fancybox"
                                    href="https://d1ixrqw6vq49jv.cloudfront.net/wysiwyg/wdd/customer-service/image-5e4c09d9afcae9.78677400.jpeg"
                                  >
                                    EXCELLENT COVERAGE AND NO FINE PRINT
                                  </a></p>
                                  <p>
                                    If you bought it at Wedding Day Diamonds,
                                    it's guaranteed. It's just that simple. Even
                                    if you lose a diamond from a ring you
                                    purchased from Wedding Day Diamonds, we will
                                    replace it.
                                  </p>
                                  <p>
                                    If you choose to trade in your diamond,
                                    simply find a diamond that retails for at
                                    least $1 more than the current market value.
                                    All <a href="#repairs">maintenance</a> is
                                    free forever.
                                  </p>
                                  <p>
                                    The only thing we are unable to guarantee is
                                    that you won't lose your jewelry. For that
                                    you need <a href="#insurance">insurance</a>.
                                  </p>
                                </div>
                                <div className="csContentGrad">
                                  <p>
                                    <strong>ADDITIONAL INFORMATION</strong>
                                  </p>
                                  <ul>
                                    <li>
                                      No clean and checks, ever. No inspections
                                      required. Most jewelers will require
                                      regular inspections to keep your warranty
                                      valid, but not Wedding Day Diamonds.
                                    </li>
                                    <li>
                                      You do not pay for our warranty. It
                                      automatically comes with your purchase.
                                    </li>
                                    <li>
                                      No need to keep a copy of our warranty for
                                      your records; we will never question it
                                      when your ring needs repairs.
                                    </li>
                                    <li>Warranties are not transferable.</li>
                                    <li>
                                      If you purchased your jewelry at Wedding
                                      Day Jewelers before 2007, or if you made
                                      purchases under our corporate warranty,
                                      please call us at 1-866-740-RING for more
                                      information.
                                    </li>
                                  </ul>
                                </div>
                                <div
                                  className="csContentGrad mt-5"
                                  id="parfect-ring-promise"
                                >
                                  <p className="mb-2">
                                    <strong>PERFECT RING PROMISE</strong>
                                  </p>
                                  <p>
                                    If at any time during the first year of
                                    ownership you decide that your ring isn’t
                                    perfect, we will do whatever it takes to
                                    make it perfect, up to and including a total
                                    remake. We’re able to make this promise
                                    because we have an exclusive Perfect Ring
                                    Promise, unequaled quality control, and most
                                    important, an absolute commitment to our
                                    clients. We are happy to exchange your ring
                                    up to a year from your purchase date. You
                                    are allowed one exchange within one year.
                                    Custom orders ARE included.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="financing">
                    <Accordion.Header>Financing</Accordion.Header>
                    <Accordion.Body>
                      <div className="bluewrapper" id="financing">
                        <a name="financing"></a>
                        <div className="customerservicecontainer">
                          <article className="genericContentBluecs">
                            <div className="basic customerService">
                              {/* <div className="customer-service-page-heading">
                                                                    <h2 className='text-start'>Financing</h2>
                                                                </div> */}
                              <div className="csContent text-start">
                                <div data-banner-el-id="beforeForm">
                                  <h4>We Make it Easy to Pay for Your Ring</h4>
                                  <p className="nopad">
                                    Wedding Day Diamonds offers Special
                                    Financing options with approved credit.
                                  </p>
                                  <a
                                    className="button wdd-button-primary"
                                    href="/financing"
                                  >
                                    Learn more
                                  </a>
                                </div>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="layaways">
                    <Accordion.Header>Layaways</Accordion.Header>
                    <Accordion.Body>
                      <div className="cswrapper" id="">
                        <a name="layaways"></a>
                        <div className="customerservicecontainer">
                          <article className="customerservicecontent">
                            <div className="basic customerService">
                              {/* <div className="customer-service-page-heading">
                                                                    <h2>Layaways</h2>
                                                                </div> */}
                              <div className="csContent">
                                <p>
                                  If you need additional time to pay for your
                                  ring before you get down on one knee, we’re
                                  here to help. With the Wedding Day Diamonds
                                  layaway policy, we’ll put your ring aside,
                                  with your name on it, and the price locked in.
                                  Just plan ahead, give yourself 6 months, and
                                  we will accept payments along the way.
                                </p>
                                <ul className="layawaysul">
                                  <li>
                                    We require a minimum deposit of 10% of the
                                    purchase price for layaway.
                                  </li>
                                  <li>
                                    Layaways must be paid in full within 180
                                    days.
                                  </li>
                                  <li>
                                    Each month, 10% of the purchase price is
                                    due.
                                  </li>
                                  <li>No refunds after 60 days.</li>
                                  <li>
                                    If any of these policies are non-compliant,
                                    the layaway will be cancelled and the money
                                    on the account will become store credit.
                                  </li>
                                </ul>
                                <p>
                                  <a
                                    className="button wdd-button-primary"
                                    href="#payment-options"
                                  >
                                    Payment options
                                  </a>
                                </p>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="appraisals">
                    <Accordion.Header>Appraisals</Accordion.Header>
                    <Accordion.Body>
                      <div className="bluewrapper" id="">
                        <a name="appraisals"></a>
                        <div className="customerservicecontainer">
                          <article className="genericContentBluecs">
                            <div className="basic customerService">
                              {/* <div className="customer-service-page-heading">
                                                                    <h2>Appraisals</h2>
                                                                </div> */}
                              <div className="csContent">
                                <p>
                                  When you pick up your new engagement ring from
                                  Wedding Day Diamonds, you will receive
                                  “Insurance Replacement Documentation” free of
                                  charge. Please use this documentation to find
                                  an insurance policy that fits your needs.
                                </p>
                                <p>
                                  Although the Wedding Day Diamond warranty
                                  provides free maintenance forever, including
                                  the loss of diamonds, we cannot cover a
                                  completely lost or stolen piece of jewelry.
                                </p>
                                <p>
                                  We will provide FREE Insurance Replacement
                                  Documentation for a lifetime.
                                </p>
                                <p>
                                  It is recommended to update this documentation
                                  every 5 years.
                                </p>
                                <p>
                                  Call 1-866-740-RING to request an updated
                                  document now.
                                </p>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="insurance">
                    <Accordion.Header>Insurance</Accordion.Header>
                    <Accordion.Body>
                      <div className="cswrapper" id="">
                        <div className="customerservicecontainer">
                          <article className="customerservicecontent">
                            <div className="basic customerService">
                              {/* <div className="customer-service-page-heading">
                                                                    <h2>Insurance</h2>
                                                                </div> */}
                              <div className="csContent">
                                <div className="insuranceb text-start mb-3">
                                  <div className="img-box me-5">
                                    <img width={200}
                                      src={s3_img_url + 'insurance.jpg'}
                                      alt="Perfect Circle"
                                    />
                                  </div>
                                  <p>
                                    Life is unpredictable. And in the event you lose your entire piece of jewelry, insurance is the way to have it replaced. Wedding Day Diamonds will guarantee that from the moment you put your ring on your finger, we will make sure it looks fabulous. But, make sure you are covered by insurance for those unpredictable moments in life. <br /><br />

                                    Take our word for it, BriteCo. jewelry insurance is the insurance you want for your beautiful new ring. They make jewelry insurance faster, easier and more affordable wherever, whenever you choose. With exceptional coverage up to 125% of the appraised value, no deductibles and monthly pay options, they are our preferred jewelry insurance choice. <br /><br />

                                    We invite you to <a className="text-decoration-underline" href="https://brite.co/?ref=wdd&utm_source=wdd&utm_medium=lp&utm_campaign=cspage" rel="noreferrer" target="_blank">check them out</a> for yourselves, and get a quote instantly.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="trade-ins">
                    <Accordion.Header>Trade Ins</Accordion.Header>
                    <Accordion.Body>
                      <div className="bluewrapper" id="">
                        <a name="trade-ins"></a>
                        <div className="customerservicecontainer">
                          <article className="genericContentBluecs">
                            <div className="basic customerService">
                              {/* <div className="customer-service-page-heading">
                                                                    <h2>Our Amazing Trade-in Policy</h2>
                                                                </div> */}
                              <div className="csContent">
                                <p>
                                  Wedding Day Diamonds is here to help should
                                  you choose to trade your Wedding Day diamond
                                  for something new and different. Your
                                  spectacular new diamond will be just as
                                  special as that first stunning diamond you
                                  purchased.
                                </p>
                                <p>
                                  If you choose to trade in your diamond, simply
                                  find a diamond that retails for at least $1
                                  more than the current market value.
                                </p>
                                <p>
                                  This trade-in policy applies to all loose
                                  diamonds.
                                </p>
                                <p>
                                  If you have any questions regarding your
                                  warranty or trade in, please contact us at{" "}
                                  <a href="mailto:info@wddco.com">
                                    info@wddco.com
                                  </a>
                                </p>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="returns-exchanges">
                    <Accordion.Header>Returns Exchanges</Accordion.Header>
                    <Accordion.Body>
                      <div className="cswrapper" id="">
                        <a name="returns-exchanges"></a>
                        <div className="customerservicecontainer">
                          <article className="customerservicecontent">
                            <div className="basic customerService">
                              {/* <div className="customer-service-page-heading">
                                                                    <h2>Returns/Exchanges</h2>
                                                                </div> */}
                              <div className="csContent">
                                <h3>Return Policy</h3>
                                <p className="special">
                                  All jewelry has a 60-day return policy from
                                  the date of purchase.
                                </p>
                                <h3>Exchange Policy</h3>
                                <h4>Semi Mounts</h4>
                                <p>
                                  You may exchange all semi mounts once within
                                  365 days from the date of purchase.
                                </p>
                                <h4>Diamond Fashion Hoops</h4>
                                <p>
                                  If you damage or lose a diamond fashion hoop
                                  within 365 days from the date of purchase, we
                                  will replace it once free of charge. You must
                                  still have the other earring within your
                                  possession. (For more information, please call
                                  1-866-740-RING)
                                </p>
                                <h4>Men's Wedding Bands</h4>
                                <p>
                                  For a fee of $75, you may exchange your
                                  wedding band for the identical style due to
                                  damage or size. In most cases, your wedding
                                  band will be repaired in house without having
                                  to replace it. However, Wedding Day Diamonds
                                  will determine if the work cannot be done by
                                  our in house goldsmiths. All exchanges must be
                                  approved by the store manager. <br />
                                  *If you own a men’s wedding band made by Jeff
                                  Cooper, please call 1-866-740-RING for more
                                  information.
                                </p>
                                <h4>Loose Diamonds</h4>
                                <p>
                                  You may trade in your Wedding Day diamond for
                                  a more expensive one at any time. You will get
                                  the current market value for your diamond and
                                  you must exchange it for a diamond that is at
                                  least $1 over that amount. <br />
                                  See <a href="#trade-ins">
                                    Trade-In Policy
                                  </a>{" "}
                                  above.
                                </p>
                                <p className="special">
                                  If you purchased your diamond before 2004,
                                  please call 1-866-740-RING.
                                </p>
                                <h3>Online Returns and Exchanges</h3>
                                <p className="special">
                                  Our in-store return and exchange policies
                                  apply directly to online purchases as well.
                                  All purchases made online can be returned or
                                  exchanged via mail or in store. If you chose
                                  to stop into one of our stores, a sales
                                  associate will walk you through the entire
                                  process from start to finish.
                                </p>
                                <ul>
                                  <li>
                                    <a
                                      href="https://d1ixrqw6vq49jv.cloudfront.net/wysiwyg/custom-service-pdf/return-exchange-form-updated-10-16-20.pdf"
                                      target="_blank"
                                    >
                                      Download return form (pdf)
                                    </a>
                                  </li>
                                </ul>
                                <h4>If you choose to mail your return:</h4>
                                <ul>
                                  <li>
                                    Please make sure all original contents,
                                    packaging and paper work are included in
                                    your shipment. This includes but is not
                                    limited to:
                                    <ul>
                                      <li>Purchased Jewelry</li>
                                      <li>Receipts</li>
                                      <li>Ring Boxes</li>
                                      <li>Diamond Certifications</li>
                                      <li>
                                        Insurance Replacement Documentation
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    Any package that is missing original
                                    contents may be refused.
                                  </li>
                                  <li>
                                    Wedding Day Diamonds is not responsible for
                                    damage that occurs during shipping. We
                                    reserve the right to refuse a return if the
                                    items are damaged upon arrival.
                                  </li>
                                </ul>
                                <h4>
                                  If you need to exchange an item via mail:
                                </h4>
                                <ul>
                                  <li>
                                    Wedding Day Diamonds will process your
                                    exchange within 2 business days from the
                                    date of receiving your package. A customer
                                    service representative will call you with
                                    further information regarding any exchanges
                                    that need to be made. This is to ensure the
                                    accuracy of your order and offer more
                                    information in regards to time frame and
                                    shipping details.
                                  </li>
                                </ul>
                                <h4 className="text-uppercase mb-3">Average timeframe for online orders:</h4>
                                <p className="special text-uppercase mb-3">Engagement Rings</p>
                                <ul>
                                  <li>
                                    Most engagement rings will ship within 3
                                    weeks of the purchase date. Some may take
                                    longer based on inventory, designer or
                                    custom work. Please call us for more
                                    information.
                                  </li>
                                </ul>
                                <p className="special text-uppercase mb-3">Wedding Bands</p>
                                <ul>
                                  <li>
                                    Most wedding bands will ship within 3 weeks
                                    of the purchase date. Some may take longer
                                    based on inventory, designer or custom work.
                                    Please call us for more information.
                                  </li>
                                </ul>
                                <p className="special text-uppercase mb-3">Fashion Jewelry</p>
                                <ul>
                                  <li>
                                    Most fashion jewelry will ship within 48
                                    hours of the purchase date. Some may take
                                    longer based on inventory, designer or
                                    custom work. Please call us for more
                                    information.
                                  </li>
                                </ul>
                                <h4 className="text-uppercase mb-3">Domestic Shipping</h4>
                                <p>
                                  All orders are shipped FREE Delivery.
                                </p>
                                <ul className="noPad">
                                  <li>All orders under $500: 2-day</li>
                                  <li>
                                    All orders over $500: Overnight
                                  </li>
                                </ul>
                                <h4>International Shipping</h4>
                                <p className="polink">
                                  Additional charges may apply. Please call
                                  1-866-740-RING for more information.
                                </p>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="custom-design-faq">
                    <Accordion.Header>Custom Design FAQs</Accordion.Header>
                    <Accordion.Body>
                      <div className="bluewrapper" id="">
                        <a name="custom-design-faq"></a>
                        <div className="customerservicecontainer">
                          <article className="genericContentBluecs">
                            <div className="basic customerService">
                              {/* <div className="customer-service-page-heading">
                                                                                                                <h2>Custom Design FAQs</h2>
                                                                                                            </div> */}
                              <FaqData />
                            </div>
                          </article>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="repairs">
                    <Accordion.Header>Repairs</Accordion.Header>
                    <Accordion.Body>
                      <div className="cswrapper" id="">
                        <a name="repairs"></a>
                        <div className="customerservicecontainer">
                          <article className="customerservicecontent">
                            <div className="basic customerService">
                              {/* <div className="customer-service-page-heading">
                                                                    <h2>Repairs</h2>
                                                                </div> */}
                              <div className="csContent">
                                <div>
                                  <p>
                                    All cleaning and repair work is FREE under
                                    our NO FINE PRINT WARRANTY. If you purchased
                                    a piece of jewelry before 2007, please call
                                    1-866-740-RING.
                                  </p>
                                  <h3>Repair Services</h3>
                                  <div className="d-lg-flex justify-content-lg-between">
                                    <ul className="repairs noPad">
                                      <li>Ring sizing</li>
                                      <li>Rhodium plating</li>
                                      <li>Soldering</li>
                                      <li>Diamond setting</li>
                                    </ul>
                                    <ul className="repairs noPad">
                                      <li>Engraving</li>
                                      <li>Ring removal</li>
                                      <li>Stone tightening</li>
                                      <li>Custom work</li>
                                    </ul>
                                    <ul className="repairs noPad">
                                      <li>Refurbishing and polishing</li>
                                      <li>Chain repair</li>
                                      <li>Plus more</li>
                                    </ul>
                                  </div>
                                  <h3 className="alt mt-5">FAQs</h3>
                                </div>
                                <div className="faq">
                                  <Accordion>
                                    <Accordion.Item eventKey="0">
                                      <Accordion.Header>
                                        How long do repairs take?
                                      </Accordion.Header>
                                      <Accordion.Body>
                                        Most repairs take one week to complete.
                                        Your repair will go into a queue based
                                        on the day you drop it off at one of our
                                        stores. If you need something done
                                        quickly, please give our stores a call
                                        or submit an appointment request above.{" "}
                                      </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="1">
                                      <Accordion.Header>
                                        Do I need to have my jewelry inspected?
                                      </Accordion.Header>
                                      <Accordion.Body>
                                        Our NO FINE PRINT WARRANTY does NOT
                                        require any inspections. However, it is
                                        recommended to get your jewelry cleaned
                                        and inspected about every 6 months. If
                                        there is something that needs to be
                                        done, we will let you know and make
                                        arrangements to have it repaired.
                                      </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="2">
                                      <Accordion.Header>
                                        What is a clean and check?
                                      </Accordion.Header>
                                      <Accordion.Body>
                                        A clean and check is the process of
                                        inspecting your jewelry. Stop in anytime
                                        and ask for a clean and check! It’s
                                        FREE! A representative will take a look
                                        at your jewelry under a microscope,
                                        check for any loose stones or other
                                        damage that may need to be addressed. If
                                        everything looks great, we will
                                        professionally clean and steam it for
                                        you while you wait. If there are repairs
                                        needed, we will let you know and help
                                        you get it taken care of.
                                      </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="3">
                                      <Accordion.Header>
                                        My white gold ring is turning yellow;
                                        what do I do?
                                      </Accordion.Header>
                                      <Accordion.Body>
                                        All white gold has a plating called
                                        rhodium on it. It is rhodium that
                                        creates the white metal color on your
                                        ring. Over time, this plating can wear
                                        off. When this occurs, simply bring in
                                        your ring to get re-rhodium plated and
                                        polished. We recommend doing this no
                                        more than once a year in order to keep
                                        the integrity of your ring for as long
                                        as possible.
                                      </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="4">
                                      <Accordion.Header>
                                        {" "}
                                        Do you take appointments for repair
                                        work?
                                      </Accordion.Header>
                                      <Accordion.Body>
                                        We do our best to accommodate clients
                                        that need repair work done in a short
                                        amount of time. We know that some
                                        clients live out of town and need work
                                        done on the spot. If you need an
                                        appointment, please call one of our
                                        stores submit an appointment request
                                        above and we will do our best to make it
                                        as convenient as possible for you.
                                      </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="5">
                                      <Accordion.Header>
                                        {" "}
                                        My diamond fell out; what do I do?
                                      </Accordion.Header>
                                      <Accordion.Body>
                                        If your diamond fell out and you have
                                        possession of it, bring it in to one of
                                        our stores as soon as possible. We will
                                        take a look at your jewelry and help you
                                        get it reset and/or repaired. If your
                                        diamond fell out and you cannot find it,
                                        please call a store to make an
                                        appointment with the store manager. Most
                                        jewelry that is missing diamonds must be
                                        taken in by a manager and sent to our
                                        corporate office.
                                      </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="6">
                                      <Accordion.Header>
                                        {" "}
                                        I need my ring cut off; what do I do?
                                      </Accordion.Header>
                                      <Accordion.Body>
                                        We have goldsmiths at most of our
                                        locations, typically Monday-Friday from
                                        11am-6pm. Please call 1-866-740-RING for
                                        further assistance. (If it is an
                                        emergency, please contact your local
                                        hospital. We do not have goldsmiths
                                        available in the evenings or weekends.)
                                      </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="7">
                                      <Accordion.Header>
                                        {" "}
                                        My ring has scratches in it; can you
                                        polish it for me?
                                      </Accordion.Header>
                                      <Accordion.Body>
                                        All precious metals scratch over time
                                        and we will definitely help you polish
                                        your ring and remove as many scratches
                                        as we can. However, we recommend this
                                        service no more than once a year in
                                        order to keep the integrity of your ring
                                        for as long as possible.
                                      </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="8">
                                      <Accordion.Header>
                                        {" "}
                                        Is it true that alternative metal rings
                                        cannot be repaired?
                                      </Accordion.Header>
                                      <Accordion.Body>
                                        In most cases, repair work on
                                        alternative metal rings is not possible.
                                        Due to the nature of alternative metals,
                                        most cannot be polished, soldered or
                                        re-sized. If your alternative metal ring
                                        is damaged or you need a different size,
                                        please call our stores.{" "}
                                      </Accordion.Body>
                                    </Accordion.Item>
                                  </Accordion>
                                </div>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="ring-cleaning">
                    <Accordion.Header>Ring Cleaning</Accordion.Header>
                    <Accordion.Body>
                      <div className="bluewrapper" id="">
                        <a name="payment-options"></a>
                        <div className="customerservicecontainer">
                          <article className="genericContentBluecs">
                            <div id="323" className="basic customerService">
                              {/* <div className="customer-service-page-heading">
                                                                    <h2>RING CLEANING</h2>
                                                                </div> */}
                              <div className="csContent">
                                <p>
                                  We offer free inspections + ring cleaning for
                                  anyone who stops into our stores. Your jewelry
                                  is meant to be worn so its inevitable that
                                  over time, it will collect a little dust and
                                  dirt.
                                </p>
                                <p>
                                  Stop in anytime (no appointment necessary) and
                                  we will take a closer look at your jewelry,
                                  make sure everything is how it should be and
                                  then give it a quick bath in our ultrasonic
                                  cleaner. Finishing it off with a high pressure
                                  steam will make your jewelry sparkle and
                                  shine!
                                </p>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="engraving">
                    <Accordion.Header>Engraving</Accordion.Header>
                    <Accordion.Body>
                      <div className="bluewrapper" id="">
                        <a name="payment-options"></a>
                        <div className="customerservicecontainer">
                          <article className="genericContentBluecs">
                            <div id="323" className="basic customerService">
                              {/* <div className="customer-service-page-heading">
                                                                    <h2>Engraving</h2>
                                                                </div> */}
                              <div className="csContent">
                                <p>
                                  For a minimal fee, we can engrave just about
                                  any piece of jewelry. Using state-of-the-art
                                  laser technology, our master jewelers will
                                  engrave your special message and create a
                                  lasting memory. Options for engraving depends
                                  on the space available and metal type of the
                                  jewelry.
                                </p>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="payment-options">
                    <Accordion.Header>Payment Options</Accordion.Header>
                    <Accordion.Body>
                      <div className="bluewrapper" id="">
                        <a name="payment-options"></a>
                        <div className="customerservicecontainer">
                          <article className="genericContentBluecs">
                            <div id="323" className="basic customerService">
                              {/* <div className="customer-service-page-heading">
                                                                    <h2>Payment Options</h2>
                                                                </div> */}
                              <div className="csContent">
                                <h3>Layaway</h3>
                                <p>
                                  No matter where you started your layaway
                                  purchase, feel free to stop into ANY Wedding
                                  Day Diamonds to make a payment. We accept all
                                  major credit cards, cash, cashier’s checks and
                                  personal checks.*
                                </p>
                                <br />
                                *Jewelry paid for with a personal check will not
                                be available for pick up until 10 days from the
                                date of deposit.
                                <p>
                                  For more information on our layaway program,
                                  <Link to="/financing">click here</Link>
                                </p>
                                <h3>Financing</h3>
                                <p>
                                  For more information about our financing
                                  options, <Link to="/financing">click here</Link>
                                </p>
                                <h3>Phone Payments</h3>
                                <p>
                                We do not accept over the phone payments at this time. However, we are able to send a payment text link through Kenect.
                                </p>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="referral-program">
                    <Accordion.Header>Referral Program</Accordion.Header>
                    <Accordion.Body>
                      <div className="cswrapper" id="">
                        <a name="referral-program"></a>
                        <div className="customerservicecontainer">
                          <article className="customerservicecontent">
                            <div
                              id="533"
                              className="basic customerService referral-program"
                              data-banner-id="533"
                            >
                              {/* <div className="customer-service-page-heading">
                                                                    <h2>Referral Program</h2>
                                                                </div> */}
                              <div className="csContent">
                                <div
                                  data-banner-el-id="additional"
                                  className="mb-3"
                                >
                                  <p>
                                    Refer a friend to Wedding Day Diamonds to
                                    receive a{" "}
                                    <span className="blue">$100 gift card</span>{" "}
                                    towards your next
                                    <br />
                                    purchase <span className="plus">
                                      PLUS
                                    </span>{" "}
                                    your friend will receive{" "}
                                    <span className="blue">
                                      $100 off their purchase
                                    </span>{" "}
                                    of $1000 or more.
                                  </p>
                                </div>
                                <div className="faq">
                                  <Accordion>
                                    <Accordion.Item eventKey="0">
                                      <Accordion.Header>
                                        How Do I Refer a Friend?
                                      </Accordion.Header>
                                      <Accordion.Body>
                                        Request a referral card from your Client
                                        Advocate or a Store Representative.
                                        Within six months of your purchase, fill
                                        out your personalized referral card and
                                        give the completed card to your friend
                                        to present at the time of their
                                        purchase.
                                      </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="1">
                                      <Accordion.Header>
                                        How Do I Redeem a Referral Discount?
                                      </Accordion.Header>
                                      <Accordion.Body>
                                        Present your personalized referral card,
                                        given to you by an existing client of
                                        Wedding Day Diamonds, at the time of
                                        purchase. Purchase must equal $1000 or
                                        more before tax. Limit one discount per
                                        client referred to Wedding Day Diamonds.
                                        Eligible for new clients only. Cannot be
                                        redeemed for cash. Wedding Day Diamonds
                                        is not responsible for lost or stolen
                                        referral cards.
                                      </Accordion.Body>
                                    </Accordion.Item>
                                  </Accordion>
                                </div>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="military-discount">
                    <Accordion.Header>Military Discount</Accordion.Header>
                    <Accordion.Body>
                      <div className="bluewrapper" id="">
                        <a name="military-discount"></a>
                        <div className="customerservicecontainer">
                          <article className="genericContentBluecs text-start">
                            <div className="basic customerService mt-3">
                              <div className="customer-service-page-heading">
                                <h2>
                                  Military and Health Care Appreciation Discount
                                </h2>
                              </div>
                              <div className="csContent">
                                <p>
                                  In appreciation of their service, we’re
                                  pleased to offer 10% off engagement rings and
                                  5% off loose diamonds for active duty,
                                  reservists and veterans of the U.S. Armed
                                  Forces. We are also extending this discount to
                                  all health care workers. Please see store for
                                  details.
                                </p>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="help">
                    <Accordion.Header>Help</Accordion.Header>
                    <Accordion.Body>
                      <div className="cswrapper" id="">
                        <a name="help"></a>
                        <div className="customerservicecontainer">
                          <article className="customerservicecontent text-start">
                            <div className="basic customerService">
                              <h3 className="pt-3">How can we help you?</h3>
                              <div className="csContent mt-3">
                                <p className="polink">
                                  If there are any questions that we haven't
                                  answered, contact us{" "}
                                  <a href="/contact-us">here</a> or call
                                  1-866-740-RING.
                                </p>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            )}
          </div>
        </div>
      </Container>

      <Container className="contact_fotm">
        <h2 className="text-center mb-5 theme_color subtitle">CONTACT US</h2>
        <ContactForm />
      </Container>
      <Container>
                  <div className='seo_urlsss'>
                    <ul>
                          <li><a href="https://weddingdaydiamonds.com">https://weddingdaydiamonds.com</a></li>               
                          <li><a href="https://weddingdaydiamonds.com/special">https://weddingdaydiamonds.com/special</a></li>
                          <li><a href="https://weddingdaydiamonds.com/person-appointment">https://weddingdaydiamonds.com/person-appointment</a></li>
                          <li><a href="https://weddingdaydiamonds.com/terms-and-conditions">https://weddingdaydiamonds.com/terms-and-conditions</a></li>
                          <li><a href="https://weddingdaydiamonds.com/privacy-policy">https://weddingdaydiamonds.com/privacy-policy</a></li>
                          <li><a href="https://weddingdaydiamonds.com/contact-us">https://weddingdaydiamonds.com/contact-us</a></li>
                          <li><a href="https://weddingdaydiamonds.com/customer-service">https://weddingdaydiamonds.com/customer-service</a></li>
                          <li><a href="https://weddingdaydiamonds.com/stay-tuned">https://weddingdaydiamonds.com/stay-tuned</a></li>
                          <li><a href="https://weddingdaydiamonds.com/fall-band-event">https://weddingdaydiamonds.com/fall-band-event</a></li>
                          <li><a href="https://weddingdaydiamonds.com/wishlist">https://weddingdaydiamonds.com/wishlist</a></li>
                          <li><a href="https://weddingdaydiamonds.com/book-an-appointment">https://weddingdaydiamonds.com/book-an-appointment</a></li>
                          <li><a href="https://weddingdaydiamonds.com/showroom">https://weddingdaydiamonds.com/showroom</a></li>
                          <li><a href="https://weddingdaydiamonds.com/gallery">https://weddingdaydiamonds.com/gallery</a></li>
                          <li><a href="https://weddingdaydiamonds.com/education">https://weddingdaydiamonds.com/education</a></li>
                          <li><a href="https://weddingdaydiamonds.com/custom-design">https://weddingdaydiamonds.com/custom-design</a></li>
                          <li><a href="https://weddingdaydiamonds.com/person-appointment">https://weddingdaydiamonds.com/person-appointment</a></li>
                          <li><a href="https://weddingdaydiamonds.com/virtual-appointment">https://weddingdaydiamonds.com/virtual-appointment</a></li>
                          <li><a href="https://weddingdaydiamonds.com/free-custom-design">https://weddingdaydiamonds.com/free-custom-design</a></li>
                          <li><a href="https://weddingdaydiamonds.com/our-team">https://weddingdaydiamonds.com/our-team</a></li>
                          <li><a href="https://weddingdaydiamonds.com/our-difference">https://weddingdaydiamonds.com/our-difference</a></li>
                          <li><a href="https://weddingdaydiamonds.com/repairs">https://weddingdaydiamonds.com/repairs</a></li>
                          <li><a href="https://weddingdaydiamonds.com/sell-gold-silver-jewelry">https://weddingdaydiamonds.com/sell-gold-silver-jewelry</a></li>
                          <li><a href="https://weddingdaydiamonds.com/jewelry-guides">https://weddingdaydiamonds.com/jewelry-guides</a></li>
                          <li><a href="https://weddingdaydiamonds.com/engagement-rings-buying-guide">https://weddingdaydiamonds.com/engagement-rings-buying-guide</a></li>
                          <li><a href="https://weddingdaydiamonds.com/fashion-Jewelry-guide">https://weddingdaydiamonds.com/fashion-Jewelry-guide</a></li>
                          <li><a href="https://weddingdaydiamonds.com/lab-Grown-diamond-jewelry-guide">https://weddingdaydiamonds.com/lab-Grown-diamond-jewelry-guide</a></li>
                          <li><a href="https://weddingdaydiamonds.com/necklaces-and-pendants-guide">https://weddingdaydiamonds.com/necklaces-and-pendants-guide</a></li>
                          <li><a href="https://weddingdaydiamonds.com/ultimate-bracelet-guide">https://weddingdaydiamonds.com/ultimate-bracelet-guide</a></li>
                          <li><a href="https://weddingdaydiamonds.com/the-ultimate-guide-to-wedding-bands">https://weddingdaydiamonds.com/the-ultimate-guide-to-wedding-bands</a></li>
                          <li><a href="https://weddingdaydiamonds.com/earring-guide">https://weddingdaydiamonds.com/earring-guide</a></li>
                          <li><a href="https://weddingdaydiamonds.com/fashion-ring-guide">https://weddingdaydiamonds.com/fashion-ring-guide</a></li>
                          <li><a href="https://weddingdaydiamonds.com/gabriel-co">https://weddingdaydiamonds.com/gabriel-co</a></li>
                          <li><a href="https://weddingdaydiamonds.com/ring-promise">https://weddingdaydiamonds.com/ring-promise</a></li>
                          <li><a href="https://weddingdaydiamonds.com/fall-band-event">https://weddingdaydiamonds.com/fall-band-event</a></li>
                          <li><a href="https://weddingdaydiamonds.com/blog">https://weddingdaydiamonds.com/blog</a></li>
                          <li><a href="https://weddingdaydiamonds.com/spring-band-event">https://weddingdaydiamonds.com/spring-band-event</a></li>
                          <li><a href="https://weddingdaydiamonds.com/payment-declined">https://weddingdaydiamonds.com/payment-declined</a></li>
                          <li><a href="https://weddingdaydiamonds.com/financing">https://weddingdaydiamonds.com/financing</a></li>
                          <li><a href="https://weddingdaydiamonds.com/showroom">https://weddingdaydiamonds.com/showroom/</a></li>
                          <li><a href="https://weddingdaydiamonds.com/showroom/Burnsville">https://weddingdaydiamonds.com/showroom/Burnsville</a></li>
                          <li><a href="https://weddingdaydiamonds.com/showroom/Richfield">https://weddingdaydiamonds.com/showroom/Richfield</a></li>
                          <li><a href="https://weddingdaydiamonds.com/showroom/Minnetonka">https://weddingdaydiamonds.com/showroom/Minnetonka</a></li>
                          <li><a href="https://weddingdaydiamonds.com/showroom/Eden%20Prairie">https://weddingdaydiamonds.com/showroom/Eden%20Prairie</a></li>
                          <li><a href="https://weddingdaydiamonds.com/showroom/Maple%20Grove">https://weddingdaydiamonds.com/showroom/Maple%20Grove</a></li>
                          <li><a href="https://weddingdaydiamonds.com/showroom/St.%20Cloud">https://weddingdaydiamonds.com/showroom/St.%20Cloud</a></li>
                          <li><a href="https://weddingdaydiamonds.com/showroom/Woodbury">https://weddingdaydiamonds.com/showroom/Woodbury</a></li>
                          <li><a href="https://weddingdaydiamonds.com/showroom/Roseville">https://weddingdaydiamonds.com/showroom/Roseville</a></li>
                          <li><a href="https://weddingdaydiamonds.com/showroom/Rochester">https://weddingdaydiamonds.com/showroom/Rochester</a></li> 
                          <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Solitaire">https://weddingdaydiamonds.com/productlist/engagement-rings/Solitaire</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Halo">https://weddingdaydiamonds.com/productlist/engagement-rings/Halo</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Hidden%20Accent">https://weddingdaydiamonds.com/productlist/engagement-rings/Hidden Accent</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Side%20stone">https://weddingdaydiamonds.com/productlist/engagement-rings/Side Stone</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Vintage">https://weddingdaydiamonds.com/productlist/engagement-rings/Vintage</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Nature">https://weddingdaydiamonds.com/productlist/engagement-rings/Nature</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Three%20stone">https://weddingdaydiamonds.com/productlist/engagement-rings/Three Stone</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Luxury">https://weddingdaydiamonds.com/productlist/engagement-rings/Luxury</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Modern">https://weddingdaydiamonds.com/productlist/engagement-rings/Modern</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings">https://weddingdaydiamonds.com/productlist/engagement-rings/Shop All</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Round">https://weddingdaydiamonds.com/productlist/engagement-rings/Round</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Oval">https://weddingdaydiamonds.com/productlist/engagement-rings/Oval</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Pear">https://weddingdaydiamonds.com/productlist/engagement-rings/Pear</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Princess">https://weddingdaydiamonds.com/productlist/engagement-rings/Princess</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Radiant">https://weddingdaydiamonds.com/productlist/engagement-rings/Radiant</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Emerald">https://weddingdaydiamonds.com/productlist/engagement-rings/Emerald</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Marquise">https://weddingdaydiamonds.com/productlist/engagement-rings/Marquise</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Cushion">https://weddingdaydiamonds.com/productlist/engagement-rings/Cushion</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/White">https://weddingdaydiamonds.com/productlist/engagement-rings/White Gold</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Yellow">https://weddingdaydiamonds.com/productlist/engagement-rings/Yellow Gold</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Rose">https://weddingdaydiamonds.com/productlist/engagement-rings/Rose Gold</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Platinum">https://weddingdaydiamonds.com/productlist/engagement-rings/Platinum</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/new-arrivals">https://weddingdaydiamonds.com/productlist/engagement-rings/New Style</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/best-sellers">https://weddingdaydiamonds.com/productlist/engagement-rings/best-sellers</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/best-sellers">https://weddingdaydiamonds.com/productlist/engagement-rings/Top Twenty</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Quick-Ship">https://weddingdaydiamonds.com/productlist/engagement-rings/Quick Ship</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Tierra%20Collection">https://weddingdaydiamonds.com/productlist/engagement-rings/Tierra</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/Atia%20Couture">https://weddingdaydiamonds.com/productlist/engagement-rings/Atia%20Couture</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/engagement-rings/The%20Grand%20Collection">https://weddingdaydiamonds.com/productlist/engagement-rings/The Grand</a></li>
                          <li><a href="https://weddingdaydiamonds.com/gabriel-co#/bridal">https://weddingdaydiamonds.com/productlist/engagement-rings/Gabriel & Co</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Diamond">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/diamond</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Curved">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/curved</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Mixed%20Shape">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/mixed-shape</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Eternity">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/eternity</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Stackables">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/stackables</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Plain">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/plain</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/new-arrivals">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/new-styles</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Round">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/round</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Marquise">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/marquise</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Princess">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/princess</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Pear">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/pear</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Emerald">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/emerald</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Oval">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/oval</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/shop-all</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Plain">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/plain</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Tantalum">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/tantalum</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Carved">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/carved</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Diamond">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/diamond</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Alternative">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Alternative</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/LUXE%20Band%20Collection">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/luxe-band-collection</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Nature">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/nature-inspired</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Mixed%20Shape">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Mixed%20Shape</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/Curved">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/curved-bands</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/womens-wedding-bands/best-sellers">https://weddingdaydiamonds.com/productlist/womens-wedding-bands/top-twenty</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/earrings">https://weddingdaydiamonds.com/productlist/earrings</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/earrings/Stud">https://weddingdaydiamonds.com/productlist/earrings/Stud</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/earrings/Gemstone">https://weddingdaydiamonds.com/productlist/earrings/Gemstone</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/earrings/Silver">https://weddingdaydiamonds.com/productlist/earrings/Silver</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/earrings/Plain%20Metal">https://weddingdaydiamonds.com/productlist/earrings/Plain%20Metal</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/earrings/Hoops">https://weddingdaydiamonds.com/productlist/earrings/Hoops</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/earrings/Fashion%20Earrings">https://weddingdaydiamonds.com/productlist/earrings/Fashion%20Earrings</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/necklaces/">https://weddingdaydiamonds.com/productlist/necklaces/</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/necklaces/Solitaire">https://weddingdaydiamonds.com/productlist/necklaces/Solitaire</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/necklaces/Tennis">https://weddingdaydiamonds.com/productlist/necklaces/Tennis</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/necklaces/Fashion">https://weddingdaydiamonds.com/productlist/necklaces/Fashion</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/necklaces/Gemstone">https://weddingdaydiamonds.com/productlist/necklaces/Gemstone</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/necklaces/Silver">https://weddingdaydiamonds.com/productlist/necklaces/Silver</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/bracelets/">https://weddingdaydiamonds.com/productlist/bracelets/</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/bracelets/Plain%20Metal">https://weddingdaydiamonds.com/productlist/bracelets/Plain%20Metal</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/bracelets/Tennis">https://weddingdaydiamonds.com/productlist/bracelets/Tennis</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/bracelets/Fashion">https://weddingdaydiamonds.com/productlist/bracelets/Fashion</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/bracelets/Gemstone">https://weddingdaydiamonds.com/productlist/bracelets/Gemstone</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/bracelets/Silver">https://weddingdaydiamonds.com/productlist/bracelets/Silver</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/fashion-rings/">https://weddingdaydiamonds.com/productlist/fashion-rings/</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/fashion-rings/Stackables">https://weddingdaydiamonds.com/productlist/fashion-rings/Stackables</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/fashion-rings/Diamond">https://weddingdaydiamonds.com/productlist/fashion-rings/Diamond</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/fashion-rings/Fashion">https://weddingdaydiamonds.com/productlist/fashion-rings/Fashion</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/fashion-rings/Gemstone">https://weddingdaydiamonds.com/productlist/fashion-rings/Gemstone</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/fashion-rings/Mixed%20shape">https://weddingdaydiamonds.com/productlist/fashion-rings/Mixed%20shape</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/fine-jewelry/">https://weddingdaydiamonds.com/productlist/fine-jewelry/</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/fine-jewelry/best-sellers">https://weddingdaydiamonds.com/productlist/fine-jewelry/best-sellers</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/fine-jewelry/Gemstone">https://weddingdaydiamonds.com/productlist/fine-jewelry/Gemstone</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/fine-jewelry/Silver">https://weddingdaydiamonds.com/productlist/fine-jewelry/Silver</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/fine-jewelry/Tennis">https://weddingdaydiamonds.com/productlist/fine-jewelry/Tennis</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/fine-jewelry/Mixed%20shape">https://weddingdaydiamonds.com/productlist/fine-jewelry/Mixed%20shape</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/fine-jewelry/gift-500">https://weddingdaydiamonds.com/productlist/fine-jewelry/gift-500</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/fine-jewelry/gift-250">https://weddingdaydiamonds.com/productlist/fine-jewelry/gift-250</a></li>
                          <li><a href="https://weddingdaydiamonds.com/productlist/fine-jewelry/gift-over-2000">https://weddingdaydiamonds.com/productlist/fine-jewelry/gift-over-2000</a></li>
                          <li><a href="https://weddingdaydiamonds.com/customer-service/">https://weddingdaydiamonds.com/customer-service/</a></li>
                          <li><a href="https://weddingdaydiamonds.com/customer-service/ring-cleaning">https://weddingdaydiamonds.com/customer-service/ring-cleaning</a></li>
                          <li><a href="https://weddingdaydiamonds.com/customer-service/engraving">https://weddingdaydiamonds.com/customer-service/engraving</a></li>
                          <li><a href="https://weddingdaydiamonds.com/customer-service/appraisals">https://weddingdaydiamonds.com/customer-service/appraisals</a></li>
                          <li><a href="https://weddingdaydiamonds.com/customer-service/engraving">https://weddingdaydiamonds.com/customer-service/engraving</a></li>
                       
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MAE-TWIST/white-gold-mae-twist-5ct-radiant-center-engagement-rings-lgmtc2468-lg-500-ra">https://weddingdaydiamonds.com/product-detail/ER-TC-MAE-TWIST/white-gold-mae-twist-5ct-radiant-center-engagement-rings-lgmtc2468-lg-500-ra</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-NOUVEAU-BEZEL-SOLITAIRE/nouveau-bezel-solitaire-engagement-rings-lgmtc1596-lg-500-rd">https://weddingdaydiamonds.com/product-detail/ER-NOUVEAU-BEZEL-SOLITAIRE/nouveau-bezel-solitaire-engagement-rings-lgmtc1596-lg-500-rd</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-BROOK-HIDDEN-SOLITAIRE/brook-hidden-solitaire-engagement-rings-lgmtc1447-lg-125-em">https://weddingdaydiamonds.com/product-detail/ER-BROOK-HIDDEN-SOLITAIRE/brook-hidden-solitaire-engagement-rings-lgmtc1447-lg-125-em</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-WEAVE-HIDDEN-SOLITAIRE/weave-hidden-solitaire-engagement-rings-lgmtc1485-lg-100-cu">https://weddingdaydiamonds.com/product-detail/ER-WEAVE-HIDDEN-SOLITAIRE/weave-hidden-solitaire-engagement-rings-lgmtc1485-lg-100-cu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-AUTUMN-VINE-TRES/platinum-autumn-vine-tres-4ct-pear-center-engagement-rings-lgmtc2442-lg-400-pe">https://weddingdaydiamonds.com/product-detail/ER-TC-AUTUMN-VINE-TRES/platinum-autumn-vine-tres-4ct-pear-center-engagement-rings-lgmtc2442-lg-400-pe</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-HAILEY-SOLITAIRE/platinum-hailey-solitaire-3-1-2ct-asscher-center-engagement-rings-lgmtc2489-lg-350-as">https://weddingdaydiamonds.com/product-detail/ER-TC-HAILEY-SOLITAIRE/platinum-hailey-solitaire-3-1-2ct-asscher-center-engagement-rings-lgmtc2489-lg-350-as</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-SKYLER-THREE-STONE/platinum-skyler-three-stone-1-3-4ct-radiant-center-engagement-rings-lgmtc2434-lg-175-ra">https://weddingdaydiamonds.com/product-detail/ER-TC-SKYLER-THREE-STONE/platinum-skyler-three-stone-1-3-4ct-radiant-center-engagement-rings-lgmtc2434-lg-175-ra</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TWIST-THREE-STONE/twist-three-stone-1-3ctw-engagement-rings-lgmtc2360-lg-100-ecu">https://weddingdaydiamonds.com/product-detail/ER-TWIST-THREE-STONE/twist-three-stone-1-3ctw-engagement-rings-lgmtc2360-lg-100-ecu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-COUTURE-TWIST-HIDDEN/rose-gold-couture-twist-hidden-1-3-4ct-cushion-center-engagement-rings-lgmtc2435-lg-175-cu">https://weddingdaydiamonds.com/product-detail/ER-TC-COUTURE-TWIST-HIDDEN/rose-gold-couture-twist-hidden-1-3-4ct-cushion-center-engagement-rings-lgmtc2435-lg-175-cu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-EMBRACE-CLASSIC/platinum-embrace-1-6-ctw-engagement-rings-lgmtc1667-lg-150-pr">https://weddingdaydiamonds.com/product-detail/ER-TC-EMBRACE-CLASSIC/platinum-embrace-1-6-ctw-engagement-rings-lgmtc1667-lg-150-pr</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-ROSALIE-BAGUETTE-ROUND/rosalie-baguette-round-engagement-rings-lgmtc2187-lg-125-as">https://weddingdaydiamonds.com/product-detail/ER-ROSALIE-BAGUETTE-ROUND/rosalie-baguette-round-engagement-rings-lgmtc2187-lg-125-as</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-SPLIT-SOLITAIRE/modern-split-solitaire-engagement-rings-lgmtc1541-lg-250-pr">https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-SPLIT-SOLITAIRE/modern-split-solitaire-engagement-rings-lgmtc1541-lg-250-pr</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-CLASSIC-GALA/classic-gala-engagement-rings-lgmtc1897-lg-250-mq">https://weddingdaydiamonds.com/product-detail/ER-CLASSIC-GALA/classic-gala-engagement-rings-lgmtc1897-lg-250-mq</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-AURORA/luxe-aurora-engagement-rings-lgmtc2069-lg-300-cu">https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-AURORA/luxe-aurora-engagement-rings-lgmtc2069-lg-300-cu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/FR-SIENNA-CNTRD/sienna-contoured-five-prong-1-2ctw-wedding-bands-lgbtc0244-1">https://weddingdaydiamonds.com/product-detail/FR-SIENNA-CNTRD/sienna-contoured-five-prong-1-2ctw-wedding-bands-lgbtc0244-1</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LOTUS-THREE-STONE/platinum-lotus-three-stone-4-1-2ct-princess-center-engagement-rings-lgmtc2450-lg-450-pr">https://weddingdaydiamonds.com/product-detail/ER-TC-LOTUS-THREE-STONE/platinum-lotus-three-stone-4-1-2ct-princess-center-engagement-rings-lgmtc2450-lg-450-pr</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LOTUS-THREE-STONE/platinum-lotus-three-stone-2ct-round-center-engagement-rings-lgmtc2450-lg-200-rd">https://weddingdaydiamonds.com/product-detail/ER-TC-LOTUS-THREE-STONE/platinum-lotus-three-stone-2ct-round-center-engagement-rings-lgmtc2450-lg-200-rd</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ARIELLE-SUN/yellow-gold-arielle-sun-1ct-oval-center-engagement-rings-lgmtc2477-lg-100-ov">https://weddingdaydiamonds.com/product-detail/ER-TC-ARIELLE-SUN/yellow-gold-arielle-sun-1ct-oval-center-engagement-rings-lgmtc2477-lg-100-ov</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-MODERN-DOMED-2.5mm/modern-domed-2-5mm-engagement-rings-lgmtc1553-lg-225-ecu">https://weddingdaydiamonds.com/product-detail/ER-MODERN-DOMED-2.5mm/modern-domed-2-5mm-engagement-rings-lgmtc1553-lg-225-ecu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-SIENNA/rose-gold-sienna-marquise-round-1-3ctw-engagement-rings-lgmtc1756-lg-300-mq">https://weddingdaydiamonds.com/product-detail/ER-TC-SIENNA/rose-gold-sienna-marquise-round-1-3ctw-engagement-rings-lgmtc1756-lg-300-mq</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-BG-RD/platinum-mini-baguette-round-1-4ctw-engagement-rings-lgmtc1711-lg-175-ra">https://weddingdaydiamonds.com/product-detail/ER-TC-BG-RD/platinum-mini-baguette-round-1-4ctw-engagement-rings-lgmtc1711-lg-175-ra</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-GRAND-ELIZABETH/grand-elizabeth-engagement-rings-lgmtc2008-lg-400-ov">https://weddingdaydiamonds.com/product-detail/ER-GRAND-ELIZABETH/grand-elizabeth-engagement-rings-lgmtc2008-lg-400-ov</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-HAZEL-TAPERED/hazel-tapered-4-5ctw-engagement-rings-lgmtc2110-lg-150-em">https://weddingdaydiamonds.com/product-detail/ER-HAZEL-TAPERED/hazel-tapered-4-5ctw-engagement-rings-lgmtc2110-lg-150-em</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-AVA-EMERALD/ava-emerald-engagement-rings-lgmtc2079-lg-350-cu">https://weddingdaydiamonds.com/product-detail/ER-AVA-EMERALD/ava-emerald-engagement-rings-lgmtc2079-lg-350-cu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-COLETTE/colette-1-4ctw-engagement-rings-lgmtc1969-lg-125-mq">https://weddingdaydiamonds.com/product-detail/ER-COLETTE/colette-1-4ctw-engagement-rings-lgmtc1969-lg-125-mq</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LILY-ENTWINE/yellow-gold-lily-entwine-1-3-4ct-pear-center-engagement-rings-lgmtc2484-lg-175-pe">https://weddingdaydiamonds.com/product-detail/ER-TC-LILY-ENTWINE/yellow-gold-lily-entwine-1-3-4ct-pear-center-engagement-rings-lgmtc2484-lg-175-pe</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MAGNOLIA-VINE/rose-gold-magnolia-vine-1-1-4ct-marquise-center-engagement-rings-lgmtc2427-lg-125-mq">https://weddingdaydiamonds.com/product-detail/ER-TC-MAGNOLIA-VINE/rose-gold-magnolia-vine-1-1-4ct-marquise-center-engagement-rings-lgmtc2427-lg-125-mq</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-SIENNA/platinum-mini-sienna-1-5ctw-engagement-rings-lgmtc1755-lg-200-cu">https://weddingdaydiamonds.com/product-detail/ER-TC-SIENNA/platinum-mini-sienna-1-5ctw-engagement-rings-lgmtc1755-lg-200-cu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-BROOK-HIDDEN-SOLITAIRE/brook-hidden-solitaire-engagement-rings-lgmtc1444-lg-100-pe">https://weddingdaydiamonds.com/product-detail/ER-BROOK-HIDDEN-SOLITAIRE/brook-hidden-solitaire-engagement-rings-lgmtc1444-lg-100-pe</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUMIERE/grand-lumiere-hidden-engagement-rings-lgmtc2235-lg-125-mq">https://weddingdaydiamonds.com/product-detail/ER-TC-LUMIERE/grand-lumiere-hidden-engagement-rings-lgmtc2235-lg-125-mq</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-MODERN-2.5mm-SOLITAIRE/modern-2-5mm-solitaire-engagement-rings-lgmtc1547-lg-150-ov">https://weddingdaydiamonds.com/product-detail/ER-MODERN-2.5mm-SOLITAIRE/modern-2-5mm-solitaire-engagement-rings-lgmtc1547-lg-150-ov</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ANTONELLA-PEAR-MQ/rose-gold-antonella-pear-marquise-3-8ctw-engagement-rings-lgmtc1680-lg-225-rd">https://weddingdaydiamonds.com/product-detail/ER-TC-ANTONELLA-PEAR-MQ/rose-gold-antonella-pear-marquise-3-8ctw-engagement-rings-lgmtc1680-lg-225-rd</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-CELINE-1-2/celine-1-2ctw-engagement-rings-lgmtc1885-lg-100-ov">https://weddingdaydiamonds.com/product-detail/ER-CELINE-1-2/celine-1-2ctw-engagement-rings-lgmtc1885-lg-100-ov</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-DELPHINE-SOLITAIRE/delphine-solitaire-engagement-rings-lgmtc1455-lg-350-pe">https://weddingdaydiamonds.com/product-detail/ER-DELPHINE-SOLITAIRE/delphine-solitaire-engagement-rings-lgmtc1455-lg-350-pe</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-HARPER/petite-harper-engagement-rings-lgmtc2100-lg-275-pr">https://weddingdaydiamonds.com/product-detail/ER-HARPER/petite-harper-engagement-rings-lgmtc2100-lg-275-pr</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-PEAR/white-gold-grand-pear-three-stone-1-2ctw-engagement-rings-lgmtc2284-lg-225-ecu">https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-PEAR/white-gold-grand-pear-three-stone-1-2ctw-engagement-rings-lgmtc2284-lg-225-ecu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LINA-MIL/rose-gold-lina-milgrain-3-8ctw-engagement-rings-lgmtc1740-lg-100-em">https://weddingdaydiamonds.com/product-detail/ER-TC-LINA-MIL/rose-gold-lina-milgrain-3-8ctw-engagement-rings-lgmtc1740-lg-100-em</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-PINNACLE/platinum-classic-pinnacle-1-3ctw-engagement-rings-lgmtc1635-lg-125-ov">https://weddingdaydiamonds.com/product-detail/ER-TC-PINNACLE/platinum-classic-pinnacle-1-3ctw-engagement-rings-lgmtc1635-lg-125-ov</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-HAILEY-SOLITAIRE/platinum-hailey-solitaire-1-3-4ct-emerald-center-engagement-rings-lgmtc2489-lg-175-em">https://weddingdaydiamonds.com/product-detail/ER-TC-HAILEY-SOLITAIRE/platinum-hailey-solitaire-1-3-4ct-emerald-center-engagement-rings-lgmtc2489-lg-175-em</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-REMI-KITE-HIDDEN-SOLITAIRE/remi-kite-hidden-solitaire-engagement-rings-lgmtc1429-lg-275-as">https://weddingdaydiamonds.com/product-detail/ER-TC-REMI-KITE-HIDDEN-SOLITAIRE/remi-kite-hidden-solitaire-engagement-rings-lgmtc1429-lg-275-as</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ELIANA-PEAR/platinum-eliana-pear-5-8ctw-engagement-rings-lgmtc1795-lg-150-em">https://weddingdaydiamonds.com/product-detail/ER-TC-ELIANA-PEAR/platinum-eliana-pear-5-8ctw-engagement-rings-lgmtc1795-lg-150-em</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-MODERN-DOMED-2.5mm/modern-domed-2-5mm-engagement-rings-lgmtc1553-lg-350-ecu">https://weddingdaydiamonds.com/product-detail/ER-MODERN-DOMED-2.5mm/modern-domed-2-5mm-engagement-rings-lgmtc1553-lg-350-ecu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-AUTUMN-VINE-TRES/rose-gold-autumn-vine-tres-2-3-4ct-round-center-engagement-rings-lgmtc2439-lg-275-rd">https://weddingdaydiamonds.com/product-detail/ER-TC-AUTUMN-VINE-TRES/rose-gold-autumn-vine-tres-2-3-4ct-round-center-engagement-rings-lgmtc2439-lg-275-rd</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-CAROLINA-5-8/carolina-5-8ctw-engagement-rings-lgmtc1945-lg-150-ra">https://weddingdaydiamonds.com/product-detail/ER-CAROLINA-5-8/carolina-5-8ctw-engagement-rings-lgmtc1945-lg-150-ra</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-CAMILE/platinum-luxury-camille-3-8ctw-engagement-rings-lgmtc1735-lg-125-pe">https://weddingdaydiamonds.com/product-detail/ER-TC-CAMILE/platinum-luxury-camille-3-8ctw-engagement-rings-lgmtc1735-lg-125-pe</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-AIMEE-PEAR-RD/rose-gold-aimee-pear-round-1-4ctw-engagement-rings-lgmtc1672-lg-200-mq">https://weddingdaydiamonds.com/product-detail/ER-TC-AIMEE-PEAR-RD/rose-gold-aimee-pear-round-1-4ctw-engagement-rings-lgmtc1672-lg-200-mq</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-SKYLER-THREE-STONE/platinum-skyler-three-stone-4-1-2ct-pear-center-engagement-rings-lgmtc2434-lg-450-pe">https://weddingdaydiamonds.com/product-detail/ER-TC-SKYLER-THREE-STONE/platinum-skyler-three-stone-4-1-2ct-pear-center-engagement-rings-lgmtc2434-lg-450-pe</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-ATLAS/grand-atlas-9-10ctw-engagement-rings-lgmtc1823-lg-150-ra">https://weddingdaydiamonds.com/product-detail/ER-ATLAS/grand-atlas-9-10ctw-engagement-rings-lgmtc1823-lg-150-ra</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1-3ctw-engagement-rings-lgmtc2369-lg-200-pe">https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1-3ctw-engagement-rings-lgmtc2369-lg-200-pe</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-ELIANA-1-4/eliana-1-4ctw-engagement-rings-lgmtc1423-lg-275-em">https://weddingdaydiamonds.com/product-detail/ER-ELIANA-1-4/eliana-1-4ctw-engagement-rings-lgmtc1423-lg-275-em</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-REIGN-PEAR-&amp;-MARQUISE/reign-pear-and-marquise-engagement-rings-lgmtc1981-lg-350-pe">https://weddingdaydiamonds.com/product-detail/ER-REIGN-PEAR-&amp;-MARQUISE/reign-pear-and-marquise-engagement-rings-lgmtc1981-lg-350-pe</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-CIANA-KITE/ciana-kite-engagement-rings-lgmtc2142-lg-150-pr">https://weddingdaydiamonds.com/product-detail/ER-TC-CIANA-KITE/ciana-kite-engagement-rings-lgmtc2142-lg-150-pr</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-MODERN-DOMED-2.5mm/modern-domed-2-5mm-engagement-rings-lgmtc1553-lg-400-pe">https://weddingdaydiamonds.com/product-detail/ER-MODERN-DOMED-2.5mm/modern-domed-2-5mm-engagement-rings-lgmtc1553-lg-400-pe</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-CLASSIC-BEZEL-SOL/rose-gold-classic-bezel-solitaire-engagement-rings-lgmtc2255-lg-100-ov">https://weddingdaydiamonds.com/product-detail/ER-TC-CLASSIC-BEZEL-SOL/rose-gold-classic-bezel-solitaire-engagement-rings-lgmtc2255-lg-100-ov</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-VINTAGE-CLEMENTINE/vintage-clementine-engagement-rings-lgmtc2177-lg-300-pr">https://weddingdaydiamonds.com/product-detail/ER-TC-VINTAGE-CLEMENTINE/vintage-clementine-engagement-rings-lgmtc2177-lg-300-pr</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-MODERN-DOMED-2.5mm/modern-domed-2-5mm-engagement-rings-lgmtc1554-lg-275-as">https://weddingdaydiamonds.com/product-detail/ER-MODERN-DOMED-2.5mm/modern-domed-2-5mm-engagement-rings-lgmtc1554-lg-275-as</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-BRIELLE-3-4CTW/brielle-3-4ctw-engagement-rings-lgmtc1988-lg-175-rd">https://weddingdaydiamonds.com/product-detail/ER-TC-BRIELLE-3-4CTW/brielle-3-4ctw-engagement-rings-lgmtc1988-lg-175-rd</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-GEMINI-RD-BG/platinum-gemini-round-baguette-1-4ctw-engagement-rings-lgmtc1687-lg-275-cu">https://weddingdaydiamonds.com/product-detail/ER-TC-GEMINI-RD-BG/platinum-gemini-round-baguette-1-4ctw-engagement-rings-lgmtc1687-lg-275-cu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-DEMI/demi-1-5ctw-engagement-rings-lgmtc1748-lg-400-rd">https://weddingdaydiamonds.com/product-detail/ER-TC-DEMI/demi-1-5ctw-engagement-rings-lgmtc1748-lg-400-rd</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-HIDDEN-RIVER/hidden-river-engagement-rings-lgmtc2152-lg-125-em">https://weddingdaydiamonds.com/product-detail/ER-TC-HIDDEN-RIVER/hidden-river-engagement-rings-lgmtc2152-lg-125-em</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-MQ/rose-gold-three-stone-marquise-1-7ctw-engagement-rings-lgmtc2291-lg-300-ecu">https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-MQ/rose-gold-three-stone-marquise-1-7ctw-engagement-rings-lgmtc2291-lg-300-ecu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-SYDNEY-1-1-5/sydney-1-1-5ctw-engagement-rings-lgmtc1929-lg-275-mq">https://weddingdaydiamonds.com/product-detail/ER-SYDNEY-1-1-5/sydney-1-1-5ctw-engagement-rings-lgmtc1929-lg-275-mq</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ELIANA-PEAR/white-gold-grand-eliana-pear-3-4ctw-engagement-rings-lgmtc1797-lg-400-ra">https://weddingdaydiamonds.com/product-detail/ER-TC-ELIANA-PEAR/white-gold-grand-eliana-pear-3-4ctw-engagement-rings-lgmtc1797-lg-400-ra</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-SUMMIT/summit-hidden-engagement-rings-lgmtc1494-lg-125-as">https://weddingdaydiamonds.com/product-detail/ER-TC-SUMMIT/summit-hidden-engagement-rings-lgmtc1494-lg-125-as</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-CAROLINA-5-8/carolina-5-8ctw-engagement-rings-lgmtc1943-lg-250-cu">https://weddingdaydiamonds.com/product-detail/ER-CAROLINA-5-8/carolina-5-8ctw-engagement-rings-lgmtc1943-lg-250-cu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-NEURO-EMERALD/neuro-emerald-engagement-rings-lgmtc2084-lg-100-pe">https://weddingdaydiamonds.com/product-detail/ER-NEURO-EMERALD/neuro-emerald-engagement-rings-lgmtc2084-lg-100-pe</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-REIGN-PEAR-&amp;-MARQUISE/reign-pear-and-marquise-engagement-rings-lgmtc1982-lg-100-rd">https://weddingdaydiamonds.com/product-detail/ER-REIGN-PEAR-&amp;-MARQUISE/reign-pear-and-marquise-engagement-rings-lgmtc1982-lg-100-rd</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MAGNOLIA-VINE/white-gold-magnolia-vine-1-1-2ct-marquise-center-engagement-rings-lgmtc2428-lg-150-mq">https://weddingdaydiamonds.com/product-detail/ER-TC-MAGNOLIA-VINE/white-gold-magnolia-vine-1-1-2ct-marquise-center-engagement-rings-lgmtc2428-lg-150-mq</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-HARPER/classic-harper-engagement-rings-lgmtc2097-lg-225-ra">https://weddingdaydiamonds.com/product-detail/ER-HARPER/classic-harper-engagement-rings-lgmtc2097-lg-225-ra</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-LACEE-1-8/lacee-1-8ctw-engagement-rings-lgmtc2073-lg-100-em">https://weddingdaydiamonds.com/product-detail/ER-LACEE-1-8/lacee-1-8ctw-engagement-rings-lgmtc2073-lg-100-em</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-SOLANA-HIDDEN/solana-hidden-engagement-rings-lgmtc2162-lg-400-rd">https://weddingdaydiamonds.com/product-detail/ER-SOLANA-HIDDEN/solana-hidden-engagement-rings-lgmtc2162-lg-400-rd</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-ALLURE-BEZEL-SOL/allure-hidden-solitaire-engagement-rings-lgmtc1461-lg-225-as">https://weddingdaydiamonds.com/product-detail/ER-ALLURE-BEZEL-SOL/allure-hidden-solitaire-engagement-rings-lgmtc1461-lg-225-as</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-CELTIC/queen-celtic-1-5ctw-engagement-rings-lgmtc1918-lg-275-em">https://weddingdaydiamonds.com/product-detail/ER-CELTIC/queen-celtic-1-5ctw-engagement-rings-lgmtc1918-lg-275-em</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-DOMED-4.5MM/modern-domed-4.5mm-engagement-rings-lgmtc1561-lg-125-ov">https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-DOMED-4.5MM/modern-domed-4.5mm-engagement-rings-lgmtc1561-lg-125-ov</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-CLASSIC-BEZEL-SOL/white-gold-classic-bezel-solitaire-engagement-rings-lgmtc2256-lg-125-mq">https://weddingdaydiamonds.com/product-detail/ER-TC-CLASSIC-BEZEL-SOL/white-gold-classic-bezel-solitaire-engagement-rings-lgmtc2256-lg-125-mq</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-ELIANA-1-4/eliana-1-4ctw-engagement-rings-lgmtc1420-lg-100-em">https://weddingdaydiamonds.com/product-detail/ER-ELIANA-1-4/eliana-1-4ctw-engagement-rings-lgmtc1420-lg-100-em</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-VINTAGE-CLEMENTINE/vintage-clementine-engagement-rings-lgmtc2176-lg-300-pe">https://weddingdaydiamonds.com/product-detail/ER-TC-VINTAGE-CLEMENTINE/vintage-clementine-engagement-rings-lgmtc2176-lg-300-pe</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/NKL-LINEAR-MIXED-DIAMOND-1-2CTW/white-gold-linear-mixed-diamond-necklace-1-2ctw-necklaces-lgwfn0114">https://weddingdaydiamonds.com/product-detail/NKL-LINEAR-MIXED-DIAMOND-1-2CTW/white-gold-linear-mixed-diamond-necklace-1-2ctw-necklaces-lgwfn0114</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1-4ctw-engagement-rings-lgmtc2390-lg-500-ecu">https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1-4ctw-engagement-rings-lgmtc2390-lg-500-ecu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-DELPHINE/classic-delphine-engagement-rings-lgmtc1836-lg-350-em">https://weddingdaydiamonds.com/product-detail/ER-DELPHINE/classic-delphine-engagement-rings-lgmtc1836-lg-350-em</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-MINI-HANNAH-1-5/mini-hannah-1-5ctw-engagement-rings-lgmtc1910-lg-100-ra">https://weddingdaydiamonds.com/product-detail/ER-MINI-HANNAH-1-5/mini-hannah-1-5ctw-engagement-rings-lgmtc1910-lg-100-ra</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-AVALON/avalon-engagement-rings-lgmtc2113-lg-300-ecu">https://weddingdaydiamonds.com/product-detail/ER-AVALON/avalon-engagement-rings-lgmtc2113-lg-300-ecu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-MINI-HANNAH-1-5/mini-hannah-1-5ctw-engagement-rings-lgmtc1907-lg-275-rd">https://weddingdaydiamonds.com/product-detail/ER-MINI-HANNAH-1-5/mini-hannah-1-5ctw-engagement-rings-lgmtc1907-lg-275-rd</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUMI-HIDDEN/lumi-hidden-engagement-rings-lgmtc2201-lg-300-rd">https://weddingdaydiamonds.com/product-detail/ER-TC-LUMI-HIDDEN/lumi-hidden-engagement-rings-lgmtc2201-lg-300-rd</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-VALENTINA/grand-valentina-hidden-engagement-rings-lgmtc2128-lg-200-cu">https://weddingdaydiamonds.com/product-detail/ER-TC-VALENTINA/grand-valentina-hidden-engagement-rings-lgmtc2128-lg-200-cu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-KALI-EAST-WEST/luxe-kali-east-west-engagement-rings-lgmtc1882-lg-175-pr">https://weddingdaydiamonds.com/product-detail/ER-KALI-EAST-WEST/luxe-kali-east-west-engagement-rings-lgmtc1882-lg-175-pr</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-FELICITY-PEAR-&amp;-RNDS/felicity-pear-and-rounds-engagement-rings-lgmtc1983-lg-150-mq">https://weddingdaydiamonds.com/product-detail/ER-FELICITY-PEAR-&amp;-RNDS/felicity-pear-and-rounds-engagement-rings-lgmtc1983-lg-150-mq</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-EMBRACE-CLASSIC/white-gold-embrace-1-6-ctw-engagement-rings-lgmtc1665-lg-100-pe">https://weddingdaydiamonds.com/product-detail/ER-TC-EMBRACE-CLASSIC/white-gold-embrace-1-6-ctw-engagement-rings-lgmtc1665-lg-100-pe</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-SPLIT-SOLITAIRE/modern-split-solitaire-engagement-rings-lgmtc1540-lg-350-pr">https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-SPLIT-SOLITAIRE/modern-split-solitaire-engagement-rings-lgmtc1540-lg-350-pr</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-BRIELLE-3-4CTW/brielle-3-4ctw-engagement-rings-lgmtc1990-lg-150-rd">https://weddingdaydiamonds.com/product-detail/ER-TC-BRIELLE-3-4CTW/brielle-3-4ctw-engagement-rings-lgmtc1990-lg-150-rd</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/FR-INES-BAGUETTE-ROUND-OPEN-RING/white-gold-ines-baguette-round-open-ring-fashion-rings-lgwfr0010">https://weddingdaydiamonds.com/product-detail/FR-INES-BAGUETTE-ROUND-OPEN-RING/white-gold-ines-baguette-round-open-ring-fashion-rings-lgwfr0010</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-AVA-OVAL-3-4/ava-oval-3-4ctw-engagement-rings-lgmtc2088-lg-200-pe">https://weddingdaydiamonds.com/product-detail/ER-AVA-OVAL-3-4/ava-oval-3-4ctw-engagement-rings-lgmtc2088-lg-200-pe</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-CLASSIC-ALLURE-BEZEL-SOLITAIRE/classic-allure-bezel-solitaire-engagement-rings-lgmtc1568-lg-250-cu">https://weddingdaydiamonds.com/product-detail/ER-CLASSIC-ALLURE-BEZEL-SOLITAIRE/classic-allure-bezel-solitaire-engagement-rings-lgmtc1568-lg-250-cu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-ROSALIE-BAGUETTE-ROUND/rosalie-baguette-round-engagement-rings-lgmtc2187-lg-350-em">https://weddingdaydiamonds.com/product-detail/ER-ROSALIE-BAGUETTE-ROUND/rosalie-baguette-round-engagement-rings-lgmtc2187-lg-350-em</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-ATLAS/classic-atlas-3-8ctw-engagement-rings-lgmtc1814-lg-125-mq">https://weddingdaydiamonds.com/product-detail/ER-ATLAS/classic-atlas-3-8ctw-engagement-rings-lgmtc1814-lg-125-mq</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MAGNOLIA-VINE/white-gold-magnolia-vine-4-1-2ct-radiant-center-engagement-rings-lgmtc2428-lg-450-ra">https://weddingdaydiamonds.com/product-detail/ER-TC-MAGNOLIA-VINE/white-gold-magnolia-vine-4-1-2ct-radiant-center-engagement-rings-lgmtc2428-lg-450-ra</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-ATLAS/petite-atlas-1-3ctw-engagement-rings-lgmtc1809-lg-175-pe">https://weddingdaydiamonds.com/product-detail/ER-ATLAS/petite-atlas-1-3ctw-engagement-rings-lgmtc1809-lg-175-pe</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LINA/platinum-mini-lina-1-4ctw-engagement-rings-lgmtc1699-lg-125-mq">https://weddingdaydiamonds.com/product-detail/ER-TC-LINA/platinum-mini-lina-1-4ctw-engagement-rings-lgmtc1699-lg-125-mq</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-PINNACLE/platinum-ultimate-pinnacle-1-2ctw-engagement-rings-lgmtc1627-lg-300-ecu">https://weddingdaydiamonds.com/product-detail/ER-TC-PINNACLE/platinum-ultimate-pinnacle-1-2ctw-engagement-rings-lgmtc1627-lg-300-ecu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-LUXE-EMILIA-1-2/luxe-emilia-1-2ctw-engagement-rings-lgmtc1416-lg-400-em">https://weddingdaydiamonds.com/product-detail/ER-LUXE-EMILIA-1-2/luxe-emilia-1-2ctw-engagement-rings-lgmtc1416-lg-400-em</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-LUXURY-SCARLETT/luxury-scarlett-engagement-rings-lgmtc1448-lg-250-pe">https://weddingdaydiamonds.com/product-detail/ER-LUXURY-SCARLETT/luxury-scarlett-engagement-rings-lgmtc1448-lg-250-pe</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST-HIDDEN-HALO/platinum-twist-hidden-halo-4-1-2ct-elongated-cushion-center-engagement-rings-lgmtc2458-lg-450-ecu">https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST-HIDDEN-HALO/platinum-twist-hidden-halo-4-1-2ct-elongated-cushion-center-engagement-rings-lgmtc2458-lg-450-ecu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-CALISTA-LOVE/calista-love-engagement-rings-lgmtc1465-lg-175-ov">https://weddingdaydiamonds.com/product-detail/ER-CALISTA-LOVE/calista-love-engagement-rings-lgmtc1465-lg-175-ov</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LONA-BAGUETTE-&amp;-ROUND/lona-baguette-&amp;-round-engagement-rings-lgmtc1966-lg-100-em">https://weddingdaydiamonds.com/product-detail/ER-TC-LONA-BAGUETTE-&amp;-ROUND/lona-baguette-&amp;-round-engagement-rings-lgmtc1966-lg-100-em</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/WB-11ST-LGRD/yellow-gold-eleven-diamond-u-split-prong-band-1-4ctw-wedding-bands-lgaby0096">https://weddingdaydiamonds.com/product-detail/WB-11ST-LGRD/yellow-gold-eleven-diamond-u-split-prong-band-1-4ctw-wedding-bands-lgaby0096</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LINA/rose-gold-lina-1-3ctw-engagement-rings-lgmtc1700-lg-250-mq">https://weddingdaydiamonds.com/product-detail/ER-TC-LINA/rose-gold-lina-1-3ctw-engagement-rings-lgmtc1700-lg-250-mq</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-CELTIC/celtic-hidden-engagement-rings-lgmtc1425-lg-300-as">https://weddingdaydiamonds.com/product-detail/ER-CELTIC/celtic-hidden-engagement-rings-lgmtc1425-lg-300-as</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-YVONNE-HIDDEN/yvonne-hidden-engagement-rings-lgmtc2172-lg-300-pe">https://weddingdaydiamonds.com/product-detail/ER-TC-YVONNE-HIDDEN/yvonne-hidden-engagement-rings-lgmtc2172-lg-300-pe</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-LUCIELLE-PEAR-3-8/lucielle-pear-3-8ctw-engagement-rings-lgmtc2034-lg-400-ra">https://weddingdaydiamonds.com/product-detail/ER-LUCIELLE-PEAR-3-8/lucielle-pear-3-8ctw-engagement-rings-lgmtc2034-lg-400-ra</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/MRMT0181-CUSTOM/yellow-4.5mm-modern-solitaire-engagement-rings-mrmt0181-custom">https://weddingdaydiamonds.com/product-detail/MRMT0181-CUSTOM/yellow-4.5mm-modern-solitaire-engagement-rings-mrmt0181-custom</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/WB-LUXE-7STN-EM/white-gold-seven-emerald-wedding-band-4ctw-womens-wedding-bands-lgabw0664">https://weddingdaydiamonds.com/product-detail/WB-LUXE-7STN-EM/white-gold-seven-emerald-wedding-band-4ctw-womens-wedding-bands-lgabw0664</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/FR-LACE/mini-lace-band-1-4ctw-wedding-bands-lgbtc0030-1">https://weddingdaydiamonds.com/product-detail/FR-LACE/mini-lace-band-1-4ctw-wedding-bands-lgbtc0030-1</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/WB-LUXE-CLC-OV-SP-ETR/yellow-gold-classic-oval-shared-prong-eternity-4ctw-womens-wedding-bands-lgetr0452">https://weddingdaydiamonds.com/product-detail/WB-LUXE-CLC-OV-SP-ETR/yellow-gold-classic-oval-shared-prong-eternity-4ctw-womens-wedding-bands-lgetr0452</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-DELPHINE/classic-delphine-engagement-rings-lgmtc1838-lg-200-cu">https://weddingdaydiamonds.com/product-detail/ER-DELPHINE/classic-delphine-engagement-rings-lgmtc1838-lg-200-cu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-MODERN-DOMED-2.5mm/modern-domed-2-5mm-engagement-rings-lgmtc1554-lg-150-cu">https://weddingdaydiamonds.com/product-detail/ER-MODERN-DOMED-2.5mm/modern-domed-2-5mm-engagement-rings-lgmtc1554-lg-150-cu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-SUMMIT/luxe-summit-hidden-engagement-rings-lgmtc2265-lg-400-as">https://weddingdaydiamonds.com/product-detail/ER-TC-SUMMIT/luxe-summit-hidden-engagement-rings-lgmtc2265-lg-400-as</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-LAINEY/luxe-lainey-1-3ctw-engagement-rings-lgmtc1912-lg-200-ra">https://weddingdaydiamonds.com/product-detail/ER-LAINEY/luxe-lainey-1-3ctw-engagement-rings-lgmtc1912-lg-200-ra</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-JUNIPER-HIDDEN-1-2CTW/juniper-hidden-1-2ctw-engagement-rings-lgmtc2125-lg-200-pr">https://weddingdaydiamonds.com/product-detail/ER-TC-JUNIPER-HIDDEN-1-2CTW/juniper-hidden-1-2ctw-engagement-rings-lgmtc2125-lg-200-pr</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-CALISTA-LOVE/calista-love-engagement-rings-lgmtc1464-lg-175-ecu">https://weddingdaydiamonds.com/product-detail/ER-CALISTA-LOVE/calista-love-engagement-rings-lgmtc1464-lg-175-ecu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LINA-MIL/yellow-gold-lina-milgrain-3-8ctw-engagement-rings-lgmtc1742-lg-125-mq">https://weddingdaydiamonds.com/product-detail/ER-TC-LINA-MIL/yellow-gold-lina-milgrain-3-8ctw-engagement-rings-lgmtc1742-lg-125-mq</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-ROSALIE-BAGUETTE-ROUND/rosalie-baguette-round-engagement-rings-lgmtc2187-lg-200-pr">https://weddingdaydiamonds.com/product-detail/ER-ROSALIE-BAGUETTE-ROUND/rosalie-baguette-round-engagement-rings-lgmtc2187-lg-200-pr</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-SPLIT-HIDDEN-SOLITAIRE/modern-split-hidden-solitaire-engagement-rings-lgmtc1872-lg-150-em">https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-SPLIT-HIDDEN-SOLITAIRE/modern-split-hidden-solitaire-engagement-rings-lgmtc1872-lg-150-em</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-2-3ctw-engagement-rings-lgmtc2371-lg-275-ra">https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-2-3ctw-engagement-rings-lgmtc2371-lg-275-ra</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-EEVEE-1-3/eevee1-3ctw-engagement-rings-lgmtc2004-lg-200-cu">https://weddingdaydiamonds.com/product-detail/ER-TC-EEVEE-1-3/eevee1-3ctw-engagement-rings-lgmtc2004-lg-200-cu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-BROOK-HIDDEN-SOLITAIRE/brook-hidden-solitaire-engagement-rings-lgmtc1447-lg-400-ov">https://weddingdaydiamonds.com/product-detail/ER-BROOK-HIDDEN-SOLITAIRE/brook-hidden-solitaire-engagement-rings-lgmtc1447-lg-400-ov</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-LUXURY-SCARLETT/luxury-scarlett-engagement-rings-lgmtc1449-lg-225-ov">https://weddingdaydiamonds.com/product-detail/ER-LUXURY-SCARLETT/luxury-scarlett-engagement-rings-lgmtc1449-lg-225-ov</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-BOHEME-ARTE/boheme-arte-engagement-rings-lgmtc2231-lg-300-ecu">https://weddingdaydiamonds.com/product-detail/ER-TC-BOHEME-ARTE/boheme-arte-engagement-rings-lgmtc2231-lg-300-ecu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-MINI-HANNAH-1-5/mini-hannah-1-5ctw-engagement-rings-lgmtc1910-lg-225-ov">https://weddingdaydiamonds.com/product-detail/ER-MINI-HANNAH-1-5/mini-hannah-1-5ctw-engagement-rings-lgmtc1910-lg-225-ov</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-HELIA-HIDDEN/helia-hidden-engagement-rings-lgmtc2181-lg-250-rd">https://weddingdaydiamonds.com/product-detail/ER-TC-HELIA-HIDDEN/helia-hidden-engagement-rings-lgmtc2181-lg-250-rd</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-SPLIT-HIDDEN-SOLITAIRE/modern-split-hidden-solitaire-engagement-rings-lgmtc1874-lg-100-rd">https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-SPLIT-HIDDEN-SOLITAIRE/modern-split-hidden-solitaire-engagement-rings-lgmtc1874-lg-100-rd</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-HAZEL-TAPERED/hazel-tapered-4-5ctw-engagement-rings-lgmtc2110-lg-150-mq">https://weddingdaydiamonds.com/product-detail/ER-HAZEL-TAPERED/hazel-tapered-4-5ctw-engagement-rings-lgmtc2110-lg-150-mq</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-MODERN-3.5mm-SOLITAIRE/modern-3-5mm-solitaire-engagement-rings-lgmtc1551-lg-175-em">https://weddingdaydiamonds.com/product-detail/ER-MODERN-3.5mm-SOLITAIRE/modern-3-5mm-solitaire-engagement-rings-lgmtc1551-lg-175-em</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-TWIST-VENUS/luxe-twist-venus-engagement-rings-lgmtc2242-lg-250-rd">https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-TWIST-VENUS/luxe-twist-venus-engagement-rings-lgmtc2242-lg-250-rd</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LINA/white-gold-lina-1-3ctw-engagement-rings-lgmtc1701-lg-250-pe">https://weddingdaydiamonds.com/product-detail/ER-TC-LINA/white-gold-lina-1-3ctw-engagement-rings-lgmtc1701-lg-250-pe</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-HELIA-HIDDEN/helia-hidden-engagement-rings-lgmtc2182-lg-250-em">https://weddingdaydiamonds.com/product-detail/ER-TC-HELIA-HIDDEN/helia-hidden-engagement-rings-lgmtc2182-lg-250-em</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/GRAND15752/14k-rose-gold-3-1-2ctw-grand-collection-engagement-ring-engagement-rings-prbre0084">https://weddingdaydiamonds.com/product-detail/GRAND15752/14k-rose-gold-3-1-2ctw-grand-collection-engagement-ring-engagement-rings-prbre0084</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-FIONA-MQ-RD/rose-gold-fiona-marquise-round-1-2ctw-engagement-rings-lgmtc1676-lg-225-mq">https://weddingdaydiamonds.com/product-detail/ER-TC-FIONA-MQ-RD/rose-gold-fiona-marquise-round-1-2ctw-engagement-rings-lgmtc1676-lg-225-mq</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ARIELLE-SUN/white-gold-arielle-sun-3-3-4ct-elongated-cushion-center-engagement-rings-lgmtc2476-lg-375-ecu">https://weddingdaydiamonds.com/product-detail/ER-TC-ARIELLE-SUN/white-gold-arielle-sun-3-3-4ct-elongated-cushion-center-engagement-rings-lgmtc2476-lg-375-ecu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-AUTUMN-VINE-TRES/white-gold-autumn-vine-tres-3-3-4ct-pear-center-engagement-rings-lgmtc2440-lg-375-pe">https://weddingdaydiamonds.com/product-detail/ER-TC-AUTUMN-VINE-TRES/white-gold-autumn-vine-tres-3-3-4ct-pear-center-engagement-rings-lgmtc2440-lg-375-pe</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-BREA-HALO-3-8/brea-halo-3-8ctw-engagement-rings-lgmtc1438-lg-400-pe">https://weddingdaydiamonds.com/product-detail/ER-BREA-HALO-3-8/brea-halo-3-8ctw-engagement-rings-lgmtc1438-lg-400-pe</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-SUMMIT/luxe-summit-hidden-engagement-rings-lgmtc2264-lg-275-mq">https://weddingdaydiamonds.com/product-detail/ER-TC-SUMMIT/luxe-summit-hidden-engagement-rings-lgmtc2264-lg-275-mq</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-DELPHINA-5-8/delphina-5-8ctw-engagement-rings-lgmtc2048-lg-300-as">https://weddingdaydiamonds.com/product-detail/ER-DELPHINA-5-8/delphina-5-8ctw-engagement-rings-lgmtc2048-lg-300-as</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-ALLURE-BEZEL-SOL/allure-hidden-solitaire-engagement-rings-lgmtc1463-lg-175-pr">https://weddingdaydiamonds.com/product-detail/ER-ALLURE-BEZEL-SOL/allure-hidden-solitaire-engagement-rings-lgmtc1463-lg-175-pr</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-AC-LUXE-HIDDEN-3-8/atia-couture-luxe-hidden-3-8ctw-engagement-rings-lgmtc2269-lg-300-rd">https://weddingdaydiamonds.com/product-detail/ER-AC-LUXE-HIDDEN-3-8/atia-couture-luxe-hidden-3-8ctw-engagement-rings-lgmtc2269-lg-300-rd</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-GRACELYN-1-3CTW/gracelyn-1-3ctw-engagement-rings-lgmtc2210-lg-500-pr">https://weddingdaydiamonds.com/product-detail/ER-TC-GRACELYN-1-3CTW/gracelyn-1-3ctw-engagement-rings-lgmtc2210-lg-500-pr</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUCERNE/luxe-lucerne-hidden-engagement-rings-lgmtc2262-lg-150-rd">https://weddingdaydiamonds.com/product-detail/ER-TC-LUCERNE/luxe-lucerne-hidden-engagement-rings-lgmtc2262-lg-150-rd</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-ATLAS/mini-atlas-1-5ctw-engagement-rings-lgmtc1807-lg-350-mq">https://weddingdaydiamonds.com/product-detail/ER-ATLAS/mini-atlas-1-5ctw-engagement-rings-lgmtc1807-lg-350-mq</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-CAMILE/platinum-camiile-1-3ctw-engagement-rings-lgmtc1731-lg-275-ra">https://weddingdaydiamonds.com/product-detail/ER-TC-CAMILE/platinum-camiile-1-3ctw-engagement-rings-lgmtc1731-lg-275-ra</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-MODERN-DOMED-2.5mm/modern-domed-2-5mm-engagement-rings-lgmtc1552-lg-150-ecu">https://weddingdaydiamonds.com/product-detail/ER-MODERN-DOMED-2.5mm/modern-domed-2-5mm-engagement-rings-lgmtc1552-lg-150-ecu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MAGNOLIA-VINE/yellow-gold-magnolia-vine-1ct-radiant-center-engagement-rings-lgmtc2429-lg-100-ra">https://weddingdaydiamonds.com/product-detail/ER-TC-MAGNOLIA-VINE/yellow-gold-magnolia-vine-1ct-radiant-center-engagement-rings-lgmtc2429-lg-100-ra</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-3-4ctw-engagement-rings-lgmtc2366-lg-150-cu">https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-3-4ctw-engagement-rings-lgmtc2366-lg-150-cu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-HAZEL-TAPERED/hazel-tapered-4-5ctw-engagement-rings-lgmtc2108-lg-275-ra">https://weddingdaydiamonds.com/product-detail/ER-HAZEL-TAPERED/hazel-tapered-4-5ctw-engagement-rings-lgmtc2108-lg-275-ra</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-HIDDEN-RIVER/hidden-river-engagement-rings-lgmtc2153-lg-250-ra">https://weddingdaydiamonds.com/product-detail/ER-TC-HIDDEN-RIVER/hidden-river-engagement-rings-lgmtc2153-lg-250-ra</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-MODERN-DOMED-3.5mm/modern-domed-3-5mm-engagement-rings-lgmtc1556-lg-250-pr">https://weddingdaydiamonds.com/product-detail/ER-MODERN-DOMED-3.5mm/modern-domed-3-5mm-engagement-rings-lgmtc1556-lg-250-pr</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-SIENNA/rose-gold-sienna-luxe-3-4ctw-engagement-rings-lgmtc1764-lg-225-ra">https://weddingdaydiamonds.com/product-detail/ER-TC-SIENNA/rose-gold-sienna-luxe-3-4ctw-engagement-rings-lgmtc1764-lg-225-ra</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-CEDAR-HIDDEN/cedar-hidden-engagement-rings-lgmtc2166-lg-225-as">https://weddingdaydiamonds.com/product-detail/ER-TC-CEDAR-HIDDEN/cedar-hidden-engagement-rings-lgmtc2166-lg-225-as</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-MQ/rose-gold-three-stone-marquise-1-7ctw-engagement-rings-lgmtc2291-lg-225-rd">https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-MQ/rose-gold-three-stone-marquise-1-7ctw-engagement-rings-lgmtc2291-lg-225-rd</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-ATHENA/athena-engagement-rings-lgmtc1433-lg-200-ecu">https://weddingdaydiamonds.com/product-detail/ER-ATHENA/athena-engagement-rings-lgmtc1433-lg-200-ecu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-NEURO-EMERALD/neuro-emerald-engagement-rings-lgmtc2086-lg-350-pr">https://weddingdaydiamonds.com/product-detail/ER-NEURO-EMERALD/neuro-emerald-engagement-rings-lgmtc2086-lg-350-pr</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-JUNIPER-HIDDEN-1-2CTW/juniper-hidden-1-2ctw-engagement-rings-lgmtc2124-lg-100-as">https://weddingdaydiamonds.com/product-detail/ER-TC-JUNIPER-HIDDEN-1-2CTW/juniper-hidden-1-2ctw-engagement-rings-lgmtc2124-lg-100-as</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-ATLAS/petite-atlas-1-3ctw-engagement-rings-lgmtc1809-lg-250-mq">https://weddingdaydiamonds.com/product-detail/ER-ATLAS/petite-atlas-1-3ctw-engagement-rings-lgmtc1809-lg-250-mq</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-GRAND-ELIZABETH/grand-elizabeth-engagement-rings-lgmtc2010-lg-275-pr">https://weddingdaydiamonds.com/product-detail/ER-GRAND-ELIZABETH/grand-elizabeth-engagement-rings-lgmtc2010-lg-275-pr</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-EAST-WEST-HIDDEN/east-west-hidden-engagement-rings-lgmtc1855-lg-250-mq">https://weddingdaydiamonds.com/product-detail/ER-EAST-WEST-HIDDEN/east-west-hidden-engagement-rings-lgmtc1855-lg-250-mq</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1-4ctw-engagement-rings-lgmtc2389-lg-125-as">https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1-4ctw-engagement-rings-lgmtc2389-lg-125-as</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-DELPHINE-SOLITAIRE/delphine-solitaire-engagement-rings-lgmtc1452-lg-350-pe">https://weddingdaydiamonds.com/product-detail/ER-DELPHINE-SOLITAIRE/delphine-solitaire-engagement-rings-lgmtc1452-lg-350-pe</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LINA-MIL/rose-gold-mini-lina-milgrain-1-4ctw-engagement-rings-lgmtc1736-lg-125-ra">https://weddingdaydiamonds.com/product-detail/ER-TC-LINA-MIL/rose-gold-mini-lina-milgrain-1-4ctw-engagement-rings-lgmtc1736-lg-125-ra</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-EMBRACE-CLASSIC/rose-gold-embrace-1-6-ctw-engagement-rings-lgmtc1664-lg-100-pr">https://weddingdaydiamonds.com/product-detail/ER-TC-EMBRACE-CLASSIC/rose-gold-embrace-1-6-ctw-engagement-rings-lgmtc1664-lg-100-pr</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-PINNACLE/platinum-ultimate-pinnacle-1-2ctw-engagement-rings-lgmtc1627-lg-225-ecu">https://weddingdaydiamonds.com/product-detail/ER-TC-PINNACLE/platinum-ultimate-pinnacle-1-2ctw-engagement-rings-lgmtc1627-lg-225-ecu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-VALENTINA/valentina-1-2ctw-engagement-rings-lgmtc2136-lg-175-ecu">https://weddingdaydiamonds.com/product-detail/ER-TC-VALENTINA/valentina-1-2ctw-engagement-rings-lgmtc2136-lg-175-ecu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-ASPEN-SIX-PRONG-SOLITAIRE/aspen-six-prong-solitaire-engagement-rings-lgmtc1538-lg-175-pr">https://weddingdaydiamonds.com/product-detail/ER-ASPEN-SIX-PRONG-SOLITAIRE/aspen-six-prong-solitaire-engagement-rings-lgmtc1538-lg-175-pr</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-VERONA/rose-gold-verona-marquise-round-3-8ctw-engagement-rings-lgmtc1772-lg-200-cu">https://weddingdaydiamonds.com/product-detail/ER-TC-VERONA/rose-gold-verona-marquise-round-3-8ctw-engagement-rings-lgmtc1772-lg-200-cu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-ATLAS/grand-atlas-9-10ctw-engagement-rings-lgmtc1822-lg-125-ecu">https://weddingdaydiamonds.com/product-detail/ER-ATLAS/grand-atlas-9-10ctw-engagement-rings-lgmtc1822-lg-125-ecu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-PRISCILLA/luxe-priscilla-engagement-rings-lgmtc2225-lg-225-ov">https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-PRISCILLA/luxe-priscilla-engagement-rings-lgmtc2225-lg-225-ov</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-CLASSIC-ALLURE-BEZEL-SOLITAIRE/classic-allure-bezel-solitaire-engagement-rings-lgmtc1569-lg-100-ra">https://weddingdaydiamonds.com/product-detail/ER-CLASSIC-ALLURE-BEZEL-SOLITAIRE/classic-allure-bezel-solitaire-engagement-rings-lgmtc1569-lg-100-ra</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-TC-WHISPER/grand-whisper-hidden-halo-1-4ctw-engagement-rings-lgmtc1394-lg-350-pe">https://weddingdaydiamonds.com/product-detail/ER-TC-WHISPER/grand-whisper-hidden-halo-1-4ctw-engagement-rings-lgmtc1394-lg-350-pe</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/WB-11ST-LGRD/platinum-eleven-diamond-u-split-prong-band-1-1-2ctw-wedding-bands-lgabp0014">https://weddingdaydiamonds.com/product-detail/WB-11ST-LGRD/platinum-eleven-diamond-u-split-prong-band-1-1-2ctw-wedding-bands-lgabp0014</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-ATLAS/atlas-5-8ctw-engagement-rings-lgmtc1819-lg-100-cu">https://weddingdaydiamonds.com/product-detail/ER-ATLAS/atlas-5-8ctw-engagement-rings-lgmtc1819-lg-100-cu</a></li>
  <li><a href="https://weddingdaydiamonds.com/product-detail/ER-AC-SUMMIT-HALO-9-10/atia-couture-summit-halo-9-10ctw-engagement-rings-lgmtc1502-lg-275-pr">https://weddingdaydiamonds.com/product-detail/ER-AC-SUMMIT-HALO-9-10/atia-couture-summit-halo-9-10ctw-engagement-rings-lgmtc1502-lg-275-pr</a></li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-VALENTINA/luxe-valentina-2-3ctw-engagement-rings-lgmtc1919-lg-175-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-VALENTINA/luxe-valentina-2-3ctw-engagement-rings-lgmtc1919-lg-175-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-DELPHINE-SOLITAIRE/delphine-solitaire-engagement-rings-lgmtc1455-lg-350-pr">
      https://weddingdaydiamonds.com/product-detail/ER-DELPHINE-SOLITAIRE/delphine-solitaire-engagement-rings-lgmtc1455-lg-350-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LEO-2-3CTW/leo-2-3ctw-engagement-rings-lgmtc1803-lg-275-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LEO-2-3CTW/leo-2-3ctw-engagement-rings-lgmtc1803-lg-275-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-HELIA-HIDDEN/helia-hidden-engagement-rings-lgmtc2181-lg-150-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-HELIA-HIDDEN/helia-hidden-engagement-rings-lgmtc2181-lg-150-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-GRACIE-THREE-STONE/gracie-three-stone-engagement-rings-lgmtc2348-lg-400-ra">
      https://weddingdaydiamonds.com/product-detail/ER-GRACIE-THREE-STONE/gracie-three-stone-engagement-rings-lgmtc2348-lg-400-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TWIST-THREE-STONE/luxe-twist-three-stone-engagement-rings-lgmtc2353-lg-400-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TWIST-THREE-STONE/luxe-twist-three-stone-engagement-rings-lgmtc2353-lg-400-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUCERNE/lucerne-hidden-engagement-rings-lgmtc1497-lg-175-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUCERNE/lucerne-hidden-engagement-rings-lgmtc1497-lg-175-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LUXURY-ALERIE/luxury-alerie-engagement-rings-lgmtc1936-lg-175-em">
      https://weddingdaydiamonds.com/product-detail/ER-LUXURY-ALERIE/luxury-alerie-engagement-rings-lgmtc1936-lg-175-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-7STONE/yellow-gold-classic-seven-stone-1-3ctw-engagement-rings-lgmtc1654-lg-150-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-7STONE/yellow-gold-classic-seven-stone-1-3ctw-engagement-rings-lgmtc1654-lg-150-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/LGMWT0842-CUSTOM/petite-three-stone-1ct-marquise-lgmwt0842-custom">
      https://weddingdaydiamonds.com/product-detail/LGMWT0842-CUSTOM/petite-three-stone-1ct-marquise-lgmwt0842-custom
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-OVAL-5STONE/yellow-gold-oval-five-stone-5-8ctw-engagement-rings-lgmtc1658-lg-275-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-OVAL-5STONE/yellow-gold-oval-five-stone-5-8ctw-engagement-rings-lgmtc1658-lg-275-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-BOHEME-ARTE/boheme-arte-engagement-rings-lgmtc2232-lg-150-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TC-BOHEME-ARTE/boheme-arte-engagement-rings-lgmtc2232-lg-150-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-1-3-8ctw-engagement-rings-lgmtc2382-lg-200-pr">
      https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-1-3-8ctw-engagement-rings-lgmtc2382-lg-200-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-RAELYN-HIDDEN/raelyn-hidden-engagement-rings-lgmtc1941-lg-150-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-RAELYN-HIDDEN/raelyn-hidden-engagement-rings-lgmtc1941-lg-150-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-REMI-KITE-SOLITAIRE/remi-kite-solitaire-engagement-rings-lgmtc1524-lg-200-ra">
      https://weddingdaydiamonds.com/product-detail/ER-REMI-KITE-SOLITAIRE/remi-kite-solitaire-engagement-rings-lgmtc1524-lg-200-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-PEAR/platinum-mini-three-stone-pear-1-10ctw-engagement-rings-lgmtc2278-lg-175-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-PEAR/platinum-mini-three-stone-pear-1-10ctw-engagement-rings-lgmtc2278-lg-175-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-COMPASS-HIDDEN-SOLITAIRE/compass-hidden-solitaire-engagement-rings-lgmtc1860-lg-200-pr">
      https://weddingdaydiamonds.com/product-detail/ER-COMPASS-HIDDEN-SOLITAIRE/compass-hidden-solitaire-engagement-rings-lgmtc1860-lg-200-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TRES-OVAL-3-8/tres-oval-3-8ctw-engagement-rings-lgmtc2013-lg-125-em">
      https://weddingdaydiamonds.com/product-detail/ER-TRES-OVAL-3-8/tres-oval-3-8ctw-engagement-rings-lgmtc2013-lg-125-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ATLAS/grand-atlas-9-10ctw-engagement-rings-lgmtc1823-lg-500-pr">
      https://weddingdaydiamonds.com/product-detail/ER-ATLAS/grand-atlas-9-10ctw-engagement-rings-lgmtc1823-lg-500-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-NESTLE-CATHEDRAL-SOLITAIRE/nestle-cathedral-solitaire-engagement-rings-lgmtc1606-lg-225-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-NESTLE-CATHEDRAL-SOLITAIRE/nestle-cathedral-solitaire-engagement-rings-lgmtc1606-lg-225-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ARIELLE-SUN/yellow-gold-arielle-sun-1-1-4ct-elongated-cushion-center-engagement-rings-lgmtc2477-lg-125-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ARIELLE-SUN/yellow-gold-arielle-sun-1-1-4ct-elongated-cushion-center-engagement-rings-lgmtc2477-lg-125-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-GRACIE-THREE-STONE/gracie-three-stone-engagement-rings-lgmtc2348-lg-100-ra">
      https://weddingdaydiamonds.com/product-detail/ER-GRACIE-THREE-STONE/gracie-three-stone-engagement-rings-lgmtc2348-lg-100-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-5STONE/rose-gold-luxury-five-stone-1-3ctw-engagement-rings-lgmtc1644-lg-300-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-5STONE/rose-gold-luxury-five-stone-1-3ctw-engagement-rings-lgmtc1644-lg-300-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LACE/platinum-luxury-lace-1-2ctw-engagement-rings-lgmtc1723-lg-175-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LACE/platinum-luxury-lace-1-2ctw-engagement-rings-lgmtc1723-lg-175-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-HANNAH-HIDDEN/luxe-hannah-hidden-1-2ctw-engagement-rings-lgmtc1411-lg-150-mq">
      https://weddingdaydiamonds.com/product-detail/ER-HANNAH-HIDDEN/luxe-hannah-hidden-1-2ctw-engagement-rings-lgmtc1411-lg-150-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST/twist-halo-engagement-rings-lgmtc1470-lg-275-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST/twist-halo-engagement-rings-lgmtc1470-lg-275-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TULIP-SOLITAIRE/tulip-solitaire-engagement-rings-lgmtc1515-lg-125-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TULIP-SOLITAIRE/tulip-solitaire-engagement-rings-lgmtc1515-lg-125-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LOTUS/lotus-3-8ctw-engagement-rings-lgmtc1888-lg-250-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-LOTUS/lotus-3-8ctw-engagement-rings-lgmtc1888-lg-250-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-4.5MM-SOLITAIRE/modern-4.5mm-solitaire-engagement-rings-lgmtc1584-lg-100-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-4.5MM-SOLITAIRE/modern-4.5mm-solitaire-engagement-rings-lgmtc1584-lg-100-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-AC-SUMMIT-HIDDEN/atia-couture-summit-hidden-3-8ctw-engagement-rings-lgmtc2274-lg-125-em">
      https://weddingdaydiamonds.com/product-detail/ER-AC-SUMMIT-HIDDEN/atia-couture-summit-hidden-3-8ctw-engagement-rings-lgmtc2274-lg-125-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-5STONE/rose-gold-classic-five-stone-1-4ctw-engagement-rings-lgmtc1636-lg-250-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-5STONE/rose-gold-classic-five-stone-1-4ctw-engagement-rings-lgmtc1636-lg-250-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-PEAR/white-gold-three-stone-pear-1-4ctw-engagement-rings-lgmtc2280-lg-200-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-PEAR/white-gold-three-stone-pear-1-4ctw-engagement-rings-lgmtc2280-lg-200-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-CLASSIC-BEZEL-SOL/platinum-classic-bezel-solitaire-engagement-rings-lgmtc2258-lg-300-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-CLASSIC-BEZEL-SOL/platinum-classic-bezel-solitaire-engagement-rings-lgmtc2258-lg-300-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-GRAND-DENALI/grand-denali-engagement-rings-lgmtc2197-lg-125-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-GRAND-DENALI/grand-denali-engagement-rings-lgmtc2197-lg-125-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ARIELLE-SUN/white-gold-arielle-sun-2-1-4ct-emerald-center-engagement-rings-lgmtc2476-lg-225-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ARIELLE-SUN/white-gold-arielle-sun-2-1-4ct-emerald-center-engagement-rings-lgmtc2476-lg-225-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ANGELICA-PEAR-&amp;-ROUND/angelica-pear-and-round-engagement-rings-lgmtc1996-lg-175-rd">
      https://weddingdaydiamonds.com/product-detail/ER-ANGELICA-PEAR-&amp;-ROUND/angelica-pear-and-round-engagement-rings-lgmtc1996-lg-175-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LINA-MIL/white-gold-lina-milgrain-3-8ctw-engagement-rings-lgmtc1741-lg-250-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LINA-MIL/white-gold-lina-milgrain-3-8ctw-engagement-rings-lgmtc1741-lg-250-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-KALI-EAST-WEST/luxe-kali-east-west-engagement-rings-lgmtc1881-lg-250-cu">
      https://weddingdaydiamonds.com/product-detail/ER-KALI-EAST-WEST/luxe-kali-east-west-engagement-rings-lgmtc1881-lg-250-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1ctw-engagement-rings-lgmtc2395-lg-150-em">
      https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1ctw-engagement-rings-lgmtc2395-lg-150-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-NELLIE-DECO/nellie-deco-engagement-rings-lgmtc2358-lg-500-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-NELLIE-DECO/nellie-deco-engagement-rings-lgmtc2358-lg-500-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MAE-TWIST/white-gold-mae-twist-3-3-4ct-marquise-center-engagement-rings-lgmtc2468-lg-375-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-MAE-TWIST/white-gold-mae-twist-3-3-4ct-marquise-center-engagement-rings-lgmtc2468-lg-375-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-REMI-KITE-SOLITAIRE/remi-kite-solitaire-engagement-rings-lgmtc1527-lg-125-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-REMI-KITE-SOLITAIRE/remi-kite-solitaire-engagement-rings-lgmtc1527-lg-125-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LEO-2-3CTW/leo-2-3ctw-engagement-rings-lgmtc1801-lg-275-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LEO-2-3CTW/leo-2-3ctw-engagement-rings-lgmtc1801-lg-275-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ATLAS/petite-atlas-1-3ctw-engagement-rings-lgmtc1808-lg-100-em">
      https://weddingdaydiamonds.com/product-detail/ER-ATLAS/petite-atlas-1-3ctw-engagement-rings-lgmtc1808-lg-100-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUMIERE/grand-lumiere-hidden-engagement-rings-lgmtc2237-lg-400-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUMIERE/grand-lumiere-hidden-engagement-rings-lgmtc2237-lg-400-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-FELICITY-PEAR-&amp;-RNDS/felicity-pear-and-rounds-engagement-rings-lgmtc1983-lg-275-ov">
      https://weddingdaydiamonds.com/product-detail/ER-FELICITY-PEAR-&amp;-RNDS/felicity-pear-and-rounds-engagement-rings-lgmtc1983-lg-275-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-CIANA-KITE/ciana-kite-engagement-rings-lgmtc2140-lg-250-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-CIANA-KITE/ciana-kite-engagement-rings-lgmtc2140-lg-250-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-AURORA/luxe-aurora-engagement-rings-lgmtc2067-lg-500-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-AURORA/luxe-aurora-engagement-rings-lgmtc2067-lg-500-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-CAMILE/platinum-camiile-1-3ctw-engagement-rings-lgmtc1731-lg-150-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TC-CAMILE/platinum-camiile-1-3ctw-engagement-rings-lgmtc1731-lg-150-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-MODERN-DOMED-2.5mm/modern-domed-2-5mm-engagement-rings-lgmtc1552-lg-125-em">
      https://weddingdaydiamonds.com/product-detail/ER-MODERN-DOMED-2.5mm/modern-domed-2-5mm-engagement-rings-lgmtc1552-lg-125-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/MWB-TC-AIDAN-BD/rose-gold-aidan-channel-black-diamond-mens-band-mens-wedding-bands-lgtmb0269">
      https://weddingdaydiamonds.com/product-detail/MWB-TC-AIDAN-BD/rose-gold-aidan-channel-black-diamond-mens-band-mens-wedding-bands-lgtmb0269
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-1-1-5ctw-engagement-rings-lgmtc2375-lg-125-pe">
      https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-1-1-5ctw-engagement-rings-lgmtc2375-lg-125-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LALILIQUE/lalilique-engagement-rings-lgmtc1952-lg-400-as">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LALILIQUE/lalilique-engagement-rings-lgmtc1952-lg-400-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-BEZEL-EAST-WEST-SOL/platinum-bezel-east-west-solitaire-engagement-rings-lgmtc2250-lg-225-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-BEZEL-EAST-WEST-SOL/platinum-bezel-east-west-solitaire-engagement-rings-lgmtc2250-lg-225-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-PINNACLE/yellow-gold-ultimate-pinnacle-1-2ctw-engagement-rings-lgmtc1626-lg-150-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-PINNACLE/yellow-gold-ultimate-pinnacle-1-2ctw-engagement-rings-lgmtc1626-lg-150-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-MAEVE/maeve-engagement-rings-lgmtc2027-lg-175-mq">
      https://weddingdaydiamonds.com/product-detail/ER-MAEVE/maeve-engagement-rings-lgmtc2027-lg-175-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/BRAC-CLASSIC-ROUND-BEZEL/sterling-silver-classic-round-bezel-adjustable-bracelet-1-10ct-bracelets-lgsfb0002">
      https://weddingdaydiamonds.com/product-detail/BRAC-CLASSIC-ROUND-BEZEL/sterling-silver-classic-round-bezel-adjustable-bracelet-1-10ct-bracelets-lgsfb0002
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-DELPHINE/classic-delphine-engagement-rings-lgmtc1836-lg-150-ra">
      https://weddingdaydiamonds.com/product-detail/ER-DELPHINE/classic-delphine-engagement-rings-lgmtc1836-lg-150-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LALILIQUE/lalilique-engagement-rings-lgmtc1954-lg-275-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LALILIQUE/lalilique-engagement-rings-lgmtc1954-lg-275-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-REMI-KITE-SOLITAIRE/remi-kite-solitaire-engagement-rings-lgmtc1524-lg-275-mq">
      https://weddingdaydiamonds.com/product-detail/ER-REMI-KITE-SOLITAIRE/remi-kite-solitaire-engagement-rings-lgmtc1524-lg-275-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LUCIELLE-PEAR-3-8/lucielle-pear-3-8ctw-engagement-rings-lgmtc2031-lg-500-rd">
      https://weddingdaydiamonds.com/product-detail/ER-LUCIELLE-PEAR-3-8/lucielle-pear-3-8ctw-engagement-rings-lgmtc2031-lg-500-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-MODERN-3.5mm-SOLITAIRE/modern-3-5mm-solitaire-engagement-rings-lgmtc1548-lg-400-pr">
      https://weddingdaydiamonds.com/product-detail/ER-MODERN-3.5mm-SOLITAIRE/modern-3-5mm-solitaire-engagement-rings-lgmtc1548-lg-400-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-1-3-8ctw-engagement-rings-lgmtc2379-lg-225-cu">
      https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-1-3-8ctw-engagement-rings-lgmtc2379-lg-225-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ATLAS/luxury-atlas-1-1-5ctw-engagement-rings-lgmtc1827-lg-150-rd">
      https://weddingdaydiamonds.com/product-detail/ER-ATLAS/luxury-atlas-1-1-5ctw-engagement-rings-lgmtc1827-lg-150-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-HELENA-DECO/helena-deco-engagement-rings-lgmtc1601-lg-275-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-HELENA-DECO/helena-deco-engagement-rings-lgmtc1601-lg-275-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-VALENTINA/valentina-1-2ctw-engagement-rings-lgmtc2137-lg-225-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-VALENTINA/valentina-1-2ctw-engagement-rings-lgmtc2137-lg-225-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-CELTIC/queen-celtic-1-5ctw-engagement-rings-lgmtc1915-lg-300-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-CELTIC/queen-celtic-1-5ctw-engagement-rings-lgmtc1915-lg-300-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ATLAS/grand-atlas-9-10ctw-engagement-rings-lgmtc1821-lg-225-rd">
      https://weddingdaydiamonds.com/product-detail/ER-ATLAS/grand-atlas-9-10ctw-engagement-rings-lgmtc1821-lg-225-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-HANNAH-HIDDEN-SOLITAIRE/hannah-hidden-solitaire-engagement-rings-lgmtc1404-lg-400-pe">
      https://weddingdaydiamonds.com/product-detail/ER-HANNAH-HIDDEN-SOLITAIRE/hannah-hidden-solitaire-engagement-rings-lgmtc1404-lg-400-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-IRIS/yellow-gold-iris-hidden-1-1-2ct-radiant-center-engagement-rings-lgmtc2425-lg-150-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-IRIS/yellow-gold-iris-hidden-1-1-2ct-radiant-center-engagement-rings-lgmtc2425-lg-150-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-HARPER/petite-harper-engagement-rings-lgmtc2099-lg-225-mq">
      https://weddingdaydiamonds.com/product-detail/ER-HARPER/petite-harper-engagement-rings-lgmtc2099-lg-225-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-SPLIT-SOLITAIRE/modern-split-solitaire-engagement-rings-lgmtc1542-lg-400-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-SPLIT-SOLITAIRE/modern-split-solitaire-engagement-rings-lgmtc1542-lg-400-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ATLAS/luxury-atlas-1-1-5ctw-engagement-rings-lgmtc1825-lg-125-mq">
      https://weddingdaydiamonds.com/product-detail/ER-ATLAS/luxury-atlas-1-1-5ctw-engagement-rings-lgmtc1825-lg-125-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ELIANA-PEAR/white-gold-mini-eliana-pear-1-3ctw-engagement-rings-lgmtc1789-lg-100-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ELIANA-PEAR/white-gold-mini-eliana-pear-1-3ctw-engagement-rings-lgmtc1789-lg-100-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-IRIS/rose-gold-iris-hidden-2-3-4ct-pear-center-engagement-rings-lgmtc2423-lg-275-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-IRIS/rose-gold-iris-hidden-2-3-4ct-pear-center-engagement-rings-lgmtc2423-lg-275-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-DELPHINE/classic-delphine-engagement-rings-lgmtc1835-lg-200-cu">
      https://weddingdaydiamonds.com/product-detail/ER-DELPHINE/classic-delphine-engagement-rings-lgmtc1835-lg-200-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-TESSA-BEZEL-SOLITAIRE/yellow-gold-tessa-bezel-solitaire-2-3-4ct-princess-center-engagement-rings-lgmtc2461-lg-275-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-TESSA-BEZEL-SOLITAIRE/yellow-gold-tessa-bezel-solitaire-2-3-4ct-princess-center-engagement-rings-lgmtc2461-lg-275-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ANTONELLA-PEAR-MQ/platinum-antonella-pear-&amp;-round-3-8ctw-engagement-rings-lgmtc1683-lg-250-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ANTONELLA-PEAR-MQ/platinum-antonella-pear-&amp;-round-3-8ctw-engagement-rings-lgmtc1683-lg-250-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-NESTLE-CATHEDRAL-SOLITAIRE/nestle-cathedral-solitaire-engagement-rings-lgmtc1607-lg-300-as">
      https://weddingdaydiamonds.com/product-detail/ER-TC-NESTLE-CATHEDRAL-SOLITAIRE/nestle-cathedral-solitaire-engagement-rings-lgmtc1607-lg-300-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ALLURE-BEZEL-SOL/allure-bezel-solitaire-engagement-rings-lgmtc1577-lg-175-mq">
      https://weddingdaydiamonds.com/product-detail/ER-ALLURE-BEZEL-SOL/allure-bezel-solitaire-engagement-rings-lgmtc1577-lg-175-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-NELLIE-DECO/nellie-deco-engagement-rings-lgmtc2356-lg-400-mq">
      https://weddingdaydiamonds.com/product-detail/ER-NELLIE-DECO/nellie-deco-engagement-rings-lgmtc2356-lg-400-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-VALLIANT-SOLITAIRE/valliant-solitaire-engagement-rings-lgmtc1580-lg-250-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-VALLIANT-SOLITAIRE/valliant-solitaire-engagement-rings-lgmtc1580-lg-250-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LOTUS/lotus-3-8ctw-engagement-rings-lgmtc1890-lg-500-mq">
      https://weddingdaydiamonds.com/product-detail/ER-LOTUS/lotus-3-8ctw-engagement-rings-lgmtc1890-lg-500-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-GRAND-DENALI/grand-denali-engagement-rings-lgmtc2195-lg-300-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-GRAND-DENALI/grand-denali-engagement-rings-lgmtc2195-lg-300-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ROSALIND-HIDDEN/rosalind-hidden-engagement-rings-lgmtc2155-lg-125-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ROSALIND-HIDDEN/rosalind-hidden-engagement-rings-lgmtc2155-lg-125-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-5STONE/platinum-luxury-five-stone-1-3ctw-engagement-rings-lgmtc1647-lg-125-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-5STONE/platinum-luxury-five-stone-1-3ctw-engagement-rings-lgmtc1647-lg-125-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-BG/platinum-three-stone-tapered-baguette-1-3ctw-engagement-rings-lgmtc2306-lg-300-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-BG/platinum-three-stone-tapered-baguette-1-3ctw-engagement-rings-lgmtc2306-lg-300-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-AVALON/avalon-engagement-rings-lgmtc2112-lg-350-ra">
      https://weddingdaydiamonds.com/product-detail/ER-AVALON/avalon-engagement-rings-lgmtc2112-lg-350-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1-3ctw-engagement-rings-lgmtc2368-lg-100-as">
      https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1-3ctw-engagement-rings-lgmtc2368-lg-100-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LEO-2-3CTW/leo-2-3ctw-engagement-rings-lgmtc1802-lg-500-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LEO-2-3CTW/leo-2-3ctw-engagement-rings-lgmtc1802-lg-500-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1-3ctw-engagement-rings-lgmtc2368-lg-150-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1-3ctw-engagement-rings-lgmtc2368-lg-150-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-COUTURE-TWIST-HIDDEN/rose-gold-couture-twist-hidden-3ct-emerald-center-engagement-rings-lgmtc2435-lg-300-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-COUTURE-TWIST-HIDDEN/rose-gold-couture-twist-hidden-3ct-emerald-center-engagement-rings-lgmtc2435-lg-300-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-AUTUMN-VINE-SOLITAIRE/autumn-vine-solitaire-engagement-rings-lgmtc1481-lg-275-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-AUTUMN-VINE-SOLITAIRE/autumn-vine-solitaire-engagement-rings-lgmtc1481-lg-275-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1-2ctw-engagement-rings-lgmtc2392-lg-350-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1-2ctw-engagement-rings-lgmtc2392-lg-350-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-1-3-8ctw-engagement-rings-lgmtc2380-lg-500-pr">
      https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-1-3-8ctw-engagement-rings-lgmtc2380-lg-500-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-DEMI/demi-1-5ctw-engagement-rings-lgmtc1751-lg-200-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-DEMI/demi-1-5ctw-engagement-rings-lgmtc1751-lg-200-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-DUO-LUMIERE/luxe-duo-lumiere-3-8ctw-engagement-rings-lgmtc1832-lg-225-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-DUO-LUMIERE/luxe-duo-lumiere-3-8ctw-engagement-rings-lgmtc1832-lg-225-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-SUMMIT/summit-hidden-engagement-rings-lgmtc1495-lg-175-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-SUMMIT/summit-hidden-engagement-rings-lgmtc1495-lg-175-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-DELPHINA-5-8/delphina-5-8ctw-engagement-rings-lgmtc2049-lg-200-rd">
      https://weddingdaydiamonds.com/product-detail/ER-DELPHINA-5-8/delphina-5-8ctw-engagement-rings-lgmtc2049-lg-200-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-AIMEE-PEAR-RD/yellow-gold-aimee-pear-round-1-4ctw-engagement-rings-lgmtc1674-lg-175-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-AIMEE-PEAR-RD/yellow-gold-aimee-pear-round-1-4ctw-engagement-rings-lgmtc1674-lg-175-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-HAVEN-V-SOLITAIRE/haven-v-solitaire-engagement-rings-lgmtc1592-lg-125-em">
      https://weddingdaydiamonds.com/product-detail/ER-HAVEN-V-SOLITAIRE/haven-v-solitaire-engagement-rings-lgmtc1592-lg-125-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-MAYA-PEAR-3-4CTW/luxe-maya-pear-3-4ctw-engagement-rings-lgmtc1972-lg-300-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-MAYA-PEAR-3-4CTW/luxe-maya-pear-3-4ctw-engagement-rings-lgmtc1972-lg-300-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-JASMINE/yellow-gold-jasmine-engagement-rings-lgmtc1670-lg-275-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-JASMINE/yellow-gold-jasmine-engagement-rings-lgmtc1670-lg-275-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MAE-TWIST/rose-gold-mae-twist-3ct-asscher-center-engagement-rings-lgmtc2467-lg-300-as">
      https://weddingdaydiamonds.com/product-detail/ER-TC-MAE-TWIST/rose-gold-mae-twist-3ct-asscher-center-engagement-rings-lgmtc2467-lg-300-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-HARPER/luxe-harper-engagement-rings-lgmtc2092-lg-175-rd">
      https://weddingdaydiamonds.com/product-detail/ER-HARPER/luxe-harper-engagement-rings-lgmtc2092-lg-175-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUCERNE/luxe-lucerne-hidden-engagement-rings-lgmtc2261-lg-225-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUCERNE/luxe-lucerne-hidden-engagement-rings-lgmtc2261-lg-225-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-TIARA/tiara-1-5ctw-engagement-rings-lgmtc1612-lg-225-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-TIARA/tiara-1-5ctw-engagement-rings-lgmtc1612-lg-225-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-TWIST-VENUS/luxe-twist-venus-engagement-rings-lgmtc2241-lg-275-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-TWIST-VENUS/luxe-twist-venus-engagement-rings-lgmtc2241-lg-275-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LEORA-MQ-RD/yellow-gold-leora-marquise-round-3-8ctw-engagement-rings-lgmtc1694-lg-175-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LEORA-MQ-RD/yellow-gold-leora-marquise-round-3-8ctw-engagement-rings-lgmtc1694-lg-175-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-JANAE/janae-engagement-rings-lgmtc1994-lg-300-ov">
      https://weddingdaydiamonds.com/product-detail/ER-JANAE/janae-engagement-rings-lgmtc1994-lg-300-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-CLASSIC-BEZEL-SOL/rose-gold-classic-bezel-solitaire-engagement-rings-lgmtc2255-lg-250-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-CLASSIC-BEZEL-SOL/rose-gold-classic-bezel-solitaire-engagement-rings-lgmtc2255-lg-250-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-AUTUMN-VINE-TRES/yellow-gold-autumn-vine-tres-2-1-2ct-oval-center-engagement-rings-lgmtc2441-lg-250-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TC-AUTUMN-VINE-TRES/yellow-gold-autumn-vine-tres-2-1-2ct-oval-center-engagement-rings-lgmtc2441-lg-250-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-NEURO-EMERALD/neuro-emerald-engagement-rings-lgmtc2086-lg-175-pe">
      https://weddingdaydiamonds.com/product-detail/ER-NEURO-EMERALD/neuro-emerald-engagement-rings-lgmtc2086-lg-175-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-DOMED-4.5MM/modern-domed-4.5mm-engagement-rings-lgmtc1563-lg-300-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-DOMED-4.5MM/modern-domed-4.5mm-engagement-rings-lgmtc1563-lg-300-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-NOUVEAU-BEZEL-SOLITAIRE/nouveau-bezel-solitaire-engagement-rings-lgmtc1599-lg-300-rd">
      https://weddingdaydiamonds.com/product-detail/ER-NOUVEAU-BEZEL-SOLITAIRE/nouveau-bezel-solitaire-engagement-rings-lgmtc1599-lg-300-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-SIENNA/yellow-gold-mini-sienna-1-5ctw-engagement-rings-lgmtc1754-lg-100-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-SIENNA/yellow-gold-mini-sienna-1-5ctw-engagement-rings-lgmtc1754-lg-100-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-MILLIE-SOLITAIRE/millie-solitaire-engagement-rings-lgmtc1532-lg-125-rd">
      https://weddingdaydiamonds.com/product-detail/ER-MILLIE-SOLITAIRE/millie-solitaire-engagement-rings-lgmtc1532-lg-125-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ATLAS/atlas-5-8ctw-engagement-rings-lgmtc1816-lg-400-em">
      https://weddingdaydiamonds.com/product-detail/ER-ATLAS/atlas-5-8ctw-engagement-rings-lgmtc1816-lg-400-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-YVETTE-HIDDEN/yvette-hidden-engagement-rings-lgmtc2214-lg-350-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-YVETTE-HIDDEN/yvette-hidden-engagement-rings-lgmtc2214-lg-350-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/WB-LUXE-7STN-RA-BZL/platinum-seven-radiant-bezel-set-band-3ctw-womens-wedding-bands-lgabp0112">
      https://weddingdaydiamonds.com/product-detail/WB-LUXE-7STN-RA-BZL/platinum-seven-radiant-bezel-set-band-3ctw-womens-wedding-bands-lgabp0112
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LUXE-GALA-SOLITAIRE/luxe-gala-solitaire-engagement-rings-lgmtc1902-lg-225-em">
      https://weddingdaydiamonds.com/product-detail/ER-LUXE-GALA-SOLITAIRE/luxe-gala-solitaire-engagement-rings-lgmtc1902-lg-225-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-HARPER/classic-harper-engagement-rings-lgmtc2097-lg-100-rd">
      https://weddingdaydiamonds.com/product-detail/ER-HARPER/classic-harper-engagement-rings-lgmtc2097-lg-100-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/WB-LUXE-EW-RA-SCALLOP/white-gold-east-west-radiant-scallop-band-4ctw-womens-wedding-bands-lgabw0651">
      https://weddingdaydiamonds.com/product-detail/WB-LUXE-EW-RA-SCALLOP/white-gold-east-west-radiant-scallop-band-4ctw-womens-wedding-bands-lgabw0651
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST/twist-solitaire-engagement-rings-lgmtc1572-lg-275-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST/twist-solitaire-engagement-rings-lgmtc1572-lg-275-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/GRAND15751/14k-rose-gold-1-7-8ctw-grand-collection-engagement-ring-engagement-rings-prbru0013">
      https://weddingdaydiamonds.com/product-detail/GRAND15751/14k-rose-gold-1-7-8ctw-grand-collection-engagement-ring-engagement-rings-prbru0013
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-MAYA-PEAR-3-4CTW/luxe-maya-pear-3-4ctw-engagement-rings-lgmtc1972-lg-100-as">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-MAYA-PEAR-3-4CTW/luxe-maya-pear-3-4ctw-engagement-rings-lgmtc1972-lg-100-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-IRIS/rose-gold-grand-iris-4-1-2ct-elongated-cushion-center-engagement-rings-lgmtc2443-lg-450-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-IRIS/rose-gold-grand-iris-4-1-2ct-elongated-cushion-center-engagement-rings-lgmtc2443-lg-450-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ANGELICA-PEAR-&amp;-ROUND/angelica-pear-and-round-engagement-rings-lgmtc1997-lg-225-cu">
      https://weddingdaydiamonds.com/product-detail/ER-ANGELICA-PEAR-&amp;-ROUND/angelica-pear-and-round-engagement-rings-lgmtc1997-lg-225-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-JULIETTA-HIDDEN/julietta-hidden-engagement-rings-lgmtc2043-lg-500-ov">
      https://weddingdaydiamonds.com/product-detail/ER-JULIETTA-HIDDEN/julietta-hidden-engagement-rings-lgmtc2043-lg-500-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-MQ/yellow-gold-three-stone-marquise-1-7ctw-engagement-rings-lgmtc2293-lg-300-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-MQ/yellow-gold-three-stone-marquise-1-7ctw-engagement-rings-lgmtc2293-lg-300-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1-3ctw-engagement-rings-lgmtc2370-lg-100-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1-3ctw-engagement-rings-lgmtc2370-lg-100-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-TIARA/tiara-1-5ctw-engagement-rings-lgmtc1614-lg-250-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-TIARA/tiara-1-5ctw-engagement-rings-lgmtc1614-lg-250-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-GRAND-ELIZABETH/grand-elizabeth-engagement-rings-lgmtc2009-lg-125-as">
      https://weddingdaydiamonds.com/product-detail/ER-GRAND-ELIZABETH/grand-elizabeth-engagement-rings-lgmtc2009-lg-125-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-DELPHINA-5-8/delphina-5-8ctw-engagement-rings-lgmtc2049-lg-300-pe">
      https://weddingdaydiamonds.com/product-detail/ER-DELPHINA-5-8/delphina-5-8ctw-engagement-rings-lgmtc2049-lg-300-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-7STONE/white-gold-classic-seven-stone-1-3ctw-engagement-rings-lgmtc1653-lg-175-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-7STONE/white-gold-classic-seven-stone-1-3ctw-engagement-rings-lgmtc1653-lg-175-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-BLAIRE-5-8/blaire-5-8ctw-engagement-rings-lgmtc2075-lg-350-pr">
      https://weddingdaydiamonds.com/product-detail/ER-BLAIRE-5-8/blaire-5-8ctw-engagement-rings-lgmtc2075-lg-350-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-1-3-8ctw-engagement-rings-lgmtc2382-lg-175-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-1-3-8ctw-engagement-rings-lgmtc2382-lg-175-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LUXE-BLAIRE-4-5/luxe-blaire-4-5ctw-engagement-rings-lgmtc2052-lg-100-em">
      https://weddingdaydiamonds.com/product-detail/ER-LUXE-BLAIRE-4-5/luxe-blaire-4-5ctw-engagement-rings-lgmtc2052-lg-100-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-COLETTE/colette-1-4ctw-engagement-rings-lgmtc1970-lg-250-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-COLETTE/colette-1-4ctw-engagement-rings-lgmtc1970-lg-250-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-REIGN-PEAR-&amp;-MARQUISE/reign-pear-and-marquise-engagement-rings-lgmtc1980-lg-300-em">
      https://weddingdaydiamonds.com/product-detail/ER-REIGN-PEAR-&amp;-MARQUISE/reign-pear-and-marquise-engagement-rings-lgmtc1980-lg-300-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-SKYLER-THREE-STONE/yellow-gold-skyler-three-stone-3ct-marquise-center-engagement-rings-lgmtc2433-lg-300-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-SKYLER-THREE-STONE/yellow-gold-skyler-three-stone-3ct-marquise-center-engagement-rings-lgmtc2433-lg-300-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/WB-7ST-LGRD-GF/rose-gold-seven-diamond-shared-prong-band-1-3ctw-wedding-bands-lgabr0055">
      https://weddingdaydiamonds.com/product-detail/WB-7ST-LGRD-GF/rose-gold-seven-diamond-shared-prong-band-1-3ctw-wedding-bands-lgabr0055
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-JULIETTA-HIDDEN/julietta-hidden-engagement-rings-lgmtc2045-lg-150-pe">
      https://weddingdaydiamonds.com/product-detail/ER-JULIETTA-HIDDEN/julietta-hidden-engagement-rings-lgmtc2045-lg-150-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ADA-MODERN-HIDDEN/ada-modern-hidden-engagement-rings-lgmtc1864-lg-275-as">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ADA-MODERN-HIDDEN/ada-modern-hidden-engagement-rings-lgmtc1864-lg-275-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ALLURE-BEZEL-SOL/allure-bezel-solitaire-engagement-rings-lgmtc1579-lg-400-ra">
      https://weddingdaydiamonds.com/product-detail/ER-ALLURE-BEZEL-SOL/allure-bezel-solitaire-engagement-rings-lgmtc1579-lg-400-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-PRISCILLA/luxe-priscilla-engagement-rings-lgmtc2225-lg-100-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-PRISCILLA/luxe-priscilla-engagement-rings-lgmtc2225-lg-100-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ELIANA-MQ/platinum-eliana-marquise-1-3ctw-engagement-rings-lgmtc1783-lg-125-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ELIANA-MQ/platinum-eliana-marquise-1-3ctw-engagement-rings-lgmtc1783-lg-125-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-HAZEL-TAPERED/hazel-tapered-4-5ctw-engagement-rings-lgmtc2107-lg-500-rd">
      https://weddingdaydiamonds.com/product-detail/ER-HAZEL-TAPERED/hazel-tapered-4-5ctw-engagement-rings-lgmtc2107-lg-500-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-MODERN-DOMED-3.5mm/modern-domed-3-5mm-engagement-rings-lgmtc1559-lg-125-pe">
      https://weddingdaydiamonds.com/product-detail/ER-MODERN-DOMED-3.5mm/modern-domed-3-5mm-engagement-rings-lgmtc1559-lg-125-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-NELLIE-DECO/nellie-deco-engagement-rings-lgmtc2356-lg-200-ra">
      https://weddingdaydiamonds.com/product-detail/ER-NELLIE-DECO/nellie-deco-engagement-rings-lgmtc2356-lg-200-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-HELIA-HIDDEN/helia-hidden-engagement-rings-lgmtc2180-lg-100-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-HELIA-HIDDEN/helia-hidden-engagement-rings-lgmtc2180-lg-100-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-BREA-HALO-3-8/brea-halo-3-8ctw-engagement-rings-lgmtc1437-lg-100-em">
      https://weddingdaydiamonds.com/product-detail/ER-BREA-HALO-3-8/brea-halo-3-8ctw-engagement-rings-lgmtc1437-lg-100-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-SPLIT-SOLITAIRE/modern-split-solitaire-engagement-rings-lgmtc1543-lg-400-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-SPLIT-SOLITAIRE/modern-split-solitaire-engagement-rings-lgmtc1543-lg-400-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1-2ctw-engagement-rings-lgmtc2394-lg-500-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1-2ctw-engagement-rings-lgmtc2394-lg-500-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-SUMMIT/luxe-summit-hidden-engagement-rings-lgmtc2266-lg-125-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-SUMMIT/luxe-summit-hidden-engagement-rings-lgmtc2266-lg-125-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-GRACIE-HIDDEN/gracie-hidden-engagement-rings-lgmtc1933-lg-200-mq">
      https://weddingdaydiamonds.com/product-detail/ER-GRACIE-HIDDEN/gracie-hidden-engagement-rings-lgmtc1933-lg-200-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-VALENTINA/grand-valentina-hidden-engagement-rings-lgmtc2129-lg-275-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-VALENTINA/grand-valentina-hidden-engagement-rings-lgmtc2129-lg-275-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LALILIQUE/lalilique-engagement-rings-lgmtc1953-lg-225-as">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LALILIQUE/lalilique-engagement-rings-lgmtc1953-lg-225-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST-HIDDEN-HALO/rose-gold-twist-hidden-halo-2-1-2ct-cushion-center-engagement-rings-lgmtc2455-lg-250-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST-HIDDEN-HALO/rose-gold-twist-hidden-halo-2-1-2ct-cushion-center-engagement-rings-lgmtc2455-lg-250-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LUXE-MABEL/luxe-mabel-engagement-rings-lgmtc2116-lg-350-ov">
      https://weddingdaydiamonds.com/product-detail/ER-LUXE-MABEL/luxe-mabel-engagement-rings-lgmtc2116-lg-350-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-CEDAR-HIDDEN/cedar-hidden-engagement-rings-lgmtc2166-lg-225-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-CEDAR-HIDDEN/cedar-hidden-engagement-rings-lgmtc2166-lg-225-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-BLAIRE-5-8/blaire-5-8ctw-engagement-rings-lgmtc2075-lg-400-pe">
      https://weddingdaydiamonds.com/product-detail/ER-BLAIRE-5-8/blaire-5-8ctw-engagement-rings-lgmtc2075-lg-400-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LEO-2-3CTW/leo-2-3ctw-engagement-rings-lgmtc1802-lg-225-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LEO-2-3CTW/leo-2-3ctw-engagement-rings-lgmtc1802-lg-225-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ESME-HIDDEN/esme-hidden-engagement-rings-lgmtc1477-lg-150-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ESME-HIDDEN/esme-hidden-engagement-rings-lgmtc1477-lg-150-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-NESTLE-CATHEDRAL-SOLITAIRE/nestle-cathedral-solitaire-engagement-rings-lgmtc1606-lg-150-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-NESTLE-CATHEDRAL-SOLITAIRE/nestle-cathedral-solitaire-engagement-rings-lgmtc1606-lg-150-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST-HIDDEN-HALO/platinum-twist-hidden-halo-5ct-emerald-center-engagement-rings-lgmtc2458-lg-500-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST-HIDDEN-HALO/platinum-twist-hidden-halo-5ct-emerald-center-engagement-rings-lgmtc2458-lg-500-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-CLASSIC-VALENTINA-HIDDEN/classic-valentina-hidden-engagement-rings-lgmtc2025-lg-100-ra">
      https://weddingdaydiamonds.com/product-detail/ER-CLASSIC-VALENTINA-HIDDEN/classic-valentina-hidden-engagement-rings-lgmtc2025-lg-100-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-GRACIE-THREE-STONE/gracie-three-stone-engagement-rings-lgmtc2350-lg-100-ov">
      https://weddingdaydiamonds.com/product-detail/ER-GRACIE-THREE-STONE/gracie-three-stone-engagement-rings-lgmtc2350-lg-100-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-HANNAH-HIDDEN/classic-hannah-hidden-engagement-rings-lgmtc1412-lg-150-pr">
      https://weddingdaydiamonds.com/product-detail/ER-HANNAH-HIDDEN/classic-hannah-hidden-engagement-rings-lgmtc1412-lg-150-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-THEA-BAGUETTE-&amp;-ROUND/thea-baguette-and-round-engagement-rings-lgmtc2036-lg-150-ra">
      https://weddingdaydiamonds.com/product-detail/ER-THEA-BAGUETTE-&amp;-ROUND/thea-baguette-and-round-engagement-rings-lgmtc2036-lg-150-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-GEMINI-RD-BG/white-gold-gemini-round-baguette-1-4ctw-engagement-rings-lgmtc1685-lg-175-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-GEMINI-RD-BG/white-gold-gemini-round-baguette-1-4ctw-engagement-rings-lgmtc1685-lg-175-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LAINEY/luxe-lainey-1-3ctw-engagement-rings-lgmtc1914-lg-275-em">
      https://weddingdaydiamonds.com/product-detail/ER-LAINEY/luxe-lainey-1-3ctw-engagement-rings-lgmtc1914-lg-275-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ARIELLA-EMERALD/ariella-emerald-engagement-rings-lgmtc1924-lg-275-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ARIELLA-EMERALD/ariella-emerald-engagement-rings-lgmtc1924-lg-275-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-DELPHINE/luxe-delphine-3-8ctw-engagement-rings-lgmtc1840-lg-300-cu">
      https://weddingdaydiamonds.com/product-detail/ER-DELPHINE/luxe-delphine-3-8ctw-engagement-rings-lgmtc1840-lg-300-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-AUTUMN-VINE-TRES/yellow-gold-autumn-vine-tres-5ct-emerald-center-engagement-rings-lgmtc2441-lg-500-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-AUTUMN-VINE-TRES/yellow-gold-autumn-vine-tres-5ct-emerald-center-engagement-rings-lgmtc2441-lg-500-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-DELPHINE/luxe-delphine-3-8ctw-engagement-rings-lgmtc1840-lg-175-ra">
      https://weddingdaydiamonds.com/product-detail/ER-DELPHINE/luxe-delphine-3-8ctw-engagement-rings-lgmtc1840-lg-175-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-CELINE-1-2/celine-1-2ctw-engagement-rings-lgmtc1885-lg-400-cu">
      https://weddingdaydiamonds.com/product-detail/ER-CELINE-1-2/celine-1-2ctw-engagement-rings-lgmtc1885-lg-400-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-SHARED/mini-shared-1-6ctw-engagement-rings-lgmtc1846-lg-225-mq">
      https://weddingdaydiamonds.com/product-detail/ER-SHARED/mini-shared-1-6ctw-engagement-rings-lgmtc1846-lg-225-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LUXURY-SCARLETT/luxury-scarlett-engagement-rings-lgmtc1450-lg-400-pr">
      https://weddingdaydiamonds.com/product-detail/ER-LUXURY-SCARLETT/luxury-scarlett-engagement-rings-lgmtc1450-lg-400-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ADA-MODERN-HIDDEN/ada-modern-hidden-engagement-rings-lgmtc1864-lg-200-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ADA-MODERN-HIDDEN/ada-modern-hidden-engagement-rings-lgmtc1864-lg-200-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ATLAS/classic-atlas-3-8ctw-engagement-rings-lgmtc1812-lg-200-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-ATLAS/classic-atlas-3-8ctw-engagement-rings-lgmtc1812-lg-200-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-GEMMA-BEZEL-SOLITAIRE/platinum-gemma-bezel-solitaire-3ct-pear-center-engagement-rings-lgmtc2466-lg-300-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-GEMMA-BEZEL-SOLITAIRE/platinum-gemma-bezel-solitaire-3ct-pear-center-engagement-rings-lgmtc2466-lg-300-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-VERONA/white-gold-mini-verona-1-5ctw-engagement-rings-lgmtc1769-lg-100-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-VERONA/white-gold-mini-verona-1-5ctw-engagement-rings-lgmtc1769-lg-100-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-DOMED-4.5MM/modern-domed-4.5mm-engagement-rings-lgmtc1560-lg-275-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-DOMED-4.5MM/modern-domed-4.5mm-engagement-rings-lgmtc1560-lg-275-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ELIANA-MQ/yellow-gold-grand-eliana-marquise-1-2ctw-engagement-rings-lgmtc1786-lg-125-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ELIANA-MQ/yellow-gold-grand-eliana-marquise-1-2ctw-engagement-rings-lgmtc1786-lg-125-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LINA/white-gold-lina-1-3ctw-engagement-rings-lgmtc1701-lg-225-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LINA/white-gold-lina-1-3ctw-engagement-rings-lgmtc1701-lg-225-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LINA/yellow-gold-lina-1-3ctw-engagement-rings-lgmtc1702-lg-200-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LINA/yellow-gold-lina-1-3ctw-engagement-rings-lgmtc1702-lg-200-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TRES-OVAL-3-8/tres-oval-3-8ctw-engagement-rings-lgmtc2012-lg-275-as">
      https://weddingdaydiamonds.com/product-detail/ER-TRES-OVAL-3-8/tres-oval-3-8ctw-engagement-rings-lgmtc2012-lg-275-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-GEMMA-BEZEL-SOLITAIRE/yellow-gold-gemma-bezel-solitaire-1-3-4ct-emerald-center-engagement-rings-lgmtc2465-lg-175-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-GEMMA-BEZEL-SOLITAIRE/yellow-gold-gemma-bezel-solitaire-1-3-4ct-emerald-center-engagement-rings-lgmtc2465-lg-175-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-BREA-HALO-3-8/brea-halo-3-8ctw-engagement-rings-lgmtc1437-lg-300-as">
      https://weddingdaydiamonds.com/product-detail/ER-BREA-HALO-3-8/brea-halo-3-8ctw-engagement-rings-lgmtc1437-lg-300-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ATLAS/atlas-5-8ctw-engagement-rings-lgmtc1816-lg-350-ov">
      https://weddingdaydiamonds.com/product-detail/ER-ATLAS/atlas-5-8ctw-engagement-rings-lgmtc1816-lg-350-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ADA-MODERN-SOLITAIRE/ada-modern-solitaire-engagement-rings-lgmtc1528-lg-400-pr">
      https://weddingdaydiamonds.com/product-detail/ER-ADA-MODERN-SOLITAIRE/ada-modern-solitaire-engagement-rings-lgmtc1528-lg-400-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-MILLIE-SOLITAIRE/millie-solitaire-engagement-rings-lgmtc1533-lg-150-em">
      https://weddingdaydiamonds.com/product-detail/ER-MILLIE-SOLITAIRE/millie-solitaire-engagement-rings-lgmtc1533-lg-150-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-SHARED/luxe-mini-shared-1-4ctw-engagement-rings-lgmtc1849-lg-125-ra">
      https://weddingdaydiamonds.com/product-detail/ER-SHARED/luxe-mini-shared-1-4ctw-engagement-rings-lgmtc1849-lg-125-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-DUO-LUMIERE/duo-lumiere-engagement-rings-lgmtc1398-lg-250-em">
      https://weddingdaydiamonds.com/product-detail/ER-DUO-LUMIERE/duo-lumiere-engagement-rings-lgmtc1398-lg-250-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-JUNIPER-HIDDEN-1-2CTW/juniper-hidden-1-2ctw-engagement-rings-lgmtc2126-lg-100-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TC-JUNIPER-HIDDEN-1-2CTW/juniper-hidden-1-2ctw-engagement-rings-lgmtc2126-lg-100-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-DECO-BAGUETTE-THREE-STONE/deco-baguette-three-stone-engagement-rings-lgmtc2343-lg-225-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-DECO-BAGUETTE-THREE-STONE/deco-baguette-three-stone-engagement-rings-lgmtc2343-lg-225-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-DEMI-MARQUISE/demi-marquise-engagement-rings-lgmtc2143-lg-225-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-DEMI-MARQUISE/demi-marquise-engagement-rings-lgmtc2143-lg-225-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-MILLIE-SOLITAIRE/millie-solitaire-engagement-rings-lgmtc1533-lg-500-as">
      https://weddingdaydiamonds.com/product-detail/ER-MILLIE-SOLITAIRE/millie-solitaire-engagement-rings-lgmtc1533-lg-500-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ATLAS/classic-atlas-3-8ctw-engagement-rings-lgmtc1815-lg-100-em">
      https://weddingdaydiamonds.com/product-detail/ER-ATLAS/classic-atlas-3-8ctw-engagement-rings-lgmtc1815-lg-100-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LEORA-MQ-RD/white-gold-leora-marquise-round-3-8ctw-engagement-rings-lgmtc1693-lg-150-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LEORA-MQ-RD/white-gold-leora-marquise-round-3-8ctw-engagement-rings-lgmtc1693-lg-150-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-NEURO-EMERALD/neuro-emerald-engagement-rings-lgmtc2086-lg-225-pr">
      https://weddingdaydiamonds.com/product-detail/ER-NEURO-EMERALD/neuro-emerald-engagement-rings-lgmtc2086-lg-225-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/FR-7ST-LGRD-GF/rose-gold-seven-diamond-shared-prong-band-1-1-2ctw-wedding-bands-lgabr0059-1">
      https://weddingdaydiamonds.com/product-detail/FR-7ST-LGRD-GF/rose-gold-seven-diamond-shared-prong-band-1-1-2ctw-wedding-bands-lgabr0059-1
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-PARIS-BEZEL/white-gold-paris-bezel-4-1-2ct-pear-center-engagement-rings-lgmtc2472-lg-450-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-PARIS-BEZEL/white-gold-paris-bezel-4-1-2ct-pear-center-engagement-rings-lgmtc2472-lg-450-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TRES-OVAL-3-8/tres-oval-3-8ctw-engagement-rings-lgmtc2014-lg-250-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TRES-OVAL-3-8/tres-oval-3-8ctw-engagement-rings-lgmtc2014-lg-250-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ADA-MODERN-HIDDEN/ada-modern-hidden-engagement-rings-lgmtc1863-lg-250-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ADA-MODERN-HIDDEN/ada-modern-hidden-engagement-rings-lgmtc1863-lg-250-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ELIANA-MQ/yellow-gold-eliana-marquise-1-3ctw-engagement-rings-lgmtc1782-lg-150-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ELIANA-MQ/yellow-gold-eliana-marquise-1-3ctw-engagement-rings-lgmtc1782-lg-150-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/WB-LUXE-EW-BZL-OV/platinum-east-west-bezel-oval-band-2ctw-womens-wedding-bands-lgabp0104">
      https://weddingdaydiamonds.com/product-detail/WB-LUXE-EW-BZL-OV/platinum-east-west-bezel-oval-band-2ctw-womens-wedding-bands-lgabp0104
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-SPLIT-HIDDEN-SOLITAIRE/modern-split-hidden-solitaire-engagement-rings-lgmtc1872-lg-400-as">
      https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-SPLIT-HIDDEN-SOLITAIRE/modern-split-hidden-solitaire-engagement-rings-lgmtc1872-lg-400-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-REIGN-PEAR-&amp;-MARQUISE/reign-pear-and-marquise-engagement-rings-lgmtc1982-lg-175-pr">
      https://weddingdaydiamonds.com/product-detail/ER-REIGN-PEAR-&amp;-MARQUISE/reign-pear-and-marquise-engagement-rings-lgmtc1982-lg-175-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-AURORA/luxe-aurora-engagement-rings-lgmtc2070-lg-250-as">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-AURORA/luxe-aurora-engagement-rings-lgmtc2070-lg-250-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-5STONE/platinum-luxury-five-stone-1-3ctw-engagement-rings-lgmtc1647-lg-175-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-5STONE/platinum-luxury-five-stone-1-3ctw-engagement-rings-lgmtc1647-lg-175-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-HARPER/petite-harper-engagement-rings-lgmtc2101-lg-300-pe">
      https://weddingdaydiamonds.com/product-detail/ER-HARPER/petite-harper-engagement-rings-lgmtc2101-lg-300-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/NK-MIXED-DIAMOND-STATION-NECKLACE-2CTW/rose-gold-mixed-diamond-station-necklace-2ctw-necklaces-lgrfn0105">
      https://weddingdaydiamonds.com/product-detail/NK-MIXED-DIAMOND-STATION-NECKLACE-2CTW/rose-gold-mixed-diamond-station-necklace-2ctw-necklaces-lgrfn0105
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-HARPER/petite-harper-engagement-rings-lgmtc2100-lg-175-as">
      https://weddingdaydiamonds.com/product-detail/ER-HARPER/petite-harper-engagement-rings-lgmtc2100-lg-175-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-MAEVE/maeve-engagement-rings-lgmtc2030-lg-275-cu">
      https://weddingdaydiamonds.com/product-detail/ER-MAEVE/maeve-engagement-rings-lgmtc2030-lg-275-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ANGELICA-PEAR-&amp;-ROUND/angelica-pear-and-round-engagement-rings-lgmtc1997-lg-400-as">
      https://weddingdaydiamonds.com/product-detail/ER-ANGELICA-PEAR-&amp;-ROUND/angelica-pear-and-round-engagement-rings-lgmtc1997-lg-400-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUMIERE/grand-lumiere-hidden-engagement-rings-lgmtc2236-lg-300-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUMIERE/grand-lumiere-hidden-engagement-rings-lgmtc2236-lg-300-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LOTUS/lotus-3-8ctw-engagement-rings-lgmtc1887-lg-200-em">
      https://weddingdaydiamonds.com/product-detail/ER-LOTUS/lotus-3-8ctw-engagement-rings-lgmtc1887-lg-200-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LUXURY-SCARLETT/luxury-scarlett-engagement-rings-lgmtc1451-lg-175-as">
      https://weddingdaydiamonds.com/product-detail/ER-LUXURY-SCARLETT/luxury-scarlett-engagement-rings-lgmtc1451-lg-175-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-AC-SUMMIT-HALO-9-10/atia-couture-summit-halo-9-10ctw-engagement-rings-lgmtc1501-lg-150-mq">
      https://weddingdaydiamonds.com/product-detail/ER-AC-SUMMIT-HALO-9-10/atia-couture-summit-halo-9-10ctw-engagement-rings-lgmtc1501-lg-150-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-VINTAGE-CLEMENTINE/vintage-clementine-engagement-rings-lgmtc2175-lg-400-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-VINTAGE-CLEMENTINE/vintage-clementine-engagement-rings-lgmtc2175-lg-400-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-AVA-EMERALD/ava-emerald-engagement-rings-lgmtc2082-lg-175-mq">
      https://weddingdaydiamonds.com/product-detail/ER-AVA-EMERALD/ava-emerald-engagement-rings-lgmtc2082-lg-175-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-JUNIPER-HIDDEN-1-2CTW/juniper-hidden-1-2ctw-engagement-rings-lgmtc2126-lg-225-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-JUNIPER-HIDDEN-1-2CTW/juniper-hidden-1-2ctw-engagement-rings-lgmtc2126-lg-225-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LACEE-1-8/lacee-1-8ctw-engagement-rings-lgmtc2072-lg-250-pr">
      https://weddingdaydiamonds.com/product-detail/ER-LACEE-1-8/lacee-1-8ctw-engagement-rings-lgmtc2072-lg-250-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-PEAR/white-gold-three-stone-pear-1-4ctw-engagement-rings-lgmtc2280-lg-250-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-PEAR/white-gold-three-stone-pear-1-4ctw-engagement-rings-lgmtc2280-lg-250-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TWIST-THREE-STONE/luxe-twist-three-stone-engagement-rings-lgmtc2354-lg-125-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TWIST-THREE-STONE/luxe-twist-three-stone-engagement-rings-lgmtc2354-lg-125-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-PEAR/rose-gold-three-stone-pear-3-8ctw-engagement-rings-lgmtc2319-lg-100-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-PEAR/rose-gold-three-stone-pear-3-8ctw-engagement-rings-lgmtc2319-lg-100-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LINA-MIL/white-gold-lina-milgrain-3-8ctw-engagement-rings-lgmtc1741-lg-225-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LINA-MIL/white-gold-lina-milgrain-3-8ctw-engagement-rings-lgmtc1741-lg-225-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1ctw-engagement-rings-lgmtc2398-lg-500-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1ctw-engagement-rings-lgmtc2398-lg-500-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LUXE-BLAIRE-4-5/luxe-blaire-4-5ctw-engagement-rings-lgmtc2051-lg-350-as">
      https://weddingdaydiamonds.com/product-detail/ER-LUXE-BLAIRE-4-5/luxe-blaire-4-5ctw-engagement-rings-lgmtc2051-lg-350-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-MARA-THREE-STONE/mara-three-stone-engagement-rings-lgmtc2001-lg-100-ov">
      https://weddingdaydiamonds.com/product-detail/ER-MARA-THREE-STONE/mara-three-stone-engagement-rings-lgmtc2001-lg-100-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-BROOK-HIDDEN-SOLITAIRE/brook-hidden-solitaire-engagement-rings-lgmtc1446-lg-175-as">
      https://weddingdaydiamonds.com/product-detail/ER-BROOK-HIDDEN-SOLITAIRE/brook-hidden-solitaire-engagement-rings-lgmtc1446-lg-175-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ALINA/alina-5-8ctw-engagement-rings-lgmtc2134-lg-500-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ALINA/alina-5-8ctw-engagement-rings-lgmtc2134-lg-500-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-HANNAH-HIDDEN/classic-hannah-hidden-engagement-rings-lgmtc1414-lg-100-rd">
      https://weddingdaydiamonds.com/product-detail/ER-HANNAH-HIDDEN/classic-hannah-hidden-engagement-rings-lgmtc1414-lg-100-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-PARIS-BEZEL/white-gold-paris-bezel-2-1-2ct-marquise-center-engagement-rings-lgmtc2472-lg-250-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-PARIS-BEZEL/white-gold-paris-bezel-2-1-2ct-marquise-center-engagement-rings-lgmtc2472-lg-250-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-4.5MM-SOLITAIRE/modern-4.5mm-solitaire-engagement-rings-lgmtc1584-lg-175-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-4.5MM-SOLITAIRE/modern-4.5mm-solitaire-engagement-rings-lgmtc1584-lg-175-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-HAZEL-TAPERED/classic-hazel-tapered-1-2ctw-engagement-rings-lgmtc2103-lg-500-cu">
      https://weddingdaydiamonds.com/product-detail/ER-HAZEL-TAPERED/classic-hazel-tapered-1-2ctw-engagement-rings-lgmtc2103-lg-500-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-EVELYN/evelyn-engagement-rings-lgmtc2042-lg-300-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-EVELYN/evelyn-engagement-rings-lgmtc2042-lg-300-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-CALISTA-LOVE/calista-love-engagement-rings-lgmtc1466-lg-175-pr">
      https://weddingdaydiamonds.com/product-detail/ER-CALISTA-LOVE/calista-love-engagement-rings-lgmtc1466-lg-175-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-AVA-ROUND/luxe-ava-round-engagement-rings-lgmtc2186-lg-250-as">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-AVA-ROUND/luxe-ava-round-engagement-rings-lgmtc2186-lg-250-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-MAYA-MILGRAIN-SOLITAIRE/maya-milgrain-solitaire-engagement-rings-lgmtc1522-lg-300-ov">
      https://weddingdaydiamonds.com/product-detail/ER-MAYA-MILGRAIN-SOLITAIRE/maya-milgrain-solitaire-engagement-rings-lgmtc1522-lg-300-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-DUO-LUMIERE/duo-lumiere-engagement-rings-lgmtc1399-lg-100-cu">
      https://weddingdaydiamonds.com/product-detail/ER-DUO-LUMIERE/duo-lumiere-engagement-rings-lgmtc1399-lg-100-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-PINNACLE/rose-gold-classic-pinnacle-1-3ctw-engagement-rings-lgmtc1632-lg-300-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-PINNACLE/rose-gold-classic-pinnacle-1-3ctw-engagement-rings-lgmtc1632-lg-300-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-HAZEL-TAPERED/classic-hazel-tapered-1-2ctw-engagement-rings-lgmtc2106-lg-100-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-HAZEL-TAPERED/classic-hazel-tapered-1-2ctw-engagement-rings-lgmtc2106-lg-100-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ISLA-HIDDEN-3-8/isla-hidden-3-8ctw-engagement-rings-lgmtc1949-lg-150-cu">
      https://weddingdaydiamonds.com/product-detail/ER-ISLA-HIDDEN-3-8/isla-hidden-3-8ctw-engagement-rings-lgmtc1949-lg-150-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-MODERN-2.5mm-SOLITAIRE/modern-2-5mm-solitaire-engagement-rings-lgmtc1547-lg-200-pr">
      https://weddingdaydiamonds.com/product-detail/ER-MODERN-2.5mm-SOLITAIRE/modern-2-5mm-solitaire-engagement-rings-lgmtc1547-lg-200-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-CELTIC/celtic-solitaire-engagement-rings-lgmtc1519-lg-300-pe">
      https://weddingdaydiamonds.com/product-detail/ER-CELTIC/celtic-solitaire-engagement-rings-lgmtc1519-lg-300-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-AIMEE-PEAR-RD/rose-gold-aimee-pear-round-1-4ctw-engagement-rings-lgmtc1672-lg-150-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-AIMEE-PEAR-RD/rose-gold-aimee-pear-round-1-4ctw-engagement-rings-lgmtc1672-lg-150-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-HELIA-HIDDEN/helia-hidden-engagement-rings-lgmtc2181-lg-125-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-HELIA-HIDDEN/helia-hidden-engagement-rings-lgmtc2181-lg-125-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-EEVEE-1-3/eevee1-3ctw-engagement-rings-lgmtc2004-lg-250-as">
      https://weddingdaydiamonds.com/product-detail/ER-TC-EEVEE-1-3/eevee1-3ctw-engagement-rings-lgmtc2004-lg-250-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-GRACELYN-1-3CTW/gracelyn-1-3ctw-engagement-rings-lgmtc2207-lg-250-as">
      https://weddingdaydiamonds.com/product-detail/ER-TC-GRACELYN-1-3CTW/gracelyn-1-3ctw-engagement-rings-lgmtc2207-lg-250-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LAINEY/luxe-lainey-1-3ctw-engagement-rings-lgmtc1913-lg-350-as">
      https://weddingdaydiamonds.com/product-detail/ER-LAINEY/luxe-lainey-1-3ctw-engagement-rings-lgmtc1913-lg-350-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-CLASSIC-BEZEL-SOL/platinum-classic-bezel-solitaire-engagement-rings-lgmtc2258-lg-225-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-CLASSIC-BEZEL-SOL/platinum-classic-bezel-solitaire-engagement-rings-lgmtc2258-lg-225-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-KALI-EAST-WEST/luxe-kali-east-west-engagement-rings-lgmtc1882-lg-200-ra">
      https://weddingdaydiamonds.com/product-detail/ER-KALI-EAST-WEST/luxe-kali-east-west-engagement-rings-lgmtc1882-lg-200-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-DUO-ESTELLA-5-8/duo-estella-5-8ctw-engagement-rings-lgmtc2055-lg-175-cu">
      https://weddingdaydiamonds.com/product-detail/ER-DUO-ESTELLA-5-8/duo-estella-5-8ctw-engagement-rings-lgmtc2055-lg-175-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-BROOK-HIDDEN-SOLITAIRE/brook-hidden-solitaire-engagement-rings-lgmtc1444-lg-150-ra">
      https://weddingdaydiamonds.com/product-detail/ER-BROOK-HIDDEN-SOLITAIRE/brook-hidden-solitaire-engagement-rings-lgmtc1444-lg-150-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-HIDDEN-RIVER/hidden-river-engagement-rings-lgmtc2152-lg-250-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-HIDDEN-RIVER/hidden-river-engagement-rings-lgmtc2152-lg-250-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LINA/white-gold-lina-1-3ctw-engagement-rings-lgmtc1701-lg-100-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LINA/white-gold-lina-1-3ctw-engagement-rings-lgmtc1701-lg-100-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-SUMMIT/luxe-summit-hidden-engagement-rings-lgmtc2264-lg-100-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-SUMMIT/luxe-summit-hidden-engagement-rings-lgmtc2264-lg-100-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-AUGUST-VINE/august-vine-engagement-rings-lgmtc2017-lg-275-cu">
      https://weddingdaydiamonds.com/product-detail/ER-AUGUST-VINE/august-vine-engagement-rings-lgmtc2017-lg-275-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-WHISPER/grand-whisper-hidden-halo-1-4ctw-engagement-rings-lgmtc1392-lg-250-as">
      https://weddingdaydiamonds.com/product-detail/ER-TC-WHISPER/grand-whisper-hidden-halo-1-4ctw-engagement-rings-lgmtc1392-lg-250-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-EAST-WEST-SOL/platinum-modern-east-west-solitaire-engagement-rings-lgmtc2254-lg-150-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-EAST-WEST-SOL/platinum-modern-east-west-solitaire-engagement-rings-lgmtc2254-lg-150-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-CLASSIC-GALA/classic-gala-engagement-rings-lgmtc1897-lg-125-cu">
      https://weddingdaydiamonds.com/product-detail/ER-CLASSIC-GALA/classic-gala-engagement-rings-lgmtc1897-lg-125-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-FIONA-MQ-RD/platinum-fiona-marquise-round-1-2ctw-engagement-rings-lgmtc1679-lg-200-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-FIONA-MQ-RD/platinum-fiona-marquise-round-1-2ctw-engagement-rings-lgmtc1679-lg-200-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ARIELLE-SUN/yellow-gold-arielle-sun-4-1-2ct-pear-center-engagement-rings-lgmtc2477-lg-450-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ARIELLE-SUN/yellow-gold-arielle-sun-4-1-2ct-pear-center-engagement-rings-lgmtc2477-lg-450-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LUXURY-SCARLETT/luxury-scarlett-engagement-rings-lgmtc1449-lg-100-rd">
      https://weddingdaydiamonds.com/product-detail/ER-LUXURY-SCARLETT/luxury-scarlett-engagement-rings-lgmtc1449-lg-100-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-MODERN-DOMED-3.5mm/modern-domed-3-5mm-engagement-rings-lgmtc1558-lg-200-as">
      https://weddingdaydiamonds.com/product-detail/ER-MODERN-DOMED-3.5mm/modern-domed-3-5mm-engagement-rings-lgmtc1558-lg-200-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ZEPHYRA/zephyra-engagement-rings-lgmtc1956-lg-400-rd">
      https://weddingdaydiamonds.com/product-detail/ER-ZEPHYRA/zephyra-engagement-rings-lgmtc1956-lg-400-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LINA-MIL/white-gold-lina-milgrain-3-8ctw-engagement-rings-lgmtc1741-lg-175-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LINA-MIL/white-gold-lina-milgrain-3-8ctw-engagement-rings-lgmtc1741-lg-175-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-DELPHINA-5-8/delphina-5-8ctw-engagement-rings-lgmtc2049-lg-275-as">
      https://weddingdaydiamonds.com/product-detail/ER-DELPHINA-5-8/delphina-5-8ctw-engagement-rings-lgmtc2049-lg-275-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-COMPASS-HIDDEN-SOLITAIRE/compass-hidden-solitaire-engagement-rings-lgmtc1861-lg-275-ra">
      https://weddingdaydiamonds.com/product-detail/ER-COMPASS-HIDDEN-SOLITAIRE/compass-hidden-solitaire-engagement-rings-lgmtc1861-lg-275-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-AVA-ROUND/luxe-ava-round-engagement-rings-lgmtc2184-lg-100-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-AVA-ROUND/luxe-ava-round-engagement-rings-lgmtc2184-lg-100-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-IRIS/white-gold-iris-hidden-2-1-2ct-round-center-engagement-rings-lgmtc2424-lg-250-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-IRIS/white-gold-iris-hidden-2-1-2ct-round-center-engagement-rings-lgmtc2424-lg-250-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-PETRA-LIGHT/petra-light-engagement-rings-lgmtc1959-lg-300-ov">
      https://weddingdaydiamonds.com/product-detail/ER-PETRA-LIGHT/petra-light-engagement-rings-lgmtc1959-lg-300-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-KALI-EAST-WEST/luxe-kali-east-west-engagement-rings-lgmtc1880-lg-200-pr">
      https://weddingdaydiamonds.com/product-detail/ER-KALI-EAST-WEST/luxe-kali-east-west-engagement-rings-lgmtc1880-lg-200-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-DELPHINE/luxe-delphine-3-8ctw-engagement-rings-lgmtc1839-lg-500-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-DELPHINE/luxe-delphine-3-8ctw-engagement-rings-lgmtc1839-lg-500-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-GRAND-DENALI/grand-denali-engagement-rings-lgmtc2197-lg-300-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-GRAND-DENALI/grand-denali-engagement-rings-lgmtc2197-lg-300-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ANALIA-PEAR-RD/rose-gold-analia-pear-round-1-4ctw-engagement-rings-lgmtc1688-lg-100-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ANALIA-PEAR-RD/rose-gold-analia-pear-round-1-4ctw-engagement-rings-lgmtc1688-lg-100-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-CLASSIC-VALENTINA-HIDDEN/classic-valentina-hidden-engagement-rings-lgmtc2023-lg-400-cu">
      https://weddingdaydiamonds.com/product-detail/ER-CLASSIC-VALENTINA-HIDDEN/classic-valentina-hidden-engagement-rings-lgmtc2023-lg-400-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-GEMINI-RD-BG/rose-gold-gemini-round-baguette-1-4ctw-engagement-rings-lgmtc1684-lg-225-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-GEMINI-RD-BG/rose-gold-gemini-round-baguette-1-4ctw-engagement-rings-lgmtc1684-lg-225-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-AVA-ROUND-HIDDEN/ava-round-hidden-engagement-rings-lgmtc2230-lg-400-as">
      https://weddingdaydiamonds.com/product-detail/ER-TC-AVA-ROUND-HIDDEN/ava-round-hidden-engagement-rings-lgmtc2230-lg-400-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-3-4ctw-engagement-rings-lgmtc2385-lg-100-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-3-4ctw-engagement-rings-lgmtc2385-lg-100-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-PEAR-RD/rose-gold-three-stone-pear-rounds-3-4ctw-engagement-rings-lgmtc2323-lg-250-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-PEAR-RD/rose-gold-three-stone-pear-rounds-3-4ctw-engagement-rings-lgmtc2323-lg-250-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-CELINE-1-2/celine-1-2ctw-engagement-rings-lgmtc1885-lg-150-mq">
      https://weddingdaydiamonds.com/product-detail/ER-CELINE-1-2/celine-1-2ctw-engagement-rings-lgmtc1885-lg-150-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/WB-LUXE-SP-RD-ETR/yellow-gold-shared-prong-round-eternity-3ctw-womens-wedding-bands-lgetr0417">
      https://weddingdaydiamonds.com/product-detail/WB-LUXE-SP-RD-ETR/yellow-gold-shared-prong-round-eternity-3ctw-womens-wedding-bands-lgetr0417
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-SHARED/luxe-mini-shared-1-4ctw-engagement-rings-lgmtc1850-lg-225-pr">
      https://weddingdaydiamonds.com/product-detail/ER-SHARED/luxe-mini-shared-1-4ctw-engagement-rings-lgmtc1850-lg-225-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-NELLIE-DECO/nellie-deco-engagement-rings-lgmtc2356-lg-175-pr">
      https://weddingdaydiamonds.com/product-detail/ER-NELLIE-DECO/nellie-deco-engagement-rings-lgmtc2356-lg-175-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-HAZEL-TAPERED/hazel-tapered-4-5ctw-engagement-rings-lgmtc2110-lg-250-as">
      https://weddingdaydiamonds.com/product-detail/ER-HAZEL-TAPERED/hazel-tapered-4-5ctw-engagement-rings-lgmtc2110-lg-250-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-BOHEME-ARTE/boheme-arte-engagement-rings-lgmtc2232-lg-275-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-BOHEME-ARTE/boheme-arte-engagement-rings-lgmtc2232-lg-275-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LUXURY-ALERIE/luxury-alerie-engagement-rings-lgmtc1937-lg-350-pr">
      https://weddingdaydiamonds.com/product-detail/ER-LUXURY-ALERIE/luxury-alerie-engagement-rings-lgmtc1937-lg-350-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-PETRA-LIGHT/petra-light-engagement-rings-lgmtc1960-lg-400-as">
      https://weddingdaydiamonds.com/product-detail/ER-PETRA-LIGHT/petra-light-engagement-rings-lgmtc1960-lg-400-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ATHENA/athena-engagement-rings-lgmtc1433-lg-175-mq">
      https://weddingdaydiamonds.com/product-detail/ER-ATHENA/athena-engagement-rings-lgmtc1433-lg-175-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-3-4ctw-engagement-rings-lgmtc2364-lg-225-ra">
      https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-3-4ctw-engagement-rings-lgmtc2364-lg-225-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-CELINE-1-2/celine-1-2ctw-engagement-rings-lgmtc1883-lg-150-ra">
      https://weddingdaydiamonds.com/product-detail/ER-CELINE-1-2/celine-1-2ctw-engagement-rings-lgmtc1883-lg-150-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/WB-LUXE-5STN/rose-gold-five-elongated-cushion-band-2ctw-womens-wedding-bands-lgabr0163">
      https://weddingdaydiamonds.com/product-detail/WB-LUXE-5STN/rose-gold-five-elongated-cushion-band-2ctw-womens-wedding-bands-lgabr0163
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-NOVAH-HEAVY/white-gold-novah-heavy-solitaire-7ct-emerald-center-engagement-rings-mwmt0328-lg-700-em">
      https://weddingdaydiamonds.com/product-detail/ER-NOVAH-HEAVY/white-gold-novah-heavy-solitaire-7ct-emerald-center-engagement-rings-mwmt0328-lg-700-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-IVY-1-4/ivy-1-4ctw-engagement-rings-lgmtc2059-lg-150-ov">
      https://weddingdaydiamonds.com/product-detail/ER-IVY-1-4/ivy-1-4ctw-engagement-rings-lgmtc2059-lg-150-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ROSALIE-BAGUETTE-ROUND/rosalie-baguette-round-engagement-rings-lgmtc2189-lg-300-ov">
      https://weddingdaydiamonds.com/product-detail/ER-ROSALIE-BAGUETTE-ROUND/rosalie-baguette-round-engagement-rings-lgmtc2189-lg-300-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-GEMINI-RD-BG/white-gold-gemini-round-baguette-1-4ctw-engagement-rings-lgmtc1685-lg-275-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-GEMINI-RD-BG/white-gold-gemini-round-baguette-1-4ctw-engagement-rings-lgmtc1685-lg-275-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LINA-MIL/yellow-gold-mini-lina-milgrain-1-4ctw-engagement-rings-lgmtc1738-lg-125-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LINA-MIL/yellow-gold-mini-lina-milgrain-1-4ctw-engagement-rings-lgmtc1738-lg-125-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LAYLA-5-8/layla-5-8ctw-engagement-rings-lgmtc2121-lg-400-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-LAYLA-5-8/layla-5-8ctw-engagement-rings-lgmtc2121-lg-400-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ASPEN-SIX-PRONG-SOLITAIRE/aspen-six-prong-solitaire-engagement-rings-lgmtc1538-lg-400-em">
      https://weddingdaydiamonds.com/product-detail/ER-ASPEN-SIX-PRONG-SOLITAIRE/aspen-six-prong-solitaire-engagement-rings-lgmtc1538-lg-400-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-CAROLINA-5-8/carolina-5-8ctw-engagement-rings-lgmtc1943-lg-200-pe">
      https://weddingdaydiamonds.com/product-detail/ER-CAROLINA-5-8/carolina-5-8ctw-engagement-rings-lgmtc1943-lg-200-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-KALI-EAST-WEST/kali-east-west-engagement-rings-lgmtc1878-lg-100-pe">
      https://weddingdaydiamonds.com/product-detail/ER-KALI-EAST-WEST/kali-east-west-engagement-rings-lgmtc1878-lg-100-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-SYDNEY-1-1-5/sydney-1-1-5ctw-engagement-rings-lgmtc1927-lg-300-pe">
      https://weddingdaydiamonds.com/product-detail/ER-SYDNEY-1-1-5/sydney-1-1-5ctw-engagement-rings-lgmtc1927-lg-300-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TRES-OVAL-3-8/tres-oval-3-8ctw-engagement-rings-lgmtc2014-lg-175-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TRES-OVAL-3-8/tres-oval-3-8ctw-engagement-rings-lgmtc2014-lg-175-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-DUO-LUMIERE/luxe-duo-lumiere-3-8ctw-engagement-rings-lgmtc1831-lg-100-pe">
      https://weddingdaydiamonds.com/product-detail/ER-DUO-LUMIERE/luxe-duo-lumiere-3-8ctw-engagement-rings-lgmtc1831-lg-100-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/FR-CLASSIC-BEZEL-CUSHION-1-3-4CTW/white-gold-classic-bezel-cushion-band-1-3-4ctw-fashion-rings-lgwfr0082">
      https://weddingdaydiamonds.com/product-detail/FR-CLASSIC-BEZEL-CUSHION-1-3-4CTW/white-gold-classic-bezel-cushion-band-1-3-4ctw-fashion-rings-lgwfr0082
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-SHARED/mini-shared-1-6ctw-engagement-rings-lgmtc1845-lg-350-cu">
      https://weddingdaydiamonds.com/product-detail/ER-SHARED/mini-shared-1-6ctw-engagement-rings-lgmtc1845-lg-350-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST-HIDDEN-HALO/rose-gold-twist-hidden-halo-5ct-princess-center-engagement-rings-lgmtc2455-lg-500-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST-HIDDEN-HALO/rose-gold-twist-hidden-halo-5ct-princess-center-engagement-rings-lgmtc2455-lg-500-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-SUMMIT/luxe-summit-hidden-engagement-rings-lgmtc2265-lg-500-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-SUMMIT/luxe-summit-hidden-engagement-rings-lgmtc2265-lg-500-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-VERONA/white-gold-mini-verona-1-5ctw-engagement-rings-lgmtc1769-lg-100-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-VERONA/white-gold-mini-verona-1-5ctw-engagement-rings-lgmtc1769-lg-100-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-DELPHINE/luxe-delphine-3-8ctw-engagement-rings-lgmtc1842-lg-300-mq">
      https://weddingdaydiamonds.com/product-detail/ER-DELPHINE/luxe-delphine-3-8ctw-engagement-rings-lgmtc1842-lg-300-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ELIANA-MQ/white-gold-grand-eliana-marquise-1-2ctw-engagement-rings-lgmtc1785-lg-150-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ELIANA-MQ/white-gold-grand-eliana-marquise-1-2ctw-engagement-rings-lgmtc1785-lg-150-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-JANAE/janae-engagement-rings-lgmtc1993-lg-100-mq">
      https://weddingdaydiamonds.com/product-detail/ER-JANAE/janae-engagement-rings-lgmtc1993-lg-100-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-HAILEY-SOLITAIRE/platinum-hailey-solitaire-1-3-4ct-radiant-center-engagement-rings-lgmtc2489-lg-175-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-HAILEY-SOLITAIRE/platinum-hailey-solitaire-1-3-4ct-radiant-center-engagement-rings-lgmtc2489-lg-175-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ROSALIND-HIDDEN/rosalind-hidden-engagement-rings-lgmtc2155-lg-300-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ROSALIND-HIDDEN/rosalind-hidden-engagement-rings-lgmtc2155-lg-300-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LOTUS/lotus-3-8ctw-engagement-rings-lgmtc1887-lg-100-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-LOTUS/lotus-3-8ctw-engagement-rings-lgmtc1887-lg-100-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-AVA-ROUND/luxe-ava-round-engagement-rings-lgmtc2186-lg-250-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-AVA-ROUND/luxe-ava-round-engagement-rings-lgmtc2186-lg-250-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LUXURY-ALERIE/luxury-alerie-engagement-rings-lgmtc1936-lg-275-rd">
      https://weddingdaydiamonds.com/product-detail/ER-LUXURY-ALERIE/luxury-alerie-engagement-rings-lgmtc1936-lg-275-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-BROOK-HIDDEN-SOLITAIRE/brook-hidden-solitaire-engagement-rings-lgmtc1447-lg-125-ra">
      https://weddingdaydiamonds.com/product-detail/ER-BROOK-HIDDEN-SOLITAIRE/brook-hidden-solitaire-engagement-rings-lgmtc1447-lg-125-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-COUTURE-TWIST-HIDDEN/white-gold-couture-twist-hidden-4ct-cushion-center-engagement-rings-lgmtc2436-lg-400-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-COUTURE-TWIST-HIDDEN/white-gold-couture-twist-hidden-4ct-cushion-center-engagement-rings-lgmtc2436-lg-400-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-HELENA-DECO/helena-deco-engagement-rings-lgmtc1602-lg-350-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-HELENA-DECO/helena-deco-engagement-rings-lgmtc1602-lg-350-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TWIST-THREE-STONE/twist-three-stone-1-3ctw-engagement-rings-lgmtc2360-lg-225-em">
      https://weddingdaydiamonds.com/product-detail/ER-TWIST-THREE-STONE/twist-three-stone-1-3ctw-engagement-rings-lgmtc2360-lg-225-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-JUNIPER-HIDDEN-1-2CTW/juniper-hidden-1-2ctw-engagement-rings-lgmtc2124-lg-500-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-JUNIPER-HIDDEN-1-2CTW/juniper-hidden-1-2ctw-engagement-rings-lgmtc2124-lg-500-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1-3ctw-engagement-rings-lgmtc2369-lg-175-as">
      https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1-3ctw-engagement-rings-lgmtc2369-lg-175-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-VALENTINA/luxe-valentina-2-3ctw-engagement-rings-lgmtc1920-lg-400-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-VALENTINA/luxe-valentina-2-3ctw-engagement-rings-lgmtc1920-lg-400-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-AUTUMN-VINE-TRES/white-gold-autumn-vine-tres-5ct-radiant-center-engagement-rings-lgmtc2440-lg-500-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-AUTUMN-VINE-TRES/white-gold-autumn-vine-tres-5ct-radiant-center-engagement-rings-lgmtc2440-lg-500-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-AC-SUMMIT-HALO-9-10/atia-couture-summit-halo-9-10ctw-engagement-rings-lgmtc1501-lg-200-mq">
      https://weddingdaydiamonds.com/product-detail/ER-AC-SUMMIT-HALO-9-10/atia-couture-summit-halo-9-10ctw-engagement-rings-lgmtc1501-lg-200-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-VALLIANT-SOLITAIRE/valliant-solitaire-engagement-rings-lgmtc1580-lg-250-as">
      https://weddingdaydiamonds.com/product-detail/ER-TC-VALLIANT-SOLITAIRE/valliant-solitaire-engagement-rings-lgmtc1580-lg-250-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LEORA-MQ-RD/white-gold-leora-marquise-round-3-8ctw-engagement-rings-lgmtc1693-lg-175-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LEORA-MQ-RD/white-gold-leora-marquise-round-3-8ctw-engagement-rings-lgmtc1693-lg-175-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-KALI-EAST-WEST/kali-east-west-engagement-rings-lgmtc1878-lg-250-cu">
      https://weddingdaydiamonds.com/product-detail/ER-KALI-EAST-WEST/kali-east-west-engagement-rings-lgmtc1878-lg-250-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ESME-HIDDEN/esme-hidden-engagement-rings-lgmtc1479-lg-400-as">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ESME-HIDDEN/esme-hidden-engagement-rings-lgmtc1479-lg-400-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-JANAE/janae-engagement-rings-lgmtc1994-lg-500-ra">
      https://weddingdaydiamonds.com/product-detail/ER-JANAE/janae-engagement-rings-lgmtc1994-lg-500-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LUXE-GALA-SOLITAIRE/luxe-gala-solitaire-engagement-rings-lgmtc1901-lg-175-rd">
      https://weddingdaydiamonds.com/product-detail/ER-LUXE-GALA-SOLITAIRE/luxe-gala-solitaire-engagement-rings-lgmtc1901-lg-175-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-KALI-EAST-WEST/kali-east-west-engagement-rings-lgmtc1877-lg-175-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-KALI-EAST-WEST/kali-east-west-engagement-rings-lgmtc1877-lg-175-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-IMANI-PEAR-&amp;-ROUND/imani-pear-and-round-engagement-rings-lgmtc1975-lg-500-ov">
      https://weddingdaydiamonds.com/product-detail/ER-IMANI-PEAR-&amp;-ROUND/imani-pear-and-round-engagement-rings-lgmtc1975-lg-500-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-CELINE-1-2/celine-1-2ctw-engagement-rings-lgmtc1885-lg-200-ra">
      https://weddingdaydiamonds.com/product-detail/ER-CELINE-1-2/celine-1-2ctw-engagement-rings-lgmtc1885-lg-200-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-NELLIE-DECO/nellie-deco-engagement-rings-lgmtc2357-lg-200-cu">
      https://weddingdaydiamonds.com/product-detail/ER-NELLIE-DECO/nellie-deco-engagement-rings-lgmtc2357-lg-200-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ATLAS/petite-atlas-1-3ctw-engagement-rings-lgmtc1809-lg-400-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-ATLAS/petite-atlas-1-3ctw-engagement-rings-lgmtc1809-lg-400-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LUXE-BLAIRE-4-5/luxe-blaire-4-5ctw-engagement-rings-lgmtc2052-lg-125-ov">
      https://weddingdaydiamonds.com/product-detail/ER-LUXE-BLAIRE-4-5/luxe-blaire-4-5ctw-engagement-rings-lgmtc2052-lg-125-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUCERNE/luxe-lucerne-hidden-engagement-rings-lgmtc2262-lg-350-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUCERNE/luxe-lucerne-hidden-engagement-rings-lgmtc2262-lg-350-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST/twist-solitaire-engagement-rings-lgmtc1575-lg-400-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST/twist-solitaire-engagement-rings-lgmtc1575-lg-400-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-3-4ctw-engagement-rings-lgmtc2364-lg-225-cu">
      https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-3-4ctw-engagement-rings-lgmtc2364-lg-225-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LUXE-MABEL/luxe-mabel-engagement-rings-lgmtc2116-lg-500-cu">
      https://weddingdaydiamonds.com/product-detail/ER-LUXE-MABEL/luxe-mabel-engagement-rings-lgmtc2116-lg-500-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-AVA-ROUND-HIDDEN/ava-round-hidden-engagement-rings-lgmtc2229-lg-175-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-AVA-ROUND-HIDDEN/ava-round-hidden-engagement-rings-lgmtc2229-lg-175-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-5STONE/yellow-gold-luxury-five-stone-1-3ctw-engagement-rings-lgmtc1646-lg-300-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-5STONE/yellow-gold-luxury-five-stone-1-3ctw-engagement-rings-lgmtc1646-lg-300-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ATLAS/classic-atlas-3-8ctw-engagement-rings-lgmtc1812-lg-175-pe">
      https://weddingdaydiamonds.com/product-detail/ER-ATLAS/classic-atlas-3-8ctw-engagement-rings-lgmtc1812-lg-175-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-GRACIE-HIDDEN/gracie-hidden-engagement-rings-lgmtc1933-lg-100-pr">
      https://weddingdaydiamonds.com/product-detail/ER-GRACIE-HIDDEN/gracie-hidden-engagement-rings-lgmtc1933-lg-100-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-3-4ctw-engagement-rings-lgmtc2366-lg-350-ov">
      https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-3-4ctw-engagement-rings-lgmtc2366-lg-350-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-DELPHINE/luxe-delphine-3-8ctw-engagement-rings-lgmtc1840-lg-200-as">
      https://weddingdaydiamonds.com/product-detail/ER-DELPHINE/luxe-delphine-3-8ctw-engagement-rings-lgmtc1840-lg-200-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUCERNE/lucerne-hidden-engagement-rings-lgmtc1499-lg-225-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUCERNE/lucerne-hidden-engagement-rings-lgmtc1499-lg-225-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LACE/rose-gold-luxury-lace-1-2ctw-engagement-rings-lgmtc1720-lg-400-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LACE/rose-gold-luxury-lace-1-2ctw-engagement-rings-lgmtc1720-lg-400-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-BOHEME-ARTE/boheme-arte-engagement-rings-lgmtc2234-lg-100-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-BOHEME-ARTE/boheme-arte-engagement-rings-lgmtc2234-lg-100-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1-3ctw-engagement-rings-lgmtc2367-lg-175-em">
      https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1-3ctw-engagement-rings-lgmtc2367-lg-175-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ALERIE-HIDDEN-HALO/alerie-hidden-halo-engagement-rings-lgmtc1458-lg-500-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-ALERIE-HIDDEN-HALO/alerie-hidden-halo-engagement-rings-lgmtc1458-lg-500-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ALERIE-HIDDEN-HALO/alerie-hidden-halo-engagement-rings-lgmtc1456-lg-225-rd">
      https://weddingdaydiamonds.com/product-detail/ER-ALERIE-HIDDEN-HALO/alerie-hidden-halo-engagement-rings-lgmtc1456-lg-225-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-CEDAR-HIDDEN/cedar-hidden-engagement-rings-lgmtc2165-lg-275-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TC-CEDAR-HIDDEN/cedar-hidden-engagement-rings-lgmtc2165-lg-275-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-HANNAH-HIDDEN/luxe-hannah-hidden-1-2ctw-engagement-rings-lgmtc1410-lg-275-pr">
      https://weddingdaydiamonds.com/product-detail/ER-HANNAH-HIDDEN/luxe-hannah-hidden-1-2ctw-engagement-rings-lgmtc1410-lg-275-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST-HIDDEN-HALO/white-gold-twist-hidden-halo-1-3-4ct-round-center-engagement-rings-lgmtc2456-lg-175-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST-HIDDEN-HALO/white-gold-twist-hidden-halo-1-3-4ct-round-center-engagement-rings-lgmtc2456-lg-175-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-GRAND-DENALI/grand-denali-engagement-rings-lgmtc2195-lg-200-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-GRAND-DENALI/grand-denali-engagement-rings-lgmtc2195-lg-200-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-BG-RD/white-gold-luxe-baguette-round-3-4ctw-engagement-rings-lgmtc1717-lg-250-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-BG-RD/white-gold-luxe-baguette-round-3-4ctw-engagement-rings-lgmtc1717-lg-250-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LINA-MIL/platinum-lina-milgrain-3-8ctw-engagement-rings-lgmtc1743-lg-200-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LINA-MIL/platinum-lina-milgrain-3-8ctw-engagement-rings-lgmtc1743-lg-200-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LINA/platinum-luxury-lina-1-2ctw-engagement-rings-lgmtc1707-lg-200-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LINA/platinum-luxury-lina-1-2ctw-engagement-rings-lgmtc1707-lg-200-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ELIANA-PEAR/white-gold-grand-eliana-pear-3-4ctw-engagement-rings-lgmtc1797-lg-175-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ELIANA-PEAR/white-gold-grand-eliana-pear-3-4ctw-engagement-rings-lgmtc1797-lg-175-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LILY-ENTWINE/white-gold-lily-entwine-2ct-elongated-cushion-center-engagement-rings-lgmtc2483-lg-200-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LILY-ENTWINE/white-gold-lily-entwine-2ct-elongated-cushion-center-engagement-rings-lgmtc2483-lg-200-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST/petite-twist-1-7ctw-engagement-rings-lgmtc1852-lg-350-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST/petite-twist-1-7ctw-engagement-rings-lgmtc1852-lg-350-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-HELENA-DECO/helena-deco-engagement-rings-lgmtc1602-lg-275-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-HELENA-DECO/helena-deco-engagement-rings-lgmtc1602-lg-275-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-PINNACLE/yellow-gold-classic-pinnacle-1-3ctw-engagement-rings-lgmtc1634-lg-200-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-PINNACLE/yellow-gold-classic-pinnacle-1-3ctw-engagement-rings-lgmtc1634-lg-200-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-SPLIT-HIDDEN-SOLITAIRE/modern-split-hidden-solitaire-engagement-rings-lgmtc1872-lg-125-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-SPLIT-HIDDEN-SOLITAIRE/modern-split-hidden-solitaire-engagement-rings-lgmtc1872-lg-125-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LALILIQUE/lalilique-engagement-rings-lgmtc1953-lg-250-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LALILIQUE/lalilique-engagement-rings-lgmtc1953-lg-250-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ALERIE-HIDDEN-HALO/alerie-hidden-halo-engagement-rings-lgmtc1456-lg-200-pe">
      https://weddingdaydiamonds.com/product-detail/ER-ALERIE-HIDDEN-HALO/alerie-hidden-halo-engagement-rings-lgmtc1456-lg-200-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST/petite-twist-1-7ctw-engagement-rings-lgmtc1854-lg-150-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST/petite-twist-1-7ctw-engagement-rings-lgmtc1854-lg-150-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LUXE-BLAIRE-4-5/luxe-blaire-4-5ctw-engagement-rings-lgmtc2052-lg-175-em">
      https://weddingdaydiamonds.com/product-detail/ER-LUXE-BLAIRE-4-5/luxe-blaire-4-5ctw-engagement-rings-lgmtc2052-lg-175-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-CYPRESS-HALO/cypress-halo-engagement-rings-lgmtc1440-lg-175-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-CYPRESS-HALO/cypress-halo-engagement-rings-lgmtc1440-lg-175-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUMIERE/grand-lumiere-hidden-engagement-rings-lgmtc2238-lg-100-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUMIERE/grand-lumiere-hidden-engagement-rings-lgmtc2238-lg-100-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LUXE-EMILIA-1-2/luxe-emilia-1-2ctw-engagement-rings-lgmtc1418-lg-300-em">
      https://weddingdaydiamonds.com/product-detail/ER-LUXE-EMILIA-1-2/luxe-emilia-1-2ctw-engagement-rings-lgmtc1418-lg-300-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-DELPHINA-5-8/delphina-5-8ctw-engagement-rings-lgmtc2049-lg-125-pr">
      https://weddingdaydiamonds.com/product-detail/ER-DELPHINA-5-8/delphina-5-8ctw-engagement-rings-lgmtc2049-lg-125-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-4.5MM-SOLITAIRE/modern-4.5mm-solitaire-engagement-rings-lgmtc1587-lg-300-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-4.5MM-SOLITAIRE/modern-4.5mm-solitaire-engagement-rings-lgmtc1587-lg-300-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-AUTUMN-VINE-TRES/rose-gold-autumn-vine-tres-4ct-princess-center-engagement-rings-lgmtc2439-lg-400-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-AUTUMN-VINE-TRES/rose-gold-autumn-vine-tres-4ct-princess-center-engagement-rings-lgmtc2439-lg-400-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-HEIRESS-HALO/platinum-heiress-halo-1-2ctw-engagement-rings-lgmtc1391-lg-150-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-HEIRESS-HALO/platinum-heiress-halo-1-2ctw-engagement-rings-lgmtc1391-lg-150-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-IRIS/platinum-iris-hidden-5ct-radiant-center-engagement-rings-lgmtc2426-lg-500-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-IRIS/platinum-iris-hidden-5ct-radiant-center-engagement-rings-lgmtc2426-lg-500-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-SYDNEY-1-1-5/sydney-1-1-5ctw-engagement-rings-lgmtc1929-lg-150-ov">
      https://weddingdaydiamonds.com/product-detail/ER-SYDNEY-1-1-5/sydney-1-1-5ctw-engagement-rings-lgmtc1929-lg-150-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-JULES-3-4CTW/jules-3-4ctw-engagement-rings-lgmtc2022-lg-175-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TC-JULES-3-4CTW/jules-3-4ctw-engagement-rings-lgmtc2022-lg-175-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-CEDAR-HIDDEN/cedar-hidden-engagement-rings-lgmtc2164-lg-400-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-CEDAR-HIDDEN/cedar-hidden-engagement-rings-lgmtc2164-lg-400-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-SHARED/mini-shared-1-6ctw-engagement-rings-lgmtc1845-lg-400-rd">
      https://weddingdaydiamonds.com/product-detail/ER-SHARED/mini-shared-1-6ctw-engagement-rings-lgmtc1845-lg-400-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LAINEY/luxe-lainey-1-3ctw-engagement-rings-lgmtc1912-lg-400-em">
      https://weddingdaydiamonds.com/product-detail/ER-LAINEY/luxe-lainey-1-3ctw-engagement-rings-lgmtc1912-lg-400-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-NESTLE-CATHEDRAL-SOLITAIRE/nestle-cathedral-solitaire-engagement-rings-lgmtc1607-lg-500-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-NESTLE-CATHEDRAL-SOLITAIRE/nestle-cathedral-solitaire-engagement-rings-lgmtc1607-lg-500-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-NESTLE-CATHEDRAL-SOLITAIRE/nestle-cathedral-solitaire-engagement-rings-lgmtc1605-lg-150-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-NESTLE-CATHEDRAL-SOLITAIRE/nestle-cathedral-solitaire-engagement-rings-lgmtc1605-lg-150-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-CALISTA-LOVE/calista-love-engagement-rings-lgmtc1466-lg-350-rd">
      https://weddingdaydiamonds.com/product-detail/ER-CALISTA-LOVE/calista-love-engagement-rings-lgmtc1466-lg-350-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-NELLIE-DECO/nellie-deco-engagement-rings-lgmtc2355-lg-150-em">
      https://weddingdaydiamonds.com/product-detail/ER-NELLIE-DECO/nellie-deco-engagement-rings-lgmtc2355-lg-150-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-COMPASS-HIDDEN-SOLITAIRE/compass-hidden-solitaire-engagement-rings-lgmtc1862-lg-300-pr">
      https://weddingdaydiamonds.com/product-detail/ER-COMPASS-HIDDEN-SOLITAIRE/compass-hidden-solitaire-engagement-rings-lgmtc1862-lg-300-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-HARPER/classic-harper-engagement-rings-lgmtc2097-lg-175-cu">
      https://weddingdaydiamonds.com/product-detail/ER-HARPER/classic-harper-engagement-rings-lgmtc2097-lg-175-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-IRIS/yellow-gold-grand-iris-2-1-4ct-princess-center-engagement-rings-lgmtc2445-lg-225-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-IRIS/yellow-gold-grand-iris-2-1-4ct-princess-center-engagement-rings-lgmtc2445-lg-225-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-EEVEE-1-3/eevee1-3ctw-engagement-rings-lgmtc2005-lg-200-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-EEVEE-1-3/eevee1-3ctw-engagement-rings-lgmtc2005-lg-200-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-DELPHINE/luxe-delphine-3-8ctw-engagement-rings-lgmtc1840-lg-150-ov">
      https://weddingdaydiamonds.com/product-detail/ER-DELPHINE/luxe-delphine-3-8ctw-engagement-rings-lgmtc1840-lg-150-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/MWB-TC-EOS-BG-DIA/platinum-eos-baguette-mens-diamond-band-mens-wedding-bands-lgtmb0136">
      https://weddingdaydiamonds.com/product-detail/MWB-TC-EOS-BG-DIA/platinum-eos-baguette-mens-diamond-band-mens-wedding-bands-lgtmb0136
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-5STONE/rose-gold-mini-five-stone-1-6ctw-engagement-rings-lgmtc1640-lg-125-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-5STONE/rose-gold-mini-five-stone-1-6ctw-engagement-rings-lgmtc1640-lg-125-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ANALIA/grand-analia-engagement-rings-lgmtc2203-lg-400-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ANALIA/grand-analia-engagement-rings-lgmtc2203-lg-400-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/MWB-TC-LANDON-BS/yellow-gold-landon-mens-baguette-sapphire-band-mens-wedding-bands-lgtmb0059">
      https://weddingdaydiamonds.com/product-detail/MWB-TC-LANDON-BS/yellow-gold-landon-mens-baguette-sapphire-band-mens-wedding-bands-lgtmb0059
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TWIST-THREE-STONE/twist-three-stone-1-3ctw-engagement-rings-lgmtc2360-lg-150-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TWIST-THREE-STONE/twist-three-stone-1-3ctw-engagement-rings-lgmtc2360-lg-150-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST/twist-halo-engagement-rings-lgmtc1468-lg-300-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST/twist-halo-engagement-rings-lgmtc1468-lg-300-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ESME-HIDDEN/esme-hidden-engagement-rings-lgmtc1479-lg-100-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ESME-HIDDEN/esme-hidden-engagement-rings-lgmtc1479-lg-100-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ADA-MODERN-HIDDEN/ada-modern-hidden-engagement-rings-lgmtc1863-lg-250-as">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ADA-MODERN-HIDDEN/ada-modern-hidden-engagement-rings-lgmtc1863-lg-250-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-COMPASS-HIDDEN-SOLITAIRE/compass-hidden-solitaire-engagement-rings-lgmtc1859-lg-400-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-COMPASS-HIDDEN-SOLITAIRE/compass-hidden-solitaire-engagement-rings-lgmtc1859-lg-400-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-SIENNA/sienna-deluxe-1-2ctw-engagement-rings-lgmtc1761-lg-225-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-SIENNA/sienna-deluxe-1-2ctw-engagement-rings-lgmtc1761-lg-225-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ADA-MODERN-SOLITAIRE/ada-modern-solitaire-engagement-rings-lgmtc1530-lg-350-as">
      https://weddingdaydiamonds.com/product-detail/ER-ADA-MODERN-SOLITAIRE/ada-modern-solitaire-engagement-rings-lgmtc1530-lg-350-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/FR-SIMPLE-TWO-PEAR-1CTW/white-gold-simple-two-pear-1ctw-fashion-rings-lgwfr0018">
      https://weddingdaydiamonds.com/product-detail/FR-SIMPLE-TWO-PEAR-1CTW/white-gold-simple-two-pear-1ctw-fashion-rings-lgwfr0018
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-GRAND-FELICITY/grand-felicity-engagement-rings-lgmtc2193-lg-300-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-GRAND-FELICITY/grand-felicity-engagement-rings-lgmtc2193-lg-300-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-MODERN-ELEGANT-HIDDEN-4.5mm/modern-elegant-hidden-4-5mm-engagement-rings-lgmtc1591-lg-500-mq">
      https://weddingdaydiamonds.com/product-detail/ER-MODERN-ELEGANT-HIDDEN-4.5mm/modern-elegant-hidden-4-5mm-engagement-rings-lgmtc1591-lg-500-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TULIP-SOLITAIRE/tulip-solitaire-engagement-rings-lgmtc1514-lg-300-em">
      https://weddingdaydiamonds.com/product-detail/ER-TULIP-SOLITAIRE/tulip-solitaire-engagement-rings-lgmtc1514-lg-300-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-MAYA-PEAR-3-4CTW/luxe-maya-pear-3-4ctw-engagement-rings-lgmtc1972-lg-300-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-MAYA-PEAR-3-4CTW/luxe-maya-pear-3-4ctw-engagement-rings-lgmtc1972-lg-300-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ALLURE-BEZEL-SOL/allure-bezel-solitaire-engagement-rings-lgmtc1579-lg-275-pr">
      https://weddingdaydiamonds.com/product-detail/ER-ALLURE-BEZEL-SOL/allure-bezel-solitaire-engagement-rings-lgmtc1579-lg-275-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ARIELLE-SUN/platinum-arielle-sun-1-1-4ct-asscher-center-engagement-rings-lgmtc2478-lg-125-as">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ARIELLE-SUN/platinum-arielle-sun-1-1-4ct-asscher-center-engagement-rings-lgmtc2478-lg-125-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-NEURO-EMERALD/neuro-emerald-engagement-rings-lgmtc2083-lg-350-pe">
      https://weddingdaydiamonds.com/product-detail/ER-NEURO-EMERALD/neuro-emerald-engagement-rings-lgmtc2083-lg-350-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LACEE-1-8/lacee-1-8ctw-engagement-rings-lgmtc2073-lg-350-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-LACEE-1-8/lacee-1-8ctw-engagement-rings-lgmtc2073-lg-350-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/FR-VERVE-SOLID/platinum-verve-solid-band-wedding-bands-lpb1520-1">
      https://weddingdaydiamonds.com/product-detail/FR-VERVE-SOLID/platinum-verve-solid-band-wedding-bands-lpb1520-1
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-PARIS-BEZEL/platinum-paris-bezel-1-1-2ct-elongated-cushion-center-engagement-rings-lgmtc2474-lg-150-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-PARIS-BEZEL/platinum-paris-bezel-1-1-2ct-elongated-cushion-center-engagement-rings-lgmtc2474-lg-150-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LACE/yellow-gold-luxury-lace-1-2ctw-engagement-rings-lgmtc1722-lg-125-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LACE/yellow-gold-luxury-lace-1-2ctw-engagement-rings-lgmtc1722-lg-125-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ATLAS/grand-atlas-9-10ctw-engagement-rings-lgmtc1821-lg-400-mq">
      https://weddingdaydiamonds.com/product-detail/ER-ATLAS/grand-atlas-9-10ctw-engagement-rings-lgmtc1821-lg-400-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-CLASSIC-GALA/classic-gala-engagement-rings-lgmtc1898-lg-125-pr">
      https://weddingdaydiamonds.com/product-detail/ER-CLASSIC-GALA/classic-gala-engagement-rings-lgmtc1898-lg-125-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LUXE-MODERN-SPLIT-HIDDEN/luxe-modern-split-hidden-engagement-rings-lgmtc1906-lg-350-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-LUXE-MODERN-SPLIT-HIDDEN/luxe-modern-split-hidden-engagement-rings-lgmtc1906-lg-350-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LINA/yellow-gold-lina-1-3ctw-engagement-rings-lgmtc1702-lg-300-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LINA/yellow-gold-lina-1-3ctw-engagement-rings-lgmtc1702-lg-300-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ATLAS/luxury-atlas-1-1-5ctw-engagement-rings-lgmtc1826-lg-275-ra">
      https://weddingdaydiamonds.com/product-detail/ER-ATLAS/luxury-atlas-1-1-5ctw-engagement-rings-lgmtc1826-lg-275-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-GRAND-DENALI/grand-denali-engagement-rings-lgmtc2196-lg-300-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-GRAND-DENALI/grand-denali-engagement-rings-lgmtc2196-lg-300-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-TWIST-VENUS/luxe-twist-venus-engagement-rings-lgmtc2240-lg-350-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-TWIST-VENUS/luxe-twist-venus-engagement-rings-lgmtc2240-lg-350-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-HIDDEN-RIVER/hidden-river-engagement-rings-lgmtc2151-lg-150-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TC-HIDDEN-RIVER/hidden-river-engagement-rings-lgmtc2151-lg-150-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-CELTIC/celtic-hidden-engagement-rings-lgmtc1424-lg-300-as">
      https://weddingdaydiamonds.com/product-detail/ER-CELTIC/celtic-hidden-engagement-rings-lgmtc1424-lg-300-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-REMI-KITE-SOLITAIRE/remi-kite-solitaire-engagement-rings-lgmtc1524-lg-275-as">
      https://weddingdaydiamonds.com/product-detail/ER-REMI-KITE-SOLITAIRE/remi-kite-solitaire-engagement-rings-lgmtc1524-lg-275-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-BG-RD/white-gold-classic-baguette-round-3-8ctw-engagement-rings-lgmtc1713-lg-200-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-BG-RD/white-gold-classic-baguette-round-3-8ctw-engagement-rings-lgmtc1713-lg-200-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-YVETTE-HIDDEN/yvette-hidden-engagement-rings-lgmtc2212-lg-300-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-YVETTE-HIDDEN/yvette-hidden-engagement-rings-lgmtc2212-lg-300-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-BLAIRE-5-8/blaire-5-8ctw-engagement-rings-lgmtc2075-lg-150-ov">
      https://weddingdaydiamonds.com/product-detail/ER-BLAIRE-5-8/blaire-5-8ctw-engagement-rings-lgmtc2075-lg-150-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-KALI-EAST-WEST/luxe-kali-east-west-engagement-rings-lgmtc1879-lg-225-cu">
      https://weddingdaydiamonds.com/product-detail/ER-KALI-EAST-WEST/luxe-kali-east-west-engagement-rings-lgmtc1879-lg-225-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ADA-MODERN-SOLITAIRE/ada-modern-solitaire-engagement-rings-lgmtc1528-lg-350-ra">
      https://weddingdaydiamonds.com/product-detail/ER-ADA-MODERN-SOLITAIRE/ada-modern-solitaire-engagement-rings-lgmtc1528-lg-350-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-SHARED/mini-shared-1-6ctw-engagement-rings-lgmtc1845-lg-200-as">
      https://weddingdaydiamonds.com/product-detail/ER-SHARED/mini-shared-1-6ctw-engagement-rings-lgmtc1845-lg-200-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-NOUVEAU-BEZEL-SOLITAIRE/nouveau-bezel-solitaire-engagement-rings-lgmtc1597-lg-400-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-NOUVEAU-BEZEL-SOLITAIRE/nouveau-bezel-solitaire-engagement-rings-lgmtc1597-lg-400-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST/twist-solitaire-engagement-rings-lgmtc1572-lg-250-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST/twist-solitaire-engagement-rings-lgmtc1572-lg-250-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-3-4ctw-engagement-rings-lgmtc2385-lg-350-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-3-4ctw-engagement-rings-lgmtc2385-lg-350-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-GRAND-DENALI/grand-denali-engagement-rings-lgmtc2197-lg-200-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TC-GRAND-DENALI/grand-denali-engagement-rings-lgmtc2197-lg-200-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LUXURY-ALERIE/luxury-alerie-engagement-rings-lgmtc1935-lg-300-pe">
      https://weddingdaydiamonds.com/product-detail/ER-LUXURY-ALERIE/luxury-alerie-engagement-rings-lgmtc1935-lg-300-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1-2ctw-engagement-rings-lgmtc2392-lg-275-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1-2ctw-engagement-rings-lgmtc2392-lg-275-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ELIANA-MQ/platinum-eliana-marquise-1-3ctw-engagement-rings-lgmtc1783-lg-225-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ELIANA-MQ/platinum-eliana-marquise-1-3ctw-engagement-rings-lgmtc1783-lg-225-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-CLASSIC-GALA/classic-gala-engagement-rings-lgmtc1895-lg-125-ra">
      https://weddingdaydiamonds.com/product-detail/ER-CLASSIC-GALA/classic-gala-engagement-rings-lgmtc1895-lg-125-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-WHISPER/yellow-gold-grand-whisper-hidden-halo-1-4ctw-engagement-rings-lgmtc1394-lg-100-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TC-WHISPER/yellow-gold-grand-whisper-hidden-halo-1-4ctw-engagement-rings-lgmtc1394-lg-100-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/FR-HANNAH-SHARED-PRONG-BAND/luxe-hannah-shared-prong-band-1-2ctw-wedding-bands-lgbtc0318-1">
      https://weddingdaydiamonds.com/product-detail/FR-HANNAH-SHARED-PRONG-BAND/luxe-hannah-shared-prong-band-1-2ctw-wedding-bands-lgbtc0318-1
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-BG-RD/yellow-gold-classic-baguette-round-3-8ctw-engagement-rings-lgmtc1714-lg-125-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-BG-RD/yellow-gold-classic-baguette-round-3-8ctw-engagement-rings-lgmtc1714-lg-125-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LINA/white-gold-lina-1-3ctw-engagement-rings-lgmtc1701-lg-200-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LINA/white-gold-lina-1-3ctw-engagement-rings-lgmtc1701-lg-200-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-HAZEL-TAPERED/hazel-tapered-4-5ctw-engagement-rings-lgmtc2110-lg-150-ov">
      https://weddingdaydiamonds.com/product-detail/ER-HAZEL-TAPERED/hazel-tapered-4-5ctw-engagement-rings-lgmtc2110-lg-150-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LUXE-GALA-SOLITAIRE/luxe-gala-solitaire-engagement-rings-lgmtc1902-lg-350-as">
      https://weddingdaydiamonds.com/product-detail/ER-LUXE-GALA-SOLITAIRE/luxe-gala-solitaire-engagement-rings-lgmtc1902-lg-350-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-JASMINE/white-gold-jasmine-engagement-rings-lgmtc1669-lg-150-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-JASMINE/white-gold-jasmine-engagement-rings-lgmtc1669-lg-150-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-WHISPER/grand-whisper-hidden-halo-1-4ctw-engagement-rings-lgmtc1393-lg-400-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-WHISPER/grand-whisper-hidden-halo-1-4ctw-engagement-rings-lgmtc1393-lg-400-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-IRIS/yellow-gold-grand-iris-2-1-2ct-round-center-engagement-rings-lgmtc2445-lg-250-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-IRIS/yellow-gold-grand-iris-2-1-2ct-round-center-engagement-rings-lgmtc2445-lg-250-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-2-3ctw-engagement-rings-lgmtc2371-lg-200-pe">
      https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-2-3ctw-engagement-rings-lgmtc2371-lg-200-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST/twist-solitaire-engagement-rings-lgmtc1573-lg-200-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST/twist-solitaire-engagement-rings-lgmtc1573-lg-200-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LYRIC-PEAR-HALO/lyric-pear-halo-engagement-rings-lgmtc1403-lg-175-as">
      https://weddingdaydiamonds.com/product-detail/ER-LYRIC-PEAR-HALO/lyric-pear-halo-engagement-rings-lgmtc1403-lg-175-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-VINTAGE-CLEMENTINE/vintage-clementine-engagement-rings-lgmtc2176-lg-200-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-VINTAGE-CLEMENTINE/vintage-clementine-engagement-rings-lgmtc2176-lg-200-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-MQ/platinum-mini-marquise-three-stone-1-10ctw-engagement-rings-lgmtc2290-lg-100-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-MQ/platinum-mini-marquise-three-stone-1-10ctw-engagement-rings-lgmtc2290-lg-100-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-7STONE/platinum-classic-seven-stone-1-3ctw-engagement-rings-lgmtc1655-lg-150-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-7STONE/platinum-classic-seven-stone-1-3ctw-engagement-rings-lgmtc1655-lg-150-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MACY-HIDDEN/macy-hidden-engagement-rings-lgmtc1488-lg-175-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-MACY-HIDDEN/macy-hidden-engagement-rings-lgmtc1488-lg-175-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-GRAND-DENALI/grand-denali-engagement-rings-lgmtc2195-lg-500-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-GRAND-DENALI/grand-denali-engagement-rings-lgmtc2195-lg-500-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-BLAIRE-5-8/blaire-5-8ctw-engagement-rings-lgmtc2076-lg-175-ov">
      https://weddingdaydiamonds.com/product-detail/ER-BLAIRE-5-8/blaire-5-8ctw-engagement-rings-lgmtc2076-lg-175-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ELIANA-MQ/platinum-grand-eliana-marquise-1-2ctw-engagement-rings-lgmtc1787-lg-225-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ELIANA-MQ/platinum-grand-eliana-marquise-1-2ctw-engagement-rings-lgmtc1787-lg-225-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-JUNIPER-HIDDEN-1-2CTW/juniper-hidden-1-2ctw-engagement-rings-lgmtc2124-lg-200-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-JUNIPER-HIDDEN-1-2CTW/juniper-hidden-1-2ctw-engagement-rings-lgmtc2124-lg-200-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ANALIA-PEAR-RD/platinum-analia-pear-round-1-4ctw-engagement-rings-lgmtc1691-lg-275-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ANALIA-PEAR-RD/platinum-analia-pear-round-1-4ctw-engagement-rings-lgmtc1691-lg-275-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-PEAR-RD/rose-gold-three-stone-pear-rounds-3-4ctw-engagement-rings-lgmtc2323-lg-125-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-PEAR-RD/rose-gold-three-stone-pear-rounds-3-4ctw-engagement-rings-lgmtc2323-lg-125-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-REMI-KITE-HIDDEN-SOLITAIRE/remi-kite-hidden-solitaire-engagement-rings-lgmtc1428-lg-400-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-REMI-KITE-HIDDEN-SOLITAIRE/remi-kite-hidden-solitaire-engagement-rings-lgmtc1428-lg-400-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/BRAC-ROUND-BEZEL-3-1-5CTW/yellow-gold-round-bezel-bracelet-3-1-5ctw-bracelets-lgbt0127">
      https://weddingdaydiamonds.com/product-detail/BRAC-ROUND-BEZEL-3-1-5CTW/yellow-gold-round-bezel-bracelet-3-1-5ctw-bracelets-lgbt0127
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-VALENTINA/luxe-valentina-2-3ctw-engagement-rings-lgmtc1920-lg-150-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-VALENTINA/luxe-valentina-2-3ctw-engagement-rings-lgmtc1920-lg-150-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-NOVAH-HEAVY/platinum-novah-heavy-hidden-solitaire-3-1-2ct-radiant-center-engagement-rings-mplts0065-lg-350-rd">
      https://weddingdaydiamonds.com/product-detail/ER-NOVAH-HEAVY/platinum-novah-heavy-hidden-solitaire-3-1-2ct-radiant-center-engagement-rings-mplts0065-lg-350-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ESME-HIDDEN/esme-hidden-engagement-rings-lgmtc1477-lg-275-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ESME-HIDDEN/esme-hidden-engagement-rings-lgmtc1477-lg-275-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-2-3ctw-engagement-rings-lgmtc2372-lg-175-pe">
      https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-2-3ctw-engagement-rings-lgmtc2372-lg-175-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST/twist-halo-engagement-rings-lgmtc1469-lg-400-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST/twist-halo-engagement-rings-lgmtc1469-lg-400-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MAGNOLIA-VINE/rose-gold-magnolia-vine-5ct-pear-center-engagement-rings-lgmtc2427-lg-500-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-MAGNOLIA-VINE/rose-gold-magnolia-vine-5ct-pear-center-engagement-rings-lgmtc2427-lg-500-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/WB-LUXE-7STN-EM-BZL/yellow-gold-seven-emerald-bezel-set-band-3ctw-womens-wedding-bands-lgaby0264">
      https://weddingdaydiamonds.com/product-detail/WB-LUXE-7STN-EM-BZL/yellow-gold-seven-emerald-bezel-set-band-3ctw-womens-wedding-bands-lgaby0264
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-CAROLINA-5-8/carolina-5-8ctw-engagement-rings-lgmtc1943-lg-500-as">
      https://weddingdaydiamonds.com/product-detail/ER-CAROLINA-5-8/carolina-5-8ctw-engagement-rings-lgmtc1943-lg-500-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-CAROLINA-5-8/carolina-5-8ctw-engagement-rings-lgmtc1943-lg-150-pr">
      https://weddingdaydiamonds.com/product-detail/ER-CAROLINA-5-8/carolina-5-8ctw-engagement-rings-lgmtc1943-lg-150-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-GRACIE-THREE-STONE/gracie-three-stone-engagement-rings-lgmtc2348-lg-300-em">
      https://weddingdaydiamonds.com/product-detail/ER-GRACIE-THREE-STONE/gracie-three-stone-engagement-rings-lgmtc2348-lg-300-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-CEDAR-HIDDEN/cedar-hidden-engagement-rings-lgmtc2165-lg-200-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-CEDAR-HIDDEN/cedar-hidden-engagement-rings-lgmtc2165-lg-200-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-CLASSIC-GALA/classic-gala-engagement-rings-lgmtc1895-lg-150-pe">
      https://weddingdaydiamonds.com/product-detail/ER-CLASSIC-GALA/classic-gala-engagement-rings-lgmtc1895-lg-150-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ANALIA/grand-analia-engagement-rings-lgmtc2205-lg-100-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ANALIA/grand-analia-engagement-rings-lgmtc2205-lg-100-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LINA-MIL/platinum-mini-lina-milgrain-1-4ctw-engagement-rings-lgmtc1739-lg-125-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LINA-MIL/platinum-mini-lina-milgrain-1-4ctw-engagement-rings-lgmtc1739-lg-125-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-BG/yellow-gold-three-stone-tapered-baguette-1-3ctw-engagement-rings-lgmtc2305-lg-125-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-BG/yellow-gold-three-stone-tapered-baguette-1-3ctw-engagement-rings-lgmtc2305-lg-125-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ALLURE-BEZEL-SOL/allure-hidden-solitaire-engagement-rings-lgmtc1463-lg-400-pr">
      https://weddingdaydiamonds.com/product-detail/ER-ALLURE-BEZEL-SOL/allure-hidden-solitaire-engagement-rings-lgmtc1463-lg-400-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LUXE-MABEL/luxe-mabel-engagement-rings-lgmtc2118-lg-225-pe">
      https://weddingdaydiamonds.com/product-detail/ER-LUXE-MABEL/luxe-mabel-engagement-rings-lgmtc2118-lg-225-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LYRA-CURVED-1-3/lyra-curved-1-3ctw-engagement-rings-lgmtc1893-lg-100-em">
      https://weddingdaydiamonds.com/product-detail/ER-LYRA-CURVED-1-3/lyra-curved-1-3ctw-engagement-rings-lgmtc1893-lg-100-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-VERONA/yellow-gold-verona-marquise-round-3-8ctw-engagement-rings-lgmtc1774-lg-150-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TC-VERONA/yellow-gold-verona-marquise-round-3-8ctw-engagement-rings-lgmtc1774-lg-150-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-KALI-EAST-WEST/kali-east-west-engagement-rings-lgmtc1878-lg-125-pr">
      https://weddingdaydiamonds.com/product-detail/ER-KALI-EAST-WEST/kali-east-west-engagement-rings-lgmtc1878-lg-125-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-SUMMIT/luxe-summit-hidden-engagement-rings-lgmtc2264-lg-300-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-SUMMIT/luxe-summit-hidden-engagement-rings-lgmtc2264-lg-300-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-JASMINE/yellow-gold-jasmine-engagement-rings-lgmtc1670-lg-100-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-JASMINE/yellow-gold-jasmine-engagement-rings-lgmtc1670-lg-100-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-DELPHINE/classic-delphine-engagement-rings-lgmtc1837-lg-125-cu">
      https://weddingdaydiamonds.com/product-detail/ER-DELPHINE/classic-delphine-engagement-rings-lgmtc1837-lg-125-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-4.5MM-SOLITAIRE/modern-4.5mm-solitaire-engagement-rings-lgmtc1584-lg-225-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-4.5MM-SOLITAIRE/modern-4.5mm-solitaire-engagement-rings-lgmtc1584-lg-225-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-REIGN-PEAR-&amp;-MARQUISE/reign-pear-and-marquise-engagement-rings-lgmtc1980-lg-250-ov">
      https://weddingdaydiamonds.com/product-detail/ER-REIGN-PEAR-&amp;-MARQUISE/reign-pear-and-marquise-engagement-rings-lgmtc1980-lg-250-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-SIENNA/rose-gold-sienna-luxe-3-4ctw-engagement-rings-lgmtc1764-lg-125-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-SIENNA/rose-gold-sienna-luxe-3-4ctw-engagement-rings-lgmtc1764-lg-125-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/DC8HP/platinum-8mm-heavy-dome-comfort-fit-band-mpb1825">
      https://weddingdaydiamonds.com/product-detail/DC8HP/platinum-8mm-heavy-dome-comfort-fit-band-mpb1825
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ATLAS/grand-atlas-9-10ctw-engagement-rings-lgmtc1822-lg-275-pr">
      https://weddingdaydiamonds.com/product-detail/ER-ATLAS/grand-atlas-9-10ctw-engagement-rings-lgmtc1822-lg-275-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-DEMI/demi-1-5ctw-engagement-rings-lgmtc1751-lg-150-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-DEMI/demi-1-5ctw-engagement-rings-lgmtc1751-lg-150-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-CAROLINA-5-8/carolina-5-8ctw-engagement-rings-lgmtc1943-lg-150-em">
      https://weddingdaydiamonds.com/product-detail/ER-CAROLINA-5-8/carolina-5-8ctw-engagement-rings-lgmtc1943-lg-150-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-VALENTINA/luxe-valentina-2-3ctw-engagement-rings-lgmtc1922-lg-250-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-VALENTINA/luxe-valentina-2-3ctw-engagement-rings-lgmtc1922-lg-250-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LILY-PEAR-RD/yellow-gold-lily-pear-round-engagement-rings-lgmtc1662-lg-125-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LILY-PEAR-RD/yellow-gold-lily-pear-round-engagement-rings-lgmtc1662-lg-125-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LAINEY/luxe-lainey-1-3ctw-engagement-rings-lgmtc1914-lg-200-ra">
      https://weddingdaydiamonds.com/product-detail/ER-LAINEY/luxe-lainey-1-3ctw-engagement-rings-lgmtc1914-lg-200-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ATLAS/grand-atlas-9-10ctw-engagement-rings-lgmtc1820-lg-300-ra">
      https://weddingdaydiamonds.com/product-detail/ER-ATLAS/grand-atlas-9-10ctw-engagement-rings-lgmtc1820-lg-300-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LYRA-CURVED-1-3/lyra-curved-1-3ctw-engagement-rings-lgmtc1891-lg-150-ov">
      https://weddingdaydiamonds.com/product-detail/ER-LYRA-CURVED-1-3/lyra-curved-1-3ctw-engagement-rings-lgmtc1891-lg-150-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-PRISCILLA/luxe-priscilla-engagement-rings-lgmtc2226-lg-225-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-PRISCILLA/luxe-priscilla-engagement-rings-lgmtc2226-lg-225-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-VINTAGE-CLEMENTINE/vintage-clementine-engagement-rings-lgmtc2177-lg-100-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-VINTAGE-CLEMENTINE/vintage-clementine-engagement-rings-lgmtc2177-lg-100-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TRES-OVAL-3-8/tres-oval-3-8ctw-engagement-rings-lgmtc2014-lg-350-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TRES-OVAL-3-8/tres-oval-3-8ctw-engagement-rings-lgmtc2014-lg-350-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-HEIRESS-HALO/heiress-halo-1-2ctw-engagement-rings-lgmtc1390-lg-225-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-HEIRESS-HALO/heiress-halo-1-2ctw-engagement-rings-lgmtc1390-lg-225-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-MQ/platinum-three-stone-marquise-1-7ctw-engagement-rings-lgmtc2294-lg-225-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-MQ/platinum-three-stone-marquise-1-7ctw-engagement-rings-lgmtc2294-lg-225-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-REMI-KITE-SOLITAIRE/remi-kite-solitaire-engagement-rings-lgmtc1527-lg-275-cu">
      https://weddingdaydiamonds.com/product-detail/ER-REMI-KITE-SOLITAIRE/remi-kite-solitaire-engagement-rings-lgmtc1527-lg-275-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MACY-HIDDEN/macy-hidden-engagement-rings-lgmtc1490-lg-300-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-MACY-HIDDEN/macy-hidden-engagement-rings-lgmtc1490-lg-300-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-AVALON/avalon-engagement-rings-lgmtc2114-lg-250-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-AVALON/avalon-engagement-rings-lgmtc2114-lg-250-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-EMMA-DECO/emma-deco-engagement-rings-lgmtc2065-lg-100-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-EMMA-DECO/emma-deco-engagement-rings-lgmtc2065-lg-100-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-BROOK-HIDDEN-SOLITAIRE/brook-hidden-solitaire-engagement-rings-lgmtc1447-lg-275-ov">
      https://weddingdaydiamonds.com/product-detail/ER-BROOK-HIDDEN-SOLITAIRE/brook-hidden-solitaire-engagement-rings-lgmtc1447-lg-275-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-SOLANA-HIDDEN/solana-hidden-engagement-rings-lgmtc2162-lg-400-cu">
      https://weddingdaydiamonds.com/product-detail/ER-SOLANA-HIDDEN/solana-hidden-engagement-rings-lgmtc2162-lg-400-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-AUTUMN-VINE-SOLITAIRE/autumn-vine-solitaire-engagement-rings-lgmtc1482-lg-300-as">
      https://weddingdaydiamonds.com/product-detail/ER-TC-AUTUMN-VINE-SOLITAIRE/autumn-vine-solitaire-engagement-rings-lgmtc1482-lg-300-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-BG/platinum-three-stone-tapered-baguette-1-3ctw-engagement-rings-lgmtc2306-lg-225-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-BG/platinum-three-stone-tapered-baguette-1-3ctw-engagement-rings-lgmtc2306-lg-225-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-GRAND-AVALON/grand-avalon-engagement-rings-lgmtc2170-lg-275-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-GRAND-AVALON/grand-avalon-engagement-rings-lgmtc2170-lg-275-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-EVELYN/evelyn-engagement-rings-lgmtc2041-lg-125-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-EVELYN/evelyn-engagement-rings-lgmtc2041-lg-125-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-GRACIE-HIDDEN/gracie-hidden-engagement-rings-lgmtc1934-lg-500-ra">
      https://weddingdaydiamonds.com/product-detail/ER-GRACIE-HIDDEN/gracie-hidden-engagement-rings-lgmtc1934-lg-500-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-floral-twist-THREE-STONE/floral-twist-three-stone-engagement-rings-lgmtc2216-lg-225-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-floral-twist-THREE-STONE/floral-twist-three-stone-engagement-rings-lgmtc2216-lg-225-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-GRAND-FELICITY/grand-felicity-engagement-rings-lgmtc2193-lg-400-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-GRAND-FELICITY/grand-felicity-engagement-rings-lgmtc2193-lg-400-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1-2ctw-engagement-rings-lgmtc2394-lg-350-as">
      https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1-2ctw-engagement-rings-lgmtc2394-lg-350-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-PEAR/rose-gold-three-stone-pear-3-8ctw-engagement-rings-lgmtc2319-lg-125-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-PEAR/rose-gold-three-stone-pear-3-8ctw-engagement-rings-lgmtc2319-lg-125-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LUXURY-SCARLETT/luxury-scarlett-engagement-rings-lgmtc1450-lg-400-pe">
      https://weddingdaydiamonds.com/product-detail/ER-LUXURY-SCARLETT/luxury-scarlett-engagement-rings-lgmtc1450-lg-400-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-HAZEL-TAPERED/hazel-tapered-4-5ctw-engagement-rings-lgmtc2109-lg-225-em">
      https://weddingdaydiamonds.com/product-detail/ER-HAZEL-TAPERED/hazel-tapered-4-5ctw-engagement-rings-lgmtc2109-lg-225-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-BG-RD/platinum-mini-baguette-round-1-4ctw-engagement-rings-lgmtc1711-lg-150-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-BG-RD/platinum-mini-baguette-round-1-4ctw-engagement-rings-lgmtc1711-lg-150-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-2-3ctw-engagement-rings-lgmtc2374-lg-125-em">
      https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-2-3ctw-engagement-rings-lgmtc2374-lg-125-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-CLASSIC-BEZEL-SOL/yellow-gold-classic-bezel-solitaire-engagement-rings-lgmtc2257-lg-300-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-CLASSIC-BEZEL-SOL/yellow-gold-classic-bezel-solitaire-engagement-rings-lgmtc2257-lg-300-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-JULIETTA-HIDDEN/julietta-hidden-engagement-rings-lgmtc2045-lg-150-em">
      https://weddingdaydiamonds.com/product-detail/ER-JULIETTA-HIDDEN/julietta-hidden-engagement-rings-lgmtc2045-lg-150-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-HAZEL-TAPERED/hazel-tapered-4-5ctw-engagement-rings-lgmtc2109-lg-300-em">
      https://weddingdaydiamonds.com/product-detail/ER-HAZEL-TAPERED/hazel-tapered-4-5ctw-engagement-rings-lgmtc2109-lg-300-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-EMMA-DECO/emma-deco-engagement-rings-lgmtc2065-lg-100-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TC-EMMA-DECO/emma-deco-engagement-rings-lgmtc2065-lg-100-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-PRISCILLA/luxe-priscilla-engagement-rings-lgmtc2224-lg-175-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-PRISCILLA/luxe-priscilla-engagement-rings-lgmtc2224-lg-175-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-COMPASS-HIDDEN-SOLITAIRE/compass-hidden-solitaire-engagement-rings-lgmtc1861-lg-500-em">
      https://weddingdaydiamonds.com/product-detail/ER-COMPASS-HIDDEN-SOLITAIRE/compass-hidden-solitaire-engagement-rings-lgmtc1861-lg-500-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LOTUS/lotus-3-8ctw-engagement-rings-lgmtc1889-lg-125-em">
      https://weddingdaydiamonds.com/product-detail/ER-LOTUS/lotus-3-8ctw-engagement-rings-lgmtc1889-lg-125-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-PRISCILLA/luxe-priscilla-engagement-rings-lgmtc2226-lg-350-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-PRISCILLA/luxe-priscilla-engagement-rings-lgmtc2226-lg-350-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-SIENNA/sienna-deluxe-1-2ctw-engagement-rings-lgmtc1762-lg-250-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-SIENNA/sienna-deluxe-1-2ctw-engagement-rings-lgmtc1762-lg-250-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-AVA-ROUND-HIDDEN/ava-round-hidden-engagement-rings-lgmtc2227-lg-175-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-AVA-ROUND-HIDDEN/ava-round-hidden-engagement-rings-lgmtc2227-lg-175-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-HELIA-HIDDEN/helia-hidden-engagement-rings-lgmtc2180-lg-100-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-HELIA-HIDDEN/helia-hidden-engagement-rings-lgmtc2180-lg-100-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ELIANA-MQ/rose-gold-mini-eliana-marquise-1-4ctw-engagement-rings-lgmtc1776-lg-150-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ELIANA-MQ/rose-gold-mini-eliana-marquise-1-4ctw-engagement-rings-lgmtc1776-lg-150-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LUXURY-SCARLETT/luxury-scarlett-engagement-rings-lgmtc1451-lg-300-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-LUXURY-SCARLETT/luxury-scarlett-engagement-rings-lgmtc1451-lg-300-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1ctw-engagement-rings-lgmtc2395-lg-500-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1ctw-engagement-rings-lgmtc2395-lg-500-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/FR-KALIE-TRES-DIAMOND-RING/rose-gold-kalie-tres-diamond-ring-fashion-rings-lgrfr0030">
      https://weddingdaydiamonds.com/product-detail/FR-KALIE-TRES-DIAMOND-RING/rose-gold-kalie-tres-diamond-ring-fashion-rings-lgrfr0030
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ATLAS/grand-atlas-9-10ctw-engagement-rings-lgmtc1823-lg-175-as">
      https://weddingdaydiamonds.com/product-detail/ER-ATLAS/grand-atlas-9-10ctw-engagement-rings-lgmtc1823-lg-175-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-PEAR/platinum-three-stone-pear-3-8ctw-engagement-rings-lgmtc2322-lg-275-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-PEAR/platinum-three-stone-pear-3-8ctw-engagement-rings-lgmtc2322-lg-275-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST/twist-solitaire-engagement-rings-lgmtc1573-lg-125-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST/twist-solitaire-engagement-rings-lgmtc1573-lg-125-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-GEMMA-BEZEL-SOLITAIRE/yellow-gold-gemma-bezel-solitaire-4ct-elongated-cushion-center-engagement-rings-lgmtc2465-lg-400-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-GEMMA-BEZEL-SOLITAIRE/yellow-gold-gemma-bezel-solitaire-4ct-elongated-cushion-center-engagement-rings-lgmtc2465-lg-400-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-AIMEE-PEAR-RD/white-gold-aimee-pear-round-1-4ctw-engagement-rings-lgmtc1673-lg-200-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-AIMEE-PEAR-RD/white-gold-aimee-pear-round-1-4ctw-engagement-rings-lgmtc1673-lg-200-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/WB-LUXE-5STN-EM-BZL/platinum-five-emerald-bezel-set-band-1ctw-womens-wedding-bands-lgabp0057">
      https://weddingdaydiamonds.com/product-detail/WB-LUXE-5STN-EM-BZL/platinum-five-emerald-bezel-set-band-1ctw-womens-wedding-bands-lgabp0057
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-AVA-ROUND-HIDDEN/ava-round-hidden-engagement-rings-lgmtc2227-lg-125-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-AVA-ROUND-HIDDEN/ava-round-hidden-engagement-rings-lgmtc2227-lg-125-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/WB-SILVAN/rose-gold-silvan-lab-grown-diamond-band-wedding-bands-lgbtc0374">
      https://weddingdaydiamonds.com/product-detail/WB-SILVAN/rose-gold-silvan-lab-grown-diamond-band-wedding-bands-lgbtc0374
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-JANAE/janae-engagement-rings-lgmtc1991-lg-175-mq">
      https://weddingdaydiamonds.com/product-detail/ER-JANAE/janae-engagement-rings-lgmtc1991-lg-175-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ISLA-HIDDEN-3-8/isla-hidden-3-8ctw-engagement-rings-lgmtc1948-lg-200-cu">
      https://weddingdaydiamonds.com/product-detail/ER-ISLA-HIDDEN-3-8/isla-hidden-3-8ctw-engagement-rings-lgmtc1948-lg-200-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-CELTIC/celtic-hidden-engagement-rings-lgmtc1427-lg-300-pe">
      https://weddingdaydiamonds.com/product-detail/ER-CELTIC/celtic-hidden-engagement-rings-lgmtc1427-lg-300-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-AUTUMN-VINE-TRES/yellow-gold-autumn-vine-tres-1ct-oval-center-engagement-rings-lgmtc2441-lg-100-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TC-AUTUMN-VINE-TRES/yellow-gold-autumn-vine-tres-1ct-oval-center-engagement-rings-lgmtc2441-lg-100-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-MODERN-DOMED-2.5mm/modern-domed-2-5mm-engagement-rings-lgmtc1555-lg-400-ov">
      https://weddingdaydiamonds.com/product-detail/ER-MODERN-DOMED-2.5mm/modern-domed-2-5mm-engagement-rings-lgmtc1555-lg-400-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-GRACIE-HIDDEN/gracie-hidden-engagement-rings-lgmtc1933-lg-100-ra">
      https://weddingdaydiamonds.com/product-detail/ER-GRACIE-HIDDEN/gracie-hidden-engagement-rings-lgmtc1933-lg-100-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ROSALIND-HIDDEN/rosalind-hidden-engagement-rings-lgmtc2157-lg-300-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ROSALIND-HIDDEN/rosalind-hidden-engagement-rings-lgmtc2157-lg-300-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-MODERN-DOMED-3.5mm/modern-domed-3-5mm-engagement-rings-lgmtc1559-lg-275-rd">
      https://weddingdaydiamonds.com/product-detail/ER-MODERN-DOMED-3.5mm/modern-domed-3-5mm-engagement-rings-lgmtc1559-lg-275-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/EAR-RD-PAVE-HUGGIE/rose-gold-round-pave-huggie-earrings-1-4ctw-earrings-lgehp0091">
      https://weddingdaydiamonds.com/product-detail/EAR-RD-PAVE-HUGGIE/rose-gold-round-pave-huggie-earrings-1-4ctw-earrings-lgehp0091
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LAINEY/luxe-lainey-1-3ctw-engagement-rings-lgmtc1912-lg-200-cu">
      https://weddingdaydiamonds.com/product-detail/ER-LAINEY/luxe-lainey-1-3ctw-engagement-rings-lgmtc1912-lg-200-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-GRAND-DENALI/grand-denali-engagement-rings-lgmtc2197-lg-225-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-GRAND-DENALI/grand-denali-engagement-rings-lgmtc2197-lg-225-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LUXE-GALA-SOLITAIRE/luxe-gala-solitaire-engagement-rings-lgmtc1902-lg-275-mq">
      https://weddingdaydiamonds.com/product-detail/ER-LUXE-GALA-SOLITAIRE/luxe-gala-solitaire-engagement-rings-lgmtc1902-lg-275-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-GRACIE-HIDDEN/gracie-hidden-engagement-rings-lgmtc1932-lg-100-mq">
      https://weddingdaydiamonds.com/product-detail/ER-GRACIE-HIDDEN/gracie-hidden-engagement-rings-lgmtc1932-lg-100-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LAYLA-5-8/layla-5-8ctw-engagement-rings-lgmtc2119-lg-275-ov">
      https://weddingdaydiamonds.com/product-detail/ER-LAYLA-5-8/layla-5-8ctw-engagement-rings-lgmtc2119-lg-275-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-BEZEL-EAST-WEST-SOL/white-gold-bezel-east-west-solitaire-engagement-rings-lgmtc2248-lg-150-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-BEZEL-EAST-WEST-SOL/white-gold-bezel-east-west-solitaire-engagement-rings-lgmtc2248-lg-150-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-DEMI/demi-1-5ctw-engagement-rings-lgmtc1750-lg-275-as">
      https://weddingdaydiamonds.com/product-detail/ER-TC-DEMI/demi-1-5ctw-engagement-rings-lgmtc1750-lg-275-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-EMMA-DECO/emma-deco-engagement-rings-lgmtc2066-lg-350-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-EMMA-DECO/emma-deco-engagement-rings-lgmtc2066-lg-350-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LACE/yellow-gold-mini-lace-1-4ctw-engagement-rings-lgmtc1726-lg-125-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LACE/yellow-gold-mini-lace-1-4ctw-engagement-rings-lgmtc1726-lg-125-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-MAYA-PEAR-3-4CTW/luxe-maya-pear-3-4ctw-engagement-rings-lgmtc1972-lg-300-as">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-MAYA-PEAR-3-4CTW/luxe-maya-pear-3-4ctw-engagement-rings-lgmtc1972-lg-300-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-VALLIANT-SOLITAIRE/valliant-solitaire-engagement-rings-lgmtc1583-lg-300-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-VALLIANT-SOLITAIRE/valliant-solitaire-engagement-rings-lgmtc1583-lg-300-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-NEURO-EMERALD/neuro-emerald-engagement-rings-lgmtc2086-lg-150-pr">
      https://weddingdaydiamonds.com/product-detail/ER-NEURO-EMERALD/neuro-emerald-engagement-rings-lgmtc2086-lg-150-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ANALIA-PEAR-RD/yellow-gold-analia-pear-round-1-4ctw-engagement-rings-lgmtc1690-lg-175-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ANALIA-PEAR-RD/yellow-gold-analia-pear-round-1-4ctw-engagement-rings-lgmtc1690-lg-175-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-SPLIT-HIDDEN-SOLITAIRE/modern-split-hidden-solitaire-engagement-rings-lgmtc1874-lg-225-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-SPLIT-HIDDEN-SOLITAIRE/modern-split-hidden-solitaire-engagement-rings-lgmtc1874-lg-225-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-MILLIE-SOLITAIRE/millie-solitaire-engagement-rings-lgmtc1533-lg-250-rd">
      https://weddingdaydiamonds.com/product-detail/ER-MILLIE-SOLITAIRE/millie-solitaire-engagement-rings-lgmtc1533-lg-250-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-floral-twist-THREE-STONE/floral-twist-three-stone-engagement-rings-lgmtc2215-lg-200-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-floral-twist-THREE-STONE/floral-twist-three-stone-engagement-rings-lgmtc2215-lg-200-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUCERNE/lucerne-hidden-engagement-rings-lgmtc1497-lg-250-as">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUCERNE/lucerne-hidden-engagement-rings-lgmtc1497-lg-250-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ALERIE-HIDDEN-HALO/alerie-hidden-halo-engagement-rings-lgmtc1458-lg-400-pr">
      https://weddingdaydiamonds.com/product-detail/ER-ALERIE-HIDDEN-HALO/alerie-hidden-halo-engagement-rings-lgmtc1458-lg-400-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TWIST-THREE-STONE/luxe-twist-three-stone-engagement-rings-lgmtc2353-lg-300-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TWIST-THREE-STONE/luxe-twist-three-stone-engagement-rings-lgmtc2353-lg-300-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-SPLIT-SOLITAIRE/modern-split-solitaire-engagement-rings-lgmtc1543-lg-100-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-SPLIT-SOLITAIRE/modern-split-solitaire-engagement-rings-lgmtc1543-lg-100-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TWIST-THREE-STONE/luxe-twist-three-stone-engagement-rings-lgmtc2354-lg-175-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TWIST-THREE-STONE/luxe-twist-three-stone-engagement-rings-lgmtc2354-lg-175-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-NELLIE-DECO/nellie-deco-engagement-rings-lgmtc2355-lg-250-ov">
      https://weddingdaydiamonds.com/product-detail/ER-NELLIE-DECO/nellie-deco-engagement-rings-lgmtc2355-lg-250-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ELIANA-1-4/eliana-1-4ctw-engagement-rings-lgmtc1422-lg-125-pe">
      https://weddingdaydiamonds.com/product-detail/ER-ELIANA-1-4/eliana-1-4ctw-engagement-rings-lgmtc1422-lg-125-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TRES-OVAL-3-8/tres-oval-3-8ctw-engagement-rings-lgmtc2011-lg-275-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TRES-OVAL-3-8/tres-oval-3-8ctw-engagement-rings-lgmtc2011-lg-275-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/EAR-TWISTING-VINE-EARRINGS-1-4CTW/white-gold-twisting-vine-earrings-1-4ctw-earrings-lgehp0156">
      https://weddingdaydiamonds.com/product-detail/EAR-TWISTING-VINE-EARRINGS-1-4CTW/white-gold-twisting-vine-earrings-1-4ctw-earrings-lgehp0156
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LUXE-MABEL/luxe-mabel-engagement-rings-lgmtc2115-lg-225-pe">
      https://weddingdaydiamonds.com/product-detail/ER-LUXE-MABEL/luxe-mabel-engagement-rings-lgmtc2115-lg-225-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-VALLIANT-SOLITAIRE/valliant-solitaire-engagement-rings-lgmtc1582-lg-175-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-VALLIANT-SOLITAIRE/valliant-solitaire-engagement-rings-lgmtc1582-lg-175-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/WBCM8510/10k-grey-tantalum-white-gold-6mm-beveled-edge-wedding-band-wedding-bands-wbcm8510">
      https://weddingdaydiamonds.com/product-detail/WBCM8510/10k-grey-tantalum-white-gold-6mm-beveled-edge-wedding-band-wedding-bands-wbcm8510
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LAINEY/lainey-hidden-solitaire-engagement-rings-lgmtc1867-lg-400-pr">
      https://weddingdaydiamonds.com/product-detail/ER-LAINEY/lainey-hidden-solitaire-engagement-rings-lgmtc1867-lg-400-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-PINNACLE/platinum-classic-pinnacle-1-3ctw-engagement-rings-lgmtc1635-lg-100-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-PINNACLE/platinum-classic-pinnacle-1-3ctw-engagement-rings-lgmtc1635-lg-100-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ELIANA-MQ/rose-gold-eliana-marquise-1-3ctw-engagement-rings-lgmtc1780-lg-300-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ELIANA-MQ/rose-gold-eliana-marquise-1-3ctw-engagement-rings-lgmtc1780-lg-300-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-HAZEL-TAPERED-1CTW/luxe-hazel-tapered-1ctw-engagement-rings-lgmtc2221-lg-500-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-HAZEL-TAPERED-1CTW/luxe-hazel-tapered-1ctw-engagement-rings-lgmtc2221-lg-500-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-IRIS/white-gold-iris-hidden-1ct-radiant-center-engagement-rings-lgmtc2424-lg-100-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-IRIS/white-gold-iris-hidden-1ct-radiant-center-engagement-rings-lgmtc2424-lg-100-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-PEAR/yellow-gold-three-stone-pear-1-4ctw-engagement-rings-lgmtc2281-lg-250-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-PEAR/yellow-gold-three-stone-pear-1-4ctw-engagement-rings-lgmtc2281-lg-250-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-AUTUMN-VINE-TRES/yellow-gold-autumn-vine-tres-2ct-emerald-center-engagement-rings-lgmtc2441-lg-200-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-AUTUMN-VINE-TRES/yellow-gold-autumn-vine-tres-2ct-emerald-center-engagement-rings-lgmtc2441-lg-200-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-MQ/white-gold-grand-three-stone-marquise-1-3ctw-engagement-rings-lgmtc2296-lg-250-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-MQ/white-gold-grand-three-stone-marquise-1-3ctw-engagement-rings-lgmtc2296-lg-250-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-GRACIE-HIDDEN/gracie-hidden-engagement-rings-lgmtc1933-lg-300-cu">
      https://weddingdaydiamonds.com/product-detail/ER-GRACIE-HIDDEN/gracie-hidden-engagement-rings-lgmtc1933-lg-300-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/FR-SIENNA/sienna-luxe-band-3-4ctw-wedding-bands-lgbtc0070-1">
      https://weddingdaydiamonds.com/product-detail/FR-SIENNA/sienna-luxe-band-3-4ctw-wedding-bands-lgbtc0070-1
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ANGELICA-PEAR-&amp;-ROUND/angelica-pear-and-round-engagement-rings-lgmtc1997-lg-100-em">
      https://weddingdaydiamonds.com/product-detail/ER-ANGELICA-PEAR-&amp;-ROUND/angelica-pear-and-round-engagement-rings-lgmtc1997-lg-100-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LEO-2-3CTW/leo-2-3ctw-engagement-rings-lgmtc1802-lg-150-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LEO-2-3CTW/leo-2-3ctw-engagement-rings-lgmtc1802-lg-150-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TULIP-SOLITAIRE/tulip-solitaire-engagement-rings-lgmtc1515-lg-350-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TULIP-SOLITAIRE/tulip-solitaire-engagement-rings-lgmtc1515-lg-350-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-SKYLER-THREE-STONE/white-gold-skyler-three-stone-3-3-4ct-emerald-center-engagement-rings-lgmtc2432-lg-375-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-SKYLER-THREE-STONE/white-gold-skyler-three-stone-3-3-4ct-emerald-center-engagement-rings-lgmtc2432-lg-375-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-EEVEE-1-3/eevee1-3ctw-engagement-rings-lgmtc2005-lg-100-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-EEVEE-1-3/eevee1-3ctw-engagement-rings-lgmtc2005-lg-100-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-VERONA/yellow-gold-verona-marquise-round-3-8ctw-engagement-rings-lgmtc1774-lg-175-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-VERONA/yellow-gold-verona-marquise-round-3-8ctw-engagement-rings-lgmtc1774-lg-175-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LAINEY/lainey-hidden-solitaire-engagement-rings-lgmtc1869-lg-200-pr">
      https://weddingdaydiamonds.com/product-detail/ER-LAINEY/lainey-hidden-solitaire-engagement-rings-lgmtc1869-lg-200-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/WB-MDRNEMETNTY/modern-demi-emerald-eternity-band-5-8ctw-wedding-bands-lgbtc0280">
      https://weddingdaydiamonds.com/product-detail/WB-MDRNEMETNTY/modern-demi-emerald-eternity-band-5-8ctw-wedding-bands-lgbtc0280
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LYRIC-PEAR-HALO/lyric-pear-halo-engagement-rings-lgmtc1402-lg-100-ov">
      https://weddingdaydiamonds.com/product-detail/ER-LYRIC-PEAR-HALO/lyric-pear-halo-engagement-rings-lgmtc1402-lg-100-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ZEPHYRA/zephyra-engagement-rings-lgmtc1956-lg-275-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-ZEPHYRA/zephyra-engagement-rings-lgmtc1956-lg-275-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LUXE-EMILIA-1-2/luxe-emilia-1-2ctw-engagement-rings-lgmtc1416-lg-275-as">
      https://weddingdaydiamonds.com/product-detail/ER-LUXE-EMILIA-1-2/luxe-emilia-1-2ctw-engagement-rings-lgmtc1416-lg-275-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-SPLIT-SOLITAIRE/modern-split-solitaire-engagement-rings-lgmtc1540-lg-175-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-SPLIT-SOLITAIRE/modern-split-solitaire-engagement-rings-lgmtc1540-lg-175-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ALLURE-BEZEL-SOL/allure-bezel-solitaire-engagement-rings-lgmtc1576-lg-225-as">
      https://weddingdaydiamonds.com/product-detail/ER-ALLURE-BEZEL-SOL/allure-bezel-solitaire-engagement-rings-lgmtc1576-lg-225-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ATLAS/atlas-5-8ctw-engagement-rings-lgmtc1816-lg-400-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-ATLAS/atlas-5-8ctw-engagement-rings-lgmtc1816-lg-400-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LEO-2-3CTW/leo-2-3ctw-engagement-rings-lgmtc1801-lg-350-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LEO-2-3CTW/leo-2-3ctw-engagement-rings-lgmtc1801-lg-350-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUMIERE/lumiere-hidden-halo-engagement-rings-lgmtc1609-lg-350-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUMIERE/lumiere-hidden-halo-engagement-rings-lgmtc1609-lg-350-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-GRAND-DENALI/grand-denali-engagement-rings-lgmtc2195-lg-275-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-GRAND-DENALI/grand-denali-engagement-rings-lgmtc2195-lg-275-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-MODERN-DOMED-2.5mm/modern-domed-2-5mm-engagement-rings-lgmtc1552-lg-250-pr">
      https://weddingdaydiamonds.com/product-detail/ER-MODERN-DOMED-2.5mm/modern-domed-2-5mm-engagement-rings-lgmtc1552-lg-250-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-JASMINE/white-gold-jasmine-engagement-rings-lgmtc1669-lg-200-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-JASMINE/white-gold-jasmine-engagement-rings-lgmtc1669-lg-200-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-7STONE/white-gold-mini-seven-stone-1-5ctw-engagement-rings-lgmtc1649-lg-200-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-7STONE/white-gold-mini-seven-stone-1-5ctw-engagement-rings-lgmtc1649-lg-200-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ATLAS/mini-atlas-1-5ctw-engagement-rings-lgmtc1804-lg-225-pe">
      https://weddingdaydiamonds.com/product-detail/ER-ATLAS/mini-atlas-1-5ctw-engagement-rings-lgmtc1804-lg-225-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-AC-SUMMIT-HALO-9-10/atia-couture-summit-halo-9-10ctw-engagement-rings-lgmtc1503-lg-150-pe">
      https://weddingdaydiamonds.com/product-detail/ER-AC-SUMMIT-HALO-9-10/atia-couture-summit-halo-9-10ctw-engagement-rings-lgmtc1503-lg-150-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-PINNACLE/rose-gold-classic-pinnacle-1-3ctw-engagement-rings-lgmtc1632-lg-150-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TC-PINNACLE/rose-gold-classic-pinnacle-1-3ctw-engagement-rings-lgmtc1632-lg-150-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-CAMILE/yellow-gold-camiile-1-3ctw-engagement-rings-lgmtc1730-lg-275-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-CAMILE/yellow-gold-camiile-1-3ctw-engagement-rings-lgmtc1730-lg-275-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-CELTIC/queen-celtic-1-5ctw-engagement-rings-lgmtc1918-lg-175-mq">
      https://weddingdaydiamonds.com/product-detail/ER-CELTIC/queen-celtic-1-5ctw-engagement-rings-lgmtc1918-lg-175-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-HAZEL-TAPERED-1CTW/luxe-hazel-tapered-1ctw-engagement-rings-lgmtc2220-lg-350-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-HAZEL-TAPERED-1CTW/luxe-hazel-tapered-1ctw-engagement-rings-lgmtc2220-lg-350-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-REIGN-PEAR-&amp;-MARQUISE/reign-pear-and-marquise-engagement-rings-lgmtc1979-lg-175-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-REIGN-PEAR-&amp;-MARQUISE/reign-pear-and-marquise-engagement-rings-lgmtc1979-lg-175-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-2-3ctw-engagement-rings-lgmtc2373-lg-125-ov">
      https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-2-3ctw-engagement-rings-lgmtc2373-lg-125-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-2-3ctw-engagement-rings-lgmtc2374-lg-100-as">
      https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-2-3ctw-engagement-rings-lgmtc2374-lg-100-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-AVA-OVAL-3-4/ava-oval-3-4ctw-engagement-rings-lgmtc2088-lg-400-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-AVA-OVAL-3-4/ava-oval-3-4ctw-engagement-rings-lgmtc2088-lg-400-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LINA/yellow-gold-luxury-lina-1-2ctw-engagement-rings-lgmtc1706-lg-275-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LINA/yellow-gold-luxury-lina-1-2ctw-engagement-rings-lgmtc1706-lg-275-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-BG/yellow-gold-mini-three-stone-baguette-1-5ctw-engagement-rings-lgmtc2301-lg-200-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-BG/yellow-gold-mini-three-stone-baguette-1-5ctw-engagement-rings-lgmtc2301-lg-200-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LOTUS/lotus-3-8ctw-engagement-rings-lgmtc1887-lg-100-pe">
      https://weddingdaydiamonds.com/product-detail/ER-LOTUS/lotus-3-8ctw-engagement-rings-lgmtc1887-lg-100-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-TIARA/tiara-1-5ctw-engagement-rings-lgmtc1612-lg-350-as">
      https://weddingdaydiamonds.com/product-detail/ER-TC-TIARA/tiara-1-5ctw-engagement-rings-lgmtc1612-lg-350-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-DEMI-MARQUISE/demi-marquise-engagement-rings-lgmtc2143-lg-125-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-DEMI-MARQUISE/demi-marquise-engagement-rings-lgmtc2143-lg-125-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MAGNOLIA-VINE/white-gold-magnolia-vine-1-1-2ct-asscher-center-engagement-rings-lgmtc2428-lg-150-as">
      https://weddingdaydiamonds.com/product-detail/ER-TC-MAGNOLIA-VINE/white-gold-magnolia-vine-1-1-2ct-asscher-center-engagement-rings-lgmtc2428-lg-150-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-DELPHINE-SOLITAIRE/delphine-solitaire-engagement-rings-lgmtc1455-lg-350-ra">
      https://weddingdaydiamonds.com/product-detail/ER-DELPHINE-SOLITAIRE/delphine-solitaire-engagement-rings-lgmtc1455-lg-350-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LOTUS-THREE-STONE/platinum-lotus-three-stone-2ct-emerald-center-engagement-rings-lgmtc2450-lg-200-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LOTUS-THREE-STONE/platinum-lotus-three-stone-2ct-emerald-center-engagement-rings-lgmtc2450-lg-200-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ELIANA-PEAR/yellow-gold-grand-eliana-pear-3-4ctw-engagement-rings-lgmtc1798-lg-125-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ELIANA-PEAR/yellow-gold-grand-eliana-pear-3-4ctw-engagement-rings-lgmtc1798-lg-125-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-GRAND-ELIZABETH/grand-elizabeth-engagement-rings-lgmtc2008-lg-300-mq">
      https://weddingdaydiamonds.com/product-detail/ER-GRAND-ELIZABETH/grand-elizabeth-engagement-rings-lgmtc2008-lg-300-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST/twist-halo-engagement-rings-lgmtc1470-lg-400-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST/twist-halo-engagement-rings-lgmtc1470-lg-400-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-DOMED-4.5MM/modern-domed-4.5mm-engagement-rings-lgmtc1561-lg-250-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-DOMED-4.5MM/modern-domed-4.5mm-engagement-rings-lgmtc1561-lg-250-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-NOVAH-HEAVY/rose-gold-novah-heavy-solitaire-2ct-round-center-engagement-rings-mrmtr0020-lg-200-rd">
      https://weddingdaydiamonds.com/product-detail/ER-NOVAH-HEAVY/rose-gold-novah-heavy-solitaire-2ct-round-center-engagement-rings-mrmtr0020-lg-200-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LYRA-CURVED-1-3/lyra-curved-1-3ctw-engagement-rings-lgmtc1891-lg-275-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-LYRA-CURVED-1-3/lyra-curved-1-3ctw-engagement-rings-lgmtc1891-lg-275-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-IMANI-PEAR-&amp;-ROUND/imani-pear-and-round-engagement-rings-lgmtc1977-lg-300-pr">
      https://weddingdaydiamonds.com/product-detail/ER-IMANI-PEAR-&amp;-ROUND/imani-pear-and-round-engagement-rings-lgmtc1977-lg-300-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ASPEN-SIX-PRONG-SOLITAIRE/aspen-six-prong-solitaire-engagement-rings-lgmtc1536-lg-200-pr">
      https://weddingdaydiamonds.com/product-detail/ER-ASPEN-SIX-PRONG-SOLITAIRE/aspen-six-prong-solitaire-engagement-rings-lgmtc1536-lg-200-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-DOMED-4.5MM/modern-domed-4.5mm-engagement-rings-lgmtc1560-lg-500-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-DOMED-4.5MM/modern-domed-4.5mm-engagement-rings-lgmtc1560-lg-500-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-DELPHINE-SOLITAIRE/delphine-solitaire-engagement-rings-lgmtc1454-lg-275-cu">
      https://weddingdaydiamonds.com/product-detail/ER-DELPHINE-SOLITAIRE/delphine-solitaire-engagement-rings-lgmtc1454-lg-275-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-AC-LUXE-HIDDEN-3-8/atia-couture-luxe-hidden-3-8ctw-engagement-rings-lgmtc2267-lg-150-ov">
      https://weddingdaydiamonds.com/product-detail/ER-AC-LUXE-HIDDEN-3-8/atia-couture-luxe-hidden-3-8ctw-engagement-rings-lgmtc2267-lg-150-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-EM-RD/yellow-gold-three-stone-emerald-rounds-3-4ctw-engagement-rings-lgmtc2333-lg-250-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-EM-RD/yellow-gold-three-stone-emerald-rounds-3-4ctw-engagement-rings-lgmtc2333-lg-250-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-DUO-LUMIERE/luxe-duo-lumiere-3-8ctw-engagement-rings-lgmtc1831-lg-225-rd">
      https://weddingdaydiamonds.com/product-detail/ER-DUO-LUMIERE/luxe-duo-lumiere-3-8ctw-engagement-rings-lgmtc1831-lg-225-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-DECO-BAGUETTE-THREE-STONE/deco-baguette-three-stone-engagement-rings-lgmtc2344-lg-300-cu">
      https://weddingdaydiamonds.com/product-detail/ER-DECO-BAGUETTE-THREE-STONE/deco-baguette-three-stone-engagement-rings-lgmtc2344-lg-300-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/WB-LUXE-PR-SP-ETR/rose-gold-princess-shared-prong-eternity-7ctw-womens-wedding-bands-lgetr0600">
      https://weddingdaydiamonds.com/product-detail/WB-LUXE-PR-SP-ETR/rose-gold-princess-shared-prong-eternity-7ctw-womens-wedding-bands-lgetr0600
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-WEAVE-HIDDEN-SOLITAIRE/weave-hidden-solitaire-engagement-rings-lgmtc1487-lg-500-mq">
      https://weddingdaydiamonds.com/product-detail/ER-WEAVE-HIDDEN-SOLITAIRE/weave-hidden-solitaire-engagement-rings-lgmtc1487-lg-500-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-NESTLE-CATHEDRAL-SOLITAIRE/nestle-cathedral-solitaire-engagement-rings-lgmtc1604-lg-300-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-NESTLE-CATHEDRAL-SOLITAIRE/nestle-cathedral-solitaire-engagement-rings-lgmtc1604-lg-300-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LOTUS-THREE-STONE/yellow-gold-lotus-three-stone-1-1-4ct-elongated-cushion-center-engagement-rings-lgmtc2449-lg-125-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LOTUS-THREE-STONE/yellow-gold-lotus-three-stone-1-1-4ct-elongated-cushion-center-engagement-rings-lgmtc2449-lg-125-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MACY-HIDDEN/macy-hidden-engagement-rings-lgmtc1488-lg-150-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-MACY-HIDDEN/macy-hidden-engagement-rings-lgmtc1488-lg-150-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUCERNE/luxe-lucerne-hidden-engagement-rings-lgmtc2262-lg-300-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUCERNE/luxe-lucerne-hidden-engagement-rings-lgmtc2262-lg-300-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LUXE-MABEL/luxe-mabel-engagement-rings-lgmtc2118-lg-225-as">
      https://weddingdaydiamonds.com/product-detail/ER-LUXE-MABEL/luxe-mabel-engagement-rings-lgmtc2118-lg-225-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-VERONA/rose-gold-mini-verona-1-5ctw-engagement-rings-lgmtc1768-lg-125-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-VERONA/rose-gold-mini-verona-1-5ctw-engagement-rings-lgmtc1768-lg-125-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-CLASSIC-ALLURE-BEZEL-SOLITAIRE/classic-allure-bezel-solitaire-engagement-rings-lgmtc1571-lg-100-em">
      https://weddingdaydiamonds.com/product-detail/ER-CLASSIC-ALLURE-BEZEL-SOLITAIRE/classic-allure-bezel-solitaire-engagement-rings-lgmtc1571-lg-100-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LEO-2-3CTW/leo-2-3ctw-engagement-rings-lgmtc1800-lg-100-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LEO-2-3CTW/leo-2-3ctw-engagement-rings-lgmtc1800-lg-100-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST/twist-halo-engagement-rings-lgmtc1470-lg-225-as">
      https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST/twist-halo-engagement-rings-lgmtc1470-lg-225-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-HAZEL-TAPERED/hazel-tapered-4-5ctw-engagement-rings-lgmtc2107-lg-400-pr">
      https://weddingdaydiamonds.com/product-detail/ER-HAZEL-TAPERED/hazel-tapered-4-5ctw-engagement-rings-lgmtc2107-lg-400-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-BLAIRE-5-8/blaire-5-8ctw-engagement-rings-lgmtc2078-lg-225-cu">
      https://weddingdaydiamonds.com/product-detail/ER-BLAIRE-5-8/blaire-5-8ctw-engagement-rings-lgmtc2078-lg-225-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-HELIA-HIDDEN/helia-hidden-engagement-rings-lgmtc2180-lg-175-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-HELIA-HIDDEN/helia-hidden-engagement-rings-lgmtc2180-lg-175-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LAINEY/lainey-hidden-solitaire-engagement-rings-lgmtc1868-lg-350-em">
      https://weddingdaydiamonds.com/product-detail/ER-LAINEY/lainey-hidden-solitaire-engagement-rings-lgmtc1868-lg-350-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-MODERN-2.5mm-SOLITAIRE/modern-2-5mm-solitaire-engagement-rings-lgmtc1547-lg-175-em">
      https://weddingdaydiamonds.com/product-detail/ER-MODERN-2.5mm-SOLITAIRE/modern-2-5mm-solitaire-engagement-rings-lgmtc1547-lg-175-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-FELICITY-PEAR-&amp;-RNDS/felicity-pear-and-rounds-engagement-rings-lgmtc1985-lg-200-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-FELICITY-PEAR-&amp;-RNDS/felicity-pear-and-rounds-engagement-rings-lgmtc1985-lg-200-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-VALENTINA/luxe-valentina-2-3ctw-engagement-rings-lgmtc1920-lg-300-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-VALENTINA/luxe-valentina-2-3ctw-engagement-rings-lgmtc1920-lg-300-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/FR-TOI-ET-MOI-HALO-1-3-4CTW/white-gold-toi-et-moi-halo-1-3-4ctw-fashion-rings-lgwfr0020">
      https://weddingdaydiamonds.com/product-detail/FR-TOI-ET-MOI-HALO-1-3-4CTW/white-gold-toi-et-moi-halo-1-3-4ctw-fashion-rings-lgwfr0020
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-RAELYN-HIDDEN/raelyn-hidden-engagement-rings-lgmtc1940-lg-150-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-RAELYN-HIDDEN/raelyn-hidden-engagement-rings-lgmtc1940-lg-150-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LUXURY-SCARLETT/luxury-scarlett-engagement-rings-lgmtc1451-lg-175-cu">
      https://weddingdaydiamonds.com/product-detail/ER-LUXURY-SCARLETT/luxury-scarlett-engagement-rings-lgmtc1451-lg-175-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-DEMI/rose-gold-mini-demi-1-10ctw-engagement-rings-lgmtc1744-lg-175-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-DEMI/rose-gold-mini-demi-1-10ctw-engagement-rings-lgmtc1744-lg-175-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-5STONE/platinum-luxury-five-stone-1-3ctw-engagement-rings-lgmtc1647-lg-200-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-5STONE/platinum-luxury-five-stone-1-3ctw-engagement-rings-lgmtc1647-lg-200-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-TIARA/tiara-1-5ctw-engagement-rings-lgmtc1615-lg-350-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-TIARA/tiara-1-5ctw-engagement-rings-lgmtc1615-lg-350-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-JULIETTA-HIDDEN/julietta-hidden-engagement-rings-lgmtc2045-lg-200-rd">
      https://weddingdaydiamonds.com/product-detail/ER-JULIETTA-HIDDEN/julietta-hidden-engagement-rings-lgmtc2045-lg-200-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LEO-2-3CTW/leo-2-3ctw-engagement-rings-lgmtc1800-lg-400-as">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LEO-2-3CTW/leo-2-3ctw-engagement-rings-lgmtc1800-lg-400-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ROSALIND-HIDDEN/rosalind-hidden-engagement-rings-lgmtc2155-lg-500-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ROSALIND-HIDDEN/rosalind-hidden-engagement-rings-lgmtc2155-lg-500-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TWIST-THREE-STONE/luxe-twist-three-stone-engagement-rings-lgmtc2354-lg-500-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TWIST-THREE-STONE/luxe-twist-three-stone-engagement-rings-lgmtc2354-lg-500-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-WHISPER/grand-whisper-hidden-halo-1-4ctw-engagement-rings-lgmtc1395-lg-150-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-WHISPER/grand-whisper-hidden-halo-1-4ctw-engagement-rings-lgmtc1395-lg-150-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/MWB-TC-ALEXANDER-DUO-BD/white-gold-alexander-duo-asscher-cut-black-diamond-band-mens-wedding-bands-lgtmb0114">
      https://weddingdaydiamonds.com/product-detail/MWB-TC-ALEXANDER-DUO-BD/white-gold-alexander-duo-asscher-cut-black-diamond-band-mens-wedding-bands-lgtmb0114
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-IRIS/yellow-gold-grand-iris-2-3-4ct-pear-center-engagement-rings-lgmtc2445-lg-275-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-IRIS/yellow-gold-grand-iris-2-3-4ct-pear-center-engagement-rings-lgmtc2445-lg-275-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-BROOK-HIDDEN-SOLITAIRE/brook-hidden-solitaire-engagement-rings-lgmtc1446-lg-100-em">
      https://weddingdaydiamonds.com/product-detail/ER-BROOK-HIDDEN-SOLITAIRE/brook-hidden-solitaire-engagement-rings-lgmtc1446-lg-100-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-AVA-OVAL-3-4/ava-oval-3-4ctw-engagement-rings-lgmtc2089-lg-200-ra">
      https://weddingdaydiamonds.com/product-detail/ER-AVA-OVAL-3-4/ava-oval-3-4ctw-engagement-rings-lgmtc2089-lg-200-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-HAILEY-SOLITAIRE/yellow-gold-hailey-solitaire-2-3-4ct-princess-center-engagement-rings-lgmtc2412-lg-275-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-HAILEY-SOLITAIRE/yellow-gold-hailey-solitaire-2-3-4ct-princess-center-engagement-rings-lgmtc2412-lg-275-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-DELPHINE/luxe-delphine-3-8ctw-engagement-rings-lgmtc1841-lg-350-rd">
      https://weddingdaydiamonds.com/product-detail/ER-DELPHINE/luxe-delphine-3-8ctw-engagement-rings-lgmtc1841-lg-350-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-WHISPER/whisper-hidden-halo-solitaire-engagement-rings-lgmtc1504-lg-150-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-WHISPER/whisper-hidden-halo-solitaire-engagement-rings-lgmtc1504-lg-150-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-AUTUMN-VINE-SOLITAIRE/autumn-vine-solitaire-engagement-rings-lgmtc1480-lg-125-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-AUTUMN-VINE-SOLITAIRE/autumn-vine-solitaire-engagement-rings-lgmtc1480-lg-125-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-PEAR-RD/yellow-gold-three-stone-pear-rounds-3-4ctw-engagement-rings-lgmtc2325-lg-300-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-PEAR-RD/yellow-gold-three-stone-pear-rounds-3-4ctw-engagement-rings-lgmtc2325-lg-300-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-MQ/white-gold-grand-three-stone-marquise-1-3ctw-engagement-rings-lgmtc2296-lg-250-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-MQ/white-gold-grand-three-stone-marquise-1-3ctw-engagement-rings-lgmtc2296-lg-250-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LUXE-EMILIA-1-2/luxe-emilia-1-2ctw-engagement-rings-lgmtc1419-lg-275-mq">
      https://weddingdaydiamonds.com/product-detail/ER-LUXE-EMILIA-1-2/luxe-emilia-1-2ctw-engagement-rings-lgmtc1419-lg-275-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-SHARED/luxe-mini-shared-1-4ctw-engagement-rings-lgmtc1847-lg-300-em">
      https://weddingdaydiamonds.com/product-detail/ER-SHARED/luxe-mini-shared-1-4ctw-engagement-rings-lgmtc1847-lg-300-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUMIERE/lumiere-hidden-halo-engagement-rings-lgmtc1608-lg-175-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUMIERE/lumiere-hidden-halo-engagement-rings-lgmtc1608-lg-175-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ROSALIND-HIDDEN/rosalind-hidden-engagement-rings-lgmtc2158-lg-200-as">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ROSALIND-HIDDEN/rosalind-hidden-engagement-rings-lgmtc2158-lg-200-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-REMI-KITE-SOLITAIRE/remi-kite-solitaire-engagement-rings-lgmtc1527-lg-175-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-REMI-KITE-SOLITAIRE/remi-kite-solitaire-engagement-rings-lgmtc1527-lg-175-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-MAEVE/maeve-engagement-rings-lgmtc2028-lg-200-ra">
      https://weddingdaydiamonds.com/product-detail/ER-MAEVE/maeve-engagement-rings-lgmtc2028-lg-200-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-1-3-8ctw-engagement-rings-lgmtc2381-lg-500-em">
      https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-1-3-8ctw-engagement-rings-lgmtc2381-lg-500-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-BRIELLE-3-4CTW/brielle-3-4ctw-engagement-rings-lgmtc1990-lg-300-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-BRIELLE-3-4CTW/brielle-3-4ctw-engagement-rings-lgmtc1990-lg-300-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ADA-MODERN-HIDDEN/ada-modern-hidden-engagement-rings-lgmtc1864-lg-400-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ADA-MODERN-HIDDEN/ada-modern-hidden-engagement-rings-lgmtc1864-lg-400-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LILY-PEAR-RD/platinum-lily-pear-round-engagement-rings-lgmtc1663-lg-300-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LILY-PEAR-RD/platinum-lily-pear-round-engagement-rings-lgmtc1663-lg-300-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MINI-3STONE/rose-gold-mini-three-1-5ct-engagement-rings-lgmtc2339-lg-200-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-MINI-3STONE/rose-gold-mini-three-1-5ct-engagement-rings-lgmtc2339-lg-200-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/WB-SIENNAPERD/petite-sienna-pear-round-1-3ctw-wedding-bands-lgbtc0122">
      https://weddingdaydiamonds.com/product-detail/WB-SIENNAPERD/petite-sienna-pear-round-1-3ctw-wedding-bands-lgbtc0122
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-BG-RD/yellow-gold-luxe-baguette-round-3-4ctw-engagement-rings-lgmtc1718-lg-125-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-BG-RD/yellow-gold-luxe-baguette-round-3-4ctw-engagement-rings-lgmtc1718-lg-125-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-DUO-LUMIERE/luxe-duo-lumiere-3-8ctw-engagement-rings-lgmtc1831-lg-300-pe">
      https://weddingdaydiamonds.com/product-detail/ER-DUO-LUMIERE/luxe-duo-lumiere-3-8ctw-engagement-rings-lgmtc1831-lg-300-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-DEMI/demi-1-5ctw-engagement-rings-lgmtc1751-lg-100-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-DEMI/demi-1-5ctw-engagement-rings-lgmtc1751-lg-100-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-CLASSIC-GALA/classic-gala-engagement-rings-lgmtc1897-lg-125-rd">
      https://weddingdaydiamonds.com/product-detail/ER-CLASSIC-GALA/classic-gala-engagement-rings-lgmtc1897-lg-125-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-TWIST-FLORA/luxe-twist-flora-engagement-rings-lgmtc2150-lg-225-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-TWIST-FLORA/luxe-twist-flora-engagement-rings-lgmtc2150-lg-225-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-HARPER/classic-harper-engagement-rings-lgmtc2097-lg-150-em">
      https://weddingdaydiamonds.com/product-detail/ER-HARPER/classic-harper-engagement-rings-lgmtc2097-lg-150-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LUXE-GALA-SOLITAIRE/luxe-gala-solitaire-engagement-rings-lgmtc1900-lg-275-pr">
      https://weddingdaydiamonds.com/product-detail/ER-LUXE-GALA-SOLITAIRE/luxe-gala-solitaire-engagement-rings-lgmtc1900-lg-275-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-COLETTE/colette-1-4ctw-engagement-rings-lgmtc1968-lg-100-pr">
      https://weddingdaydiamonds.com/product-detail/ER-COLETTE/colette-1-4ctw-engagement-rings-lgmtc1968-lg-100-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-3-4ctw-engagement-rings-lgmtc2384-lg-500-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-3-4ctw-engagement-rings-lgmtc2384-lg-500-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LOTUS-THREE-STONE/white-gold-lotus-three-stone-4-1-2ct-princess-center-engagement-rings-lgmtc2448-lg-450-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LOTUS-THREE-STONE/white-gold-lotus-three-stone-4-1-2ct-princess-center-engagement-rings-lgmtc2448-lg-450-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-DECO-BAGUETTE-THREE-STONE/deco-baguette-three-stone-engagement-rings-lgmtc2343-lg-400-mq">
      https://weddingdaydiamonds.com/product-detail/ER-DECO-BAGUETTE-THREE-STONE/deco-baguette-three-stone-engagement-rings-lgmtc2343-lg-400-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-BREA-HALO-3-8/brea-halo-3-8ctw-engagement-rings-lgmtc1438-lg-125-as">
      https://weddingdaydiamonds.com/product-detail/ER-BREA-HALO-3-8/brea-halo-3-8ctw-engagement-rings-lgmtc1438-lg-125-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-DELPHINE-SOLITAIRE/delphine-solitaire-engagement-rings-lgmtc1452-lg-500-pe">
      https://weddingdaydiamonds.com/product-detail/ER-DELPHINE-SOLITAIRE/delphine-solitaire-engagement-rings-lgmtc1452-lg-500-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUMIERE/grand-lumiere-hidden-engagement-rings-lgmtc2235-lg-400-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUMIERE/grand-lumiere-hidden-engagement-rings-lgmtc2235-lg-400-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-PEAR/white-gold-grand-pear-three-stone-1-2ctw-engagement-rings-lgmtc2284-lg-125-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-PEAR/white-gold-grand-pear-three-stone-1-2ctw-engagement-rings-lgmtc2284-lg-125-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ARIELLE-SUN/yellow-gold-arielle-sun-3-1-2ct-cushion-center-engagement-rings-lgmtc2477-lg-350-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ARIELLE-SUN/yellow-gold-arielle-sun-3-1-2ct-cushion-center-engagement-rings-lgmtc2477-lg-350-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-NELLIE-DECO/nellie-deco-engagement-rings-lgmtc2356-lg-275-rd">
      https://weddingdaydiamonds.com/product-detail/ER-NELLIE-DECO/nellie-deco-engagement-rings-lgmtc2356-lg-275-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-DEMI-MARQUISE/demi-marquise-engagement-rings-lgmtc2145-lg-225-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-DEMI-MARQUISE/demi-marquise-engagement-rings-lgmtc2145-lg-225-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-floral-twist-THREE-STONE/floral-twist-three-stone-engagement-rings-lgmtc2218-lg-300-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-floral-twist-THREE-STONE/floral-twist-three-stone-engagement-rings-lgmtc2218-lg-300-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-GRACELYN-1-3CTW/gracelyn-1-3ctw-engagement-rings-lgmtc2210-lg-300-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-GRACELYN-1-3CTW/gracelyn-1-3ctw-engagement-rings-lgmtc2210-lg-300-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-3-4ctw-engagement-rings-lgmtc2384-lg-200-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-3-4ctw-engagement-rings-lgmtc2384-lg-200-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-STELLA/platinum-stella-1-4ctw-engagement-rings-lgmtc1619-lg-300-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-STELLA/platinum-stella-1-4ctw-engagement-rings-lgmtc1619-lg-300-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-GRACIE-THREE-STONE/gracie-three-stone-engagement-rings-lgmtc2348-lg-225-pe">
      https://weddingdaydiamonds.com/product-detail/ER-GRACIE-THREE-STONE/gracie-three-stone-engagement-rings-lgmtc2348-lg-225-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-GRACIE-THREE-STONE/gracie-three-stone-engagement-rings-lgmtc2347-lg-275-mq">
      https://weddingdaydiamonds.com/product-detail/ER-GRACIE-THREE-STONE/gracie-three-stone-engagement-rings-lgmtc2347-lg-275-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-HELIA-HIDDEN/helia-hidden-engagement-rings-lgmtc2179-lg-300-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-HELIA-HIDDEN/helia-hidden-engagement-rings-lgmtc2179-lg-300-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1-4ctw-engagement-rings-lgmtc2388-lg-125-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1-4ctw-engagement-rings-lgmtc2388-lg-125-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LAYLA-5-8/layla-5-8ctw-engagement-rings-lgmtc2119-lg-125-rd">
      https://weddingdaydiamonds.com/product-detail/ER-LAYLA-5-8/layla-5-8ctw-engagement-rings-lgmtc2119-lg-125-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-DEMI/demi-1-5ctw-engagement-rings-lgmtc1751-lg-275-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-DEMI/demi-1-5ctw-engagement-rings-lgmtc1751-lg-275-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ROSALIND-HIDDEN/rosalind-hidden-engagement-rings-lgmtc2156-lg-275-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ROSALIND-HIDDEN/rosalind-hidden-engagement-rings-lgmtc2156-lg-275-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-HAZEL-TAPERED-1CTW/luxe-hazel-tapered-1ctw-engagement-rings-lgmtc2220-lg-500-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-HAZEL-TAPERED-1CTW/luxe-hazel-tapered-1ctw-engagement-rings-lgmtc2220-lg-500-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-COLETTE/colette-1-4ctw-engagement-rings-lgmtc1969-lg-200-ov">
      https://weddingdaydiamonds.com/product-detail/ER-COLETTE/colette-1-4ctw-engagement-rings-lgmtc1969-lg-200-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-AC-SUMMIT-HALO-9-10/atia-couture-summit-halo-9-10ctw-engagement-rings-lgmtc1500-lg-225-em">
      https://weddingdaydiamonds.com/product-detail/ER-AC-SUMMIT-HALO-9-10/atia-couture-summit-halo-9-10ctw-engagement-rings-lgmtc1500-lg-225-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-EMBRACE-CLASSIC/rose-gold-embrace-1-6-ctw-engagement-rings-lgmtc1664-lg-225-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-EMBRACE-CLASSIC/rose-gold-embrace-1-6-ctw-engagement-rings-lgmtc1664-lg-225-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-SHARED/mini-shared-1-6ctw-engagement-rings-lgmtc1846-lg-400-mq">
      https://weddingdaydiamonds.com/product-detail/ER-SHARED/mini-shared-1-6ctw-engagement-rings-lgmtc1846-lg-400-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-WHISPER/whisper-solitaire-engagement-rings-lgmtc1508-lg-500-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-WHISPER/whisper-solitaire-engagement-rings-lgmtc1508-lg-500-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-AUGUST-VINE/august-vine-engagement-rings-lgmtc2018-lg-300-ov">
      https://weddingdaydiamonds.com/product-detail/ER-AUGUST-VINE/august-vine-engagement-rings-lgmtc2018-lg-300-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ATLAS/atlas-5-8ctw-engagement-rings-lgmtc1816-lg-150-ov">
      https://weddingdaydiamonds.com/product-detail/ER-ATLAS/atlas-5-8ctw-engagement-rings-lgmtc1816-lg-150-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-MODERN-3.5mm-SOLITAIRE/modern-3-5mm-solitaire-engagement-rings-lgmtc1548-lg-300-pe">
      https://weddingdaydiamonds.com/product-detail/ER-MODERN-3.5mm-SOLITAIRE/modern-3-5mm-solitaire-engagement-rings-lgmtc1548-lg-300-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-DOMED-4.5MM/modern-domed-4.5mm-engagement-rings-lgmtc1563-lg-350-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-DOMED-4.5MM/modern-domed-4.5mm-engagement-rings-lgmtc1563-lg-350-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-GRACIE-THREE-STONE/gracie-three-stone-engagement-rings-lgmtc2350-lg-200-em">
      https://weddingdaydiamonds.com/product-detail/ER-GRACIE-THREE-STONE/gracie-three-stone-engagement-rings-lgmtc2350-lg-200-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ATLAS/classic-atlas-3-8ctw-engagement-rings-lgmtc1814-lg-225-ov">
      https://weddingdaydiamonds.com/product-detail/ER-ATLAS/classic-atlas-3-8ctw-engagement-rings-lgmtc1814-lg-225-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ATLAS/luxury-atlas-1-1-5ctw-engagement-rings-lgmtc1825-lg-400-em">
      https://weddingdaydiamonds.com/product-detail/ER-ATLAS/luxury-atlas-1-1-5ctw-engagement-rings-lgmtc1825-lg-400-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LINA/rose-gold-lina-1-3ctw-engagement-rings-lgmtc1700-lg-275-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LINA/rose-gold-lina-1-3ctw-engagement-rings-lgmtc1700-lg-275-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ESME-HIDDEN/esme-hidden-engagement-rings-lgmtc1477-lg-300-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ESME-HIDDEN/esme-hidden-engagement-rings-lgmtc1477-lg-300-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LAINEY/luxe-lainey-1-3ctw-engagement-rings-lgmtc1911-lg-125-mq">
      https://weddingdaydiamonds.com/product-detail/ER-LAINEY/luxe-lainey-1-3ctw-engagement-rings-lgmtc1911-lg-125-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1-4ctw-engagement-rings-lgmtc2390-lg-175-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TRINITY-HIDDEN/trinity-hidden-1-4ctw-engagement-rings-lgmtc2390-lg-175-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/WB-LUXE-5STN/platinum-five-stone-oval-anniversary-band-4ctw-womens-wedding-bands-lgabp0160">
      https://weddingdaydiamonds.com/product-detail/WB-LUXE-5STN/platinum-five-stone-oval-anniversary-band-4ctw-womens-wedding-bands-lgabp0160
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-IMANI-PEAR-&amp;-ROUND/imani-pear-and-round-engagement-rings-lgmtc1978-lg-350-rd">
      https://weddingdaydiamonds.com/product-detail/ER-IMANI-PEAR-&amp;-ROUND/imani-pear-and-round-engagement-rings-lgmtc1978-lg-350-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-EAST-WEST/rose-gold-east-west-1-3ctw-engagement-rings-lgmtc2243-lg-100-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-EAST-WEST/rose-gold-east-west-1-3ctw-engagement-rings-lgmtc2243-lg-100-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LONA-BAGUETTE-&amp;-ROUND/lona-baguette-&amp;-round-engagement-rings-lgmtc1965-lg-100-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LONA-BAGUETTE-&amp;-ROUND/lona-baguette-&amp;-round-engagement-rings-lgmtc1965-lg-100-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-MARA-THREE-STONE/mara-three-stone-engagement-rings-lgmtc2002-lg-350-cu">
      https://weddingdaydiamonds.com/product-detail/ER-MARA-THREE-STONE/mara-three-stone-engagement-rings-lgmtc2002-lg-350-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/GRAND15752/14k-rose-gold-2ctw-grand-collection-engagement-ring-engagement-rings-prbre0087">
      https://weddingdaydiamonds.com/product-detail/GRAND15752/14k-rose-gold-2ctw-grand-collection-engagement-ring-engagement-rings-prbre0087
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-PEAR/rose-gold-three-stone-pear-3-8ctw-engagement-rings-lgmtc2319-lg-175-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-PEAR/rose-gold-three-stone-pear-3-8ctw-engagement-rings-lgmtc2319-lg-175-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-AVA-ROUND/luxe-ava-round-engagement-rings-lgmtc2184-lg-125-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LUXE-AVA-ROUND/luxe-ava-round-engagement-rings-lgmtc2184-lg-125-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LUCIELLE-PEAR-3-8/lucielle-pear-3-8ctw-engagement-rings-lgmtc2032-lg-250-pr">
      https://weddingdaydiamonds.com/product-detail/ER-LUCIELLE-PEAR-3-8/lucielle-pear-3-8ctw-engagement-rings-lgmtc2032-lg-250-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ATLAS/petite-atlas-1-3ctw-engagement-rings-lgmtc1809-lg-175-as">
      https://weddingdaydiamonds.com/product-detail/ER-ATLAS/petite-atlas-1-3ctw-engagement-rings-lgmtc1809-lg-175-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ZEPHYRA/zephyra-engagement-rings-lgmtc1957-lg-200-as">
      https://weddingdaydiamonds.com/product-detail/ER-ZEPHYRA/zephyra-engagement-rings-lgmtc1957-lg-200-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-FELICITY-PEAR-&amp;-RNDS/felicity-pear-and-rounds-engagement-rings-lgmtc1985-lg-275-ra">
      https://weddingdaydiamonds.com/product-detail/ER-FELICITY-PEAR-&amp;-RNDS/felicity-pear-and-rounds-engagement-rings-lgmtc1985-lg-275-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TWIST-THREE-STONE/luxe-twist-three-stone-engagement-rings-lgmtc2352-lg-100-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TWIST-THREE-STONE/luxe-twist-three-stone-engagement-rings-lgmtc2352-lg-100-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-REMI-KITE-HIDDEN-SOLITAIRE/remi-kite-hidden-solitaire-engagement-rings-lgmtc1428-lg-225-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-REMI-KITE-HIDDEN-SOLITAIRE/remi-kite-hidden-solitaire-engagement-rings-lgmtc1428-lg-225-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ESME-HIDDEN/esme-hidden-engagement-rings-lgmtc1476-lg-125-as">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ESME-HIDDEN/esme-hidden-engagement-rings-lgmtc1476-lg-125-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-AC-LUXE-HIDDEN-3-8/atia-couture-luxe-hidden-3-8ctw-engagement-rings-lgmtc2269-lg-100-ra">
      https://weddingdaydiamonds.com/product-detail/ER-AC-LUXE-HIDDEN-3-8/atia-couture-luxe-hidden-3-8ctw-engagement-rings-lgmtc2269-lg-100-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-LACE/platinum-luxury-lace-1-2ctw-engagement-rings-lgmtc1723-lg-250-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TC-LACE/platinum-luxury-lace-1-2ctw-engagement-rings-lgmtc1723-lg-250-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-HAZEL-TAPERED/hazel-tapered-4-5ctw-engagement-rings-lgmtc2108-lg-400-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-HAZEL-TAPERED/hazel-tapered-4-5ctw-engagement-rings-lgmtc2108-lg-400-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ANALIA/grand-analia-engagement-rings-lgmtc2203-lg-275-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ANALIA/grand-analia-engagement-rings-lgmtc2203-lg-275-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-JULES-3-4CTW/jules-3-4ctw-engagement-rings-lgmtc2019-lg-300-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-JULES-3-4CTW/jules-3-4ctw-engagement-rings-lgmtc2019-lg-300-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-HEIRESS-HALO/heiress-halo-1-2ctw-engagement-rings-lgmtc1390-lg-400-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TC-HEIRESS-HALO/heiress-halo-1-2ctw-engagement-rings-lgmtc1390-lg-400-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-BG-RD/platinum-classic-baguette-round-3-8ctw-engagement-rings-lgmtc1715-lg-300-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-BG-RD/platinum-classic-baguette-round-3-8ctw-engagement-rings-lgmtc1715-lg-300-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-CYPRESS-HALO/cypress-halo-engagement-rings-lgmtc1443-lg-125-ra">
      https://weddingdaydiamonds.com/product-detail/ER-CYPRESS-HALO/cypress-halo-engagement-rings-lgmtc1443-lg-125-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-CEDAR-HIDDEN/cedar-hidden-engagement-rings-lgmtc2166-lg-100-em">
      https://weddingdaydiamonds.com/product-detail/ER-TC-CEDAR-HIDDEN/cedar-hidden-engagement-rings-lgmtc2166-lg-100-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-REIGN-PEAR-&amp;-MARQUISE/reign-pear-and-marquise-engagement-rings-lgmtc1979-lg-100-mq">
      https://weddingdaydiamonds.com/product-detail/ER-REIGN-PEAR-&amp;-MARQUISE/reign-pear-and-marquise-engagement-rings-lgmtc1979-lg-100-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/EAR-LUXURY-OVAL-DROP-5-3-4CTW/yellow-gold-luxury-oval-drop-5-3-4ctw-earrings-lgyfe0041">
      https://weddingdaydiamonds.com/product-detail/EAR-LUXURY-OVAL-DROP-5-3-4CTW/yellow-gold-luxury-oval-drop-5-3-4ctw-earrings-lgyfe0041
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-NOUVEAU-BEZEL-SOLITAIRE/nouveau-bezel-solitaire-engagement-rings-lgmtc1599-lg-175-rd">
      https://weddingdaydiamonds.com/product-detail/ER-NOUVEAU-BEZEL-SOLITAIRE/nouveau-bezel-solitaire-engagement-rings-lgmtc1599-lg-175-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-DEMI/white-gold-mini-demi-1-10ctw-engagement-rings-lgmtc1745-lg-175-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-DEMI/white-gold-mini-demi-1-10ctw-engagement-rings-lgmtc1745-lg-175-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-VERONA/white-gold-verona-marquise-round-3-8ctw-engagement-rings-lgmtc1773-lg-175-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-VERONA/white-gold-verona-marquise-round-3-8ctw-engagement-rings-lgmtc1773-lg-175-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-DEMI/rose-gold-mini-demi-1-10ctw-engagement-rings-lgmtc1744-lg-125-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-DEMI/rose-gold-mini-demi-1-10ctw-engagement-rings-lgmtc1744-lg-125-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MAE-TWIST/white-gold-mae-twist-2ct-oval-center-engagement-rings-lgmtc2468-lg-200-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TC-MAE-TWIST/white-gold-mae-twist-2ct-oval-center-engagement-rings-lgmtc2468-lg-200-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-EM/yellow-gold-three-stone-emerald-cut-3-8ctw-engagement-rings-lgmtc2313-lg-225-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-EM/yellow-gold-three-stone-emerald-cut-3-8ctw-engagement-rings-lgmtc2313-lg-225-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-DUO-LUMIERE/duo-lumiere-engagement-rings-lgmtc1397-lg-100-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-DUO-LUMIERE/duo-lumiere-engagement-rings-lgmtc1397-lg-100-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/FR-CELINE-BAND-1-2/celine-band-1-2ctw-wedding-bands-lgbtc0314-1">
      https://weddingdaydiamonds.com/product-detail/FR-CELINE-BAND-1-2/celine-band-1-2ctw-wedding-bands-lgbtc0314-1
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-GRACIE-THREE-STONE/gracie-three-stone-engagement-rings-lgmtc2348-lg-225-pr">
      https://weddingdaydiamonds.com/product-detail/ER-GRACIE-THREE-STONE/gracie-three-stone-engagement-rings-lgmtc2348-lg-225-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/WB-LUXE-SP-EM-ETR/platinum-shared-prong-emerald-eternity-7ctw-womens-wedding-bands-lgetr0590">
      https://weddingdaydiamonds.com/product-detail/WB-LUXE-SP-EM-ETR/platinum-shared-prong-emerald-eternity-7ctw-womens-wedding-bands-lgetr0590
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/NK-CROSS/14k-white-gold-lab-grown-diamond-cross-pendant-1-2ctw-lgpcr0039">
      https://weddingdaydiamonds.com/product-detail/NK-CROSS/14k-white-gold-lab-grown-diamond-cross-pendant-1-2ctw-lgpcr0039
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-HELIA-HIDDEN/helia-hidden-engagement-rings-lgmtc2181-lg-175-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-HELIA-HIDDEN/helia-hidden-engagement-rings-lgmtc2181-lg-175-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TULIP-SOLITAIRE/tulip-solitaire-engagement-rings-lgmtc1515-lg-225-em">
      https://weddingdaydiamonds.com/product-detail/ER-TULIP-SOLITAIRE/tulip-solitaire-engagement-rings-lgmtc1515-lg-225-em
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-EAST-WEST-SOL/white-gold-modern-east-west-solitaire-engagement-rings-lgmtc2252-lg-100-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TC-MODERN-EAST-WEST-SOL/white-gold-modern-east-west-solitaire-engagement-rings-lgmtc2252-lg-100-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-SUMMIT/summit-hidden-engagement-rings-lgmtc1494-lg-250-as">
      https://weddingdaydiamonds.com/product-detail/ER-TC-SUMMIT/summit-hidden-engagement-rings-lgmtc1494-lg-250-as
    </a>
  </li>
  <li>
    <a
      href="https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-1-3-8ctw-engagement-rings-
lgmtc2379-lg-275-as"
    >
      https://weddingdaydiamonds.com/product-detail/ER-GRAND-TRINITY/grand-trinity-1-3-8ctw-engagement-rings-lgmtc2379-lg-275-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-HANNAH-HIDDEN-SOLITAIRE/hannah-hidden-solitaire-engagement-rings-lgmtc1405-lg-125-ra">
      https://weddingdaydiamonds.com/product-detail/ER-HANNAH-HIDDEN-SOLITAIRE/hannah-hidden-solitaire-engagement-rings-lgmtc1405-lg-125-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-NESTLE-CATHEDRAL-SOLITAIRE/nestle-cathedral-solitaire-engagement-rings-lgmtc1604-lg-175-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TC-NESTLE-CATHEDRAL-SOLITAIRE/nestle-cathedral-solitaire-engagement-rings-lgmtc1604-lg-175-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-FELICITY-PEAR-&amp;-RNDS/felicity-pear-and-rounds-engagement-rings-lgmtc1984-lg-225-cu">
      https://weddingdaydiamonds.com/product-detail/ER-FELICITY-PEAR-&amp;-RNDS/felicity-pear-and-rounds-engagement-rings-lgmtc1984-lg-225-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-VALENTINA/valentina-1-2ctw-engagement-rings-lgmtc2137-lg-125-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-VALENTINA/valentina-1-2ctw-engagement-rings-lgmtc2137-lg-125-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-HARPER/luxe-harper-engagement-rings-lgmtc2092-lg-225-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-HARPER/luxe-harper-engagement-rings-lgmtc2092-lg-225-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ATLAS/mini-atlas-1-5ctw-engagement-rings-lgmtc1807-lg-150-as">
      https://weddingdaydiamonds.com/product-detail/ER-ATLAS/mini-atlas-1-5ctw-engagement-rings-lgmtc1807-lg-150-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-NUVO-BEZEL/nuvo-bezel-engagement-rings-lgmtc1564-lg-275-mq">
      https://weddingdaydiamonds.com/product-detail/ER-NUVO-BEZEL/nuvo-bezel-engagement-rings-lgmtc1564-lg-275-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-AVALON/avalon-engagement-rings-lgmtc2113-lg-175-mq">
      https://weddingdaydiamonds.com/product-detail/ER-AVALON/avalon-engagement-rings-lgmtc2113-lg-175-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-AVA-EMERALD/ava-emerald-engagement-rings-lgmtc2081-lg-350-ra">
      https://weddingdaydiamonds.com/product-detail/ER-AVA-EMERALD/ava-emerald-engagement-rings-lgmtc2081-lg-350-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-CELINE-1-2/celine-1-2ctw-engagement-rings-lgmtc1883-lg-350-ov">
      https://weddingdaydiamonds.com/product-detail/ER-CELINE-1-2/celine-1-2ctw-engagement-rings-lgmtc1883-lg-350-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-BG-RD/platinum-luxe-baguette-round-3-4ctw-engagement-rings-lgmtc1719-lg-275-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-BG-RD/platinum-luxe-baguette-round-3-4ctw-engagement-rings-lgmtc1719-lg-275-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-RAELYN-HIDDEN/raelyn-hidden-engagement-rings-lgmtc1941-lg-100-pe">
      https://weddingdaydiamonds.com/product-detail/ER-TC-RAELYN-HIDDEN/raelyn-hidden-engagement-rings-lgmtc1941-lg-100-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-CELTIC/celtic-solitaire-engagement-rings-lgmtc1517-lg-175-pr">
      https://weddingdaydiamonds.com/product-detail/ER-CELTIC/celtic-solitaire-engagement-rings-lgmtc1517-lg-175-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-ALINA/alina-5-8ctw-engagement-rings-lgmtc2132-lg-300-cu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-ALINA/alina-5-8ctw-engagement-rings-lgmtc2132-lg-300-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-SOLANA-HIDDEN/solana-hidden-engagement-rings-lgmtc2159-lg-350-ra">
      https://weddingdaydiamonds.com/product-detail/ER-SOLANA-HIDDEN/solana-hidden-engagement-rings-lgmtc2159-lg-350-ra
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-LYRA-CURVED-1-3/lyra-curved-1-3ctw-engagement-rings-lgmtc1894-lg-200-cu">
      https://weddingdaydiamonds.com/product-detail/ER-LYRA-CURVED-1-3/lyra-curved-1-3ctw-engagement-rings-lgmtc1894-lg-200-cu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/EAR-BOLD-HUGGIE/yellow-gold-bold-diamond-huggie-1ctw-earrings-lgehp0018">
      https://weddingdaydiamonds.com/product-detail/EAR-BOLD-HUGGIE/yellow-gold-bold-diamond-huggie-1ctw-earrings-lgehp0018
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-TIARA/tiara-1-5ctw-engagement-rings-lgmtc1615-lg-225-rd">
      https://weddingdaydiamonds.com/product-detail/ER-TC-TIARA/tiara-1-5ctw-engagement-rings-lgmtc1615-lg-225-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-AUTUMN-VINE-SOLITAIRE/autumn-vine-solitaire-engagement-rings-lgmtc1483-lg-250-mq">
      https://weddingdaydiamonds.com/product-detail/ER-TC-AUTUMN-VINE-SOLITAIRE/autumn-vine-solitaire-engagement-rings-lgmtc1483-lg-250-mq
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/FR-TC-U-SPLIT-ETERNITY/platinum-lab-grown-diamond-eternity-comfort-fit-u-split-set-1-2ctw-wedding-bands-lgbtc0417-1">
      https://weddingdaydiamonds.com/product-detail/FR-TC-U-SPLIT-ETERNITY/platinum-lab-grown-diamond-eternity-comfort-fit-u-split-set-1-2ctw-wedding-bands-lgbtc0417-1
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-AC-SUMMIT-HALO-9-10/atia-couture-summit-halo-9-10ctw-engagement-rings-lgmtc1501-lg-250-pe">
      https://weddingdaydiamonds.com/product-detail/ER-AC-SUMMIT-HALO-9-10/atia-couture-summit-halo-9-10ctw-engagement-rings-lgmtc1501-lg-250-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-OV-RD/white-gold-three-stone-oval-rounds-3-4ctw-engagement-rings-lgmtc2328-lg-250-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TC-3ST-OV-RD/white-gold-three-stone-oval-rounds-3-4ctw-engagement-rings-lgmtc2328-lg-250-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-HANNAH-HIDDEN/luxe-hannah-hidden-1-2ctw-engagement-rings-lgmtc1411-lg-400-pe">
      https://weddingdaydiamonds.com/product-detail/ER-HANNAH-HIDDEN/luxe-hannah-hidden-1-2ctw-engagement-rings-lgmtc1411-lg-400-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TWIST-THREE-STONE/luxe-twist-three-stone-engagement-rings-lgmtc2352-lg-275-as">
      https://weddingdaydiamonds.com/product-detail/ER-TWIST-THREE-STONE/luxe-twist-three-stone-engagement-rings-lgmtc2352-lg-275-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-IMANI-PEAR-&amp;-ROUND/imani-pear-and-round-engagement-rings-lgmtc1975-lg-400-pe">
      https://weddingdaydiamonds.com/product-detail/ER-IMANI-PEAR-&amp;-ROUND/imani-pear-and-round-engagement-rings-lgmtc1975-lg-400-pe
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-YVONNE-HIDDEN/yvonne-hidden-engagement-rings-lgmtc2174-lg-125-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-TC-YVONNE-HIDDEN/yvonne-hidden-engagement-rings-lgmtc2174-lg-125-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-EMBRACE-CLASSIC/rose-gold-embrace-1-6-ctw-engagement-rings-lgmtc1664-lg-275-ov">
      https://weddingdaydiamonds.com/product-detail/ER-TC-EMBRACE-CLASSIC/rose-gold-embrace-1-6-ctw-engagement-rings-lgmtc1664-lg-275-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-GRACIE-HIDDEN/gracie-hidden-engagement-rings-lgmtc1932-lg-225-rd">
      https://weddingdaydiamonds.com/product-detail/ER-GRACIE-HIDDEN/gracie-hidden-engagement-rings-lgmtc1932-lg-225-rd
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-ZEPHYRA/zephyra-engagement-rings-lgmtc1958-lg-400-ecu">
      https://weddingdaydiamonds.com/product-detail/ER-ZEPHYRA/zephyra-engagement-rings-lgmtc1958-lg-400-ecu
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-MAEVE/maeve-engagement-rings-lgmtc2028-lg-150-as">
      https://weddingdaydiamonds.com/product-detail/ER-MAEVE/maeve-engagement-rings-lgmtc2028-lg-150-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-SYDNEY-1-1-5/sydney-1-1-5ctw-engagement-rings-lgmtc1929-lg-350-ov">
      https://weddingdaydiamonds.com/product-detail/ER-SYDNEY-1-1-5/sydney-1-1-5ctw-engagement-rings-lgmtc1929-lg-350-ov
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST-HIDDEN-HALO/rose-gold-twist-hidden-halo-3-1-2ct-asscher-center-engagement-rings-lgmtc2455-lg-350-as">
      https://weddingdaydiamonds.com/product-detail/ER-TC-TWIST-HIDDEN-HALO/rose-gold-twist-hidden-halo-3-1-2ct-asscher-center-engagement-rings-lgmtc2455-lg-350-as
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-TIARA/tiara-1-5ctw-engagement-rings-lgmtc1614-lg-400-pr">
      https://weddingdaydiamonds.com/product-detail/ER-TC-TIARA/tiara-1-5ctw-engagement-rings-lgmtc1614-lg-400-pr
    </a>
  </li>
  <li>
    <a href="https://weddingdaydiamonds.com/product-detail/ER-TC-7STONE/white-gold-mini-seven-stone-1-5ctw-engagement-rings-lgmtc1649-lg-100-ra">
      https://weddingdaydiamonds.com/product-detail/ER-TC-7STONE/white-gold-mini-seven-stone-1-5ctw-engagement-rings-lgmtc1649-lg-100-ra
    </a>
  </li>
</ul>;
                     
                  </div>
                  </Container>
    </>
  );
};

export default CustomerService;
